/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const ServiceBaseProto = $root.ServiceBaseProto = (() => {

    /**
     * Namespace ServiceBaseProto.
     * @exports ServiceBaseProto
     * @namespace
     */
    const ServiceBaseProto = {};

    ServiceBaseProto.RequestMsg = (function() {

        /**
         * Properties of a RequestMsg.
         * @memberof ServiceBaseProto
         * @interface IRequestMsg
         * @property {Long} id RequestMsg id
         * @property {number|null} [priority] RequestMsg priority
         * @property {number} versionMajor RequestMsg versionMajor
         * @property {number} versionMinor RequestMsg versionMinor
         * @property {number|null} [versionBuild] RequestMsg versionBuild
         * @property {Uint8Array|null} [sessionToken] RequestMsg sessionToken
         * @property {Long|null} [timeoutMs] RequestMsg timeoutMs
         * @property {IMetaStoreRequestMsg|null} [".MetaStoreRequestMsg.metaStoreRequest"] RequestMsg .MetaStoreRequestMsg.metaStoreRequest
         * @property {ICounterRequestMsg|null} [".CounterRequestMsg.counterRequest"] RequestMsg .CounterRequestMsg.counterRequest
         * @property {IEpochRequestMsg|null} [".EpochRequestMsg.epochRequest"] RequestMsg .EpochRequestMsg.epochRequest
         * @property {ISessionRequestMsg|null} [".SessionRequestMsg.sessionRequest"] RequestMsg .SessionRequestMsg.sessionRequest
         * @property {IStatusRequestMsg|null} [".StatusRequestMsg.statusRequest"] RequestMsg .StatusRequestMsg.statusRequest
         * @property {IKeyRangeLockingRequestMsg|null} [".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] RequestMsg .KeyRangeLockingRequestMsg.keyRangeLockingRequest
         * @property {ISnapshotRequestMsg|null} [".SnapshotRequestMsg.snapshotRequest"] RequestMsg .SnapshotRequestMsg.snapshotRequest
         * @property {ITimeSyncRequestMsg|null} [".TimeSyncRequestMsg.timeSyncRequest"] RequestMsg .TimeSyncRequestMsg.timeSyncRequest
         */

        /**
         * Constructs a new RequestMsg.
         * @memberof ServiceBaseProto
         * @classdesc Represents a RequestMsg.
         * @implements IRequestMsg
         * @constructor
         * @param {ServiceBaseProto.IRequestMsg=} [properties] Properties to set
         */
        function RequestMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestMsg id.
         * @member {Long} id
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RequestMsg priority.
         * @member {number} priority
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.priority = 0;

        /**
         * RequestMsg versionMajor.
         * @member {number} versionMajor
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.versionMajor = 0;

        /**
         * RequestMsg versionMinor.
         * @member {number} versionMinor
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.versionMinor = 0;

        /**
         * RequestMsg versionBuild.
         * @member {number} versionBuild
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.versionBuild = 0;

        /**
         * RequestMsg sessionToken.
         * @member {Uint8Array} sessionToken
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.sessionToken = $util.newBuffer([]);

        /**
         * RequestMsg timeoutMs.
         * @member {Long} timeoutMs
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype.timeoutMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * RequestMsg .MetaStoreRequestMsg.metaStoreRequest.
         * @member {IMetaStoreRequestMsg|null|undefined} .MetaStoreRequestMsg.metaStoreRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".MetaStoreRequestMsg.metaStoreRequest"] = null;

        /**
         * RequestMsg .CounterRequestMsg.counterRequest.
         * @member {ICounterRequestMsg|null|undefined} .CounterRequestMsg.counterRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".CounterRequestMsg.counterRequest"] = null;

        /**
         * RequestMsg .EpochRequestMsg.epochRequest.
         * @member {IEpochRequestMsg|null|undefined} .EpochRequestMsg.epochRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".EpochRequestMsg.epochRequest"] = null;

        /**
         * RequestMsg .SessionRequestMsg.sessionRequest.
         * @member {ISessionRequestMsg|null|undefined} .SessionRequestMsg.sessionRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".SessionRequestMsg.sessionRequest"] = null;

        /**
         * RequestMsg .StatusRequestMsg.statusRequest.
         * @member {IStatusRequestMsg|null|undefined} .StatusRequestMsg.statusRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".StatusRequestMsg.statusRequest"] = null;

        /**
         * RequestMsg .KeyRangeLockingRequestMsg.keyRangeLockingRequest.
         * @member {IKeyRangeLockingRequestMsg|null|undefined} .KeyRangeLockingRequestMsg.keyRangeLockingRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] = null;

        /**
         * RequestMsg .SnapshotRequestMsg.snapshotRequest.
         * @member {ISnapshotRequestMsg|null|undefined} .SnapshotRequestMsg.snapshotRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".SnapshotRequestMsg.snapshotRequest"] = null;

        /**
         * RequestMsg .TimeSyncRequestMsg.timeSyncRequest.
         * @member {ITimeSyncRequestMsg|null|undefined} .TimeSyncRequestMsg.timeSyncRequest
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         */
        RequestMsg.prototype[".TimeSyncRequestMsg.timeSyncRequest"] = null;

        /**
         * Creates a new RequestMsg instance using the specified properties.
         * @function create
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {ServiceBaseProto.IRequestMsg=} [properties] Properties to set
         * @returns {ServiceBaseProto.RequestMsg} RequestMsg instance
         */
        RequestMsg.create = function create(properties) {
            return new RequestMsg(properties);
        };

        /**
         * Encodes the specified RequestMsg message. Does not implicitly {@link ServiceBaseProto.RequestMsg.verify|verify} messages.
         * @function encode
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {ServiceBaseProto.IRequestMsg} message RequestMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 2, wireType 0 =*/16).sint32(message.priority);
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.versionMajor);
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.versionMinor);
            if (message.versionBuild != null && Object.hasOwnProperty.call(message, "versionBuild"))
                writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.versionBuild);
            if (message.sessionToken != null && Object.hasOwnProperty.call(message, "sessionToken"))
                writer.uint32(/* id 6, wireType 2 =*/50).bytes(message.sessionToken);
            if (message.timeoutMs != null && Object.hasOwnProperty.call(message, "timeoutMs"))
                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.timeoutMs);
            if (message[".SnapshotRequestMsg.snapshotRequest"] != null && Object.hasOwnProperty.call(message, ".SnapshotRequestMsg.snapshotRequest"))
                $root.SnapshotRequestMsg.encode(message[".SnapshotRequestMsg.snapshotRequest"], writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
            if (message[".CounterRequestMsg.counterRequest"] != null && Object.hasOwnProperty.call(message, ".CounterRequestMsg.counterRequest"))
                $root.CounterRequestMsg.encode(message[".CounterRequestMsg.counterRequest"], writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
            if (message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] != null && Object.hasOwnProperty.call(message, ".KeyRangeLockingRequestMsg.keyRangeLockingRequest"))
                $root.KeyRangeLockingRequestMsg.encode(message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"], writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
            if (message[".MetaStoreRequestMsg.metaStoreRequest"] != null && Object.hasOwnProperty.call(message, ".MetaStoreRequestMsg.metaStoreRequest"))
                $root.MetaStoreRequestMsg.encode(message[".MetaStoreRequestMsg.metaStoreRequest"], writer.uint32(/* id 201, wireType 2 =*/1610).fork()).ldelim();
            if (message[".SessionRequestMsg.sessionRequest"] != null && Object.hasOwnProperty.call(message, ".SessionRequestMsg.sessionRequest"))
                $root.SessionRequestMsg.encode(message[".SessionRequestMsg.sessionRequest"], writer.uint32(/* id 202, wireType 2 =*/1618).fork()).ldelim();
            if (message[".EpochRequestMsg.epochRequest"] != null && Object.hasOwnProperty.call(message, ".EpochRequestMsg.epochRequest"))
                $root.EpochRequestMsg.encode(message[".EpochRequestMsg.epochRequest"], writer.uint32(/* id 204, wireType 2 =*/1634).fork()).ldelim();
            if (message[".StatusRequestMsg.statusRequest"] != null && Object.hasOwnProperty.call(message, ".StatusRequestMsg.statusRequest"))
                $root.StatusRequestMsg.encode(message[".StatusRequestMsg.statusRequest"], writer.uint32(/* id 206, wireType 2 =*/1650).fork()).ldelim();
            if (message[".TimeSyncRequestMsg.timeSyncRequest"] != null && Object.hasOwnProperty.call(message, ".TimeSyncRequestMsg.timeSyncRequest"))
                $root.TimeSyncRequestMsg.encode(message[".TimeSyncRequestMsg.timeSyncRequest"], writer.uint32(/* id 207, wireType 2 =*/1658).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a RequestMsg message from the specified reader or buffer.
         * @function decode
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ServiceBaseProto.RequestMsg} RequestMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestMsg.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServiceBaseProto.RequestMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.int64();
                        break;
                    }
                case 2: {
                        message.priority = reader.sint32();
                        break;
                    }
                case 3: {
                        message.versionMajor = reader.uint32();
                        break;
                    }
                case 4: {
                        message.versionMinor = reader.uint32();
                        break;
                    }
                case 5: {
                        message.versionBuild = reader.uint32();
                        break;
                    }
                case 6: {
                        message.sessionToken = reader.bytes();
                        break;
                    }
                case 7: {
                        message.timeoutMs = reader.int64();
                        break;
                    }
                case 201: {
                        message[".MetaStoreRequestMsg.metaStoreRequest"] = $root.MetaStoreRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 103: {
                        message[".CounterRequestMsg.counterRequest"] = $root.CounterRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 204: {
                        message[".EpochRequestMsg.epochRequest"] = $root.EpochRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 202: {
                        message[".SessionRequestMsg.sessionRequest"] = $root.SessionRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 206: {
                        message[".StatusRequestMsg.statusRequest"] = $root.StatusRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 106: {
                        message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] = $root.KeyRangeLockingRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 102: {
                        message[".SnapshotRequestMsg.snapshotRequest"] = $root.SnapshotRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 207: {
                        message[".TimeSyncRequestMsg.timeSyncRequest"] = $root.TimeSyncRequestMsg.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("id"))
                throw $util.ProtocolError("missing required 'id'", { instance: message });
            if (!message.hasOwnProperty("versionMajor"))
                throw $util.ProtocolError("missing required 'versionMajor'", { instance: message });
            if (!message.hasOwnProperty("versionMinor"))
                throw $util.ProtocolError("missing required 'versionMinor'", { instance: message });
            return message;
        };

        /**
         * Creates a RequestMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ServiceBaseProto.RequestMsg} RequestMsg
         */
        RequestMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.ServiceBaseProto.RequestMsg)
                return object;
            let message = new $root.ServiceBaseProto.RequestMsg();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.priority != null)
                message.priority = object.priority | 0;
            if (object.versionMajor != null)
                message.versionMajor = object.versionMajor >>> 0;
            if (object.versionMinor != null)
                message.versionMinor = object.versionMinor >>> 0;
            if (object.versionBuild != null)
                message.versionBuild = object.versionBuild >>> 0;
            if (object.sessionToken != null)
                if (typeof object.sessionToken === "string")
                    $util.base64.decode(object.sessionToken, message.sessionToken = $util.newBuffer($util.base64.length(object.sessionToken)), 0);
                else if (object.sessionToken.length >= 0)
                    message.sessionToken = object.sessionToken;
            if (object.timeoutMs != null)
                if ($util.Long)
                    (message.timeoutMs = $util.Long.fromValue(object.timeoutMs)).unsigned = false;
                else if (typeof object.timeoutMs === "string")
                    message.timeoutMs = parseInt(object.timeoutMs, 10);
                else if (typeof object.timeoutMs === "number")
                    message.timeoutMs = object.timeoutMs;
                else if (typeof object.timeoutMs === "object")
                    message.timeoutMs = new $util.LongBits(object.timeoutMs.low >>> 0, object.timeoutMs.high >>> 0).toNumber();
            if (object[".MetaStoreRequestMsg.metaStoreRequest"] != null) {
                if (typeof object[".MetaStoreRequestMsg.metaStoreRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..MetaStoreRequestMsg.metaStoreRequest: object expected");
                message[".MetaStoreRequestMsg.metaStoreRequest"] = $root.MetaStoreRequestMsg.fromObject(object[".MetaStoreRequestMsg.metaStoreRequest"]);
            }
            if (object[".CounterRequestMsg.counterRequest"] != null) {
                if (typeof object[".CounterRequestMsg.counterRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..CounterRequestMsg.counterRequest: object expected");
                message[".CounterRequestMsg.counterRequest"] = $root.CounterRequestMsg.fromObject(object[".CounterRequestMsg.counterRequest"]);
            }
            if (object[".EpochRequestMsg.epochRequest"] != null) {
                if (typeof object[".EpochRequestMsg.epochRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..EpochRequestMsg.epochRequest: object expected");
                message[".EpochRequestMsg.epochRequest"] = $root.EpochRequestMsg.fromObject(object[".EpochRequestMsg.epochRequest"]);
            }
            if (object[".SessionRequestMsg.sessionRequest"] != null) {
                if (typeof object[".SessionRequestMsg.sessionRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..SessionRequestMsg.sessionRequest: object expected");
                message[".SessionRequestMsg.sessionRequest"] = $root.SessionRequestMsg.fromObject(object[".SessionRequestMsg.sessionRequest"]);
            }
            if (object[".StatusRequestMsg.statusRequest"] != null) {
                if (typeof object[".StatusRequestMsg.statusRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..StatusRequestMsg.statusRequest: object expected");
                message[".StatusRequestMsg.statusRequest"] = $root.StatusRequestMsg.fromObject(object[".StatusRequestMsg.statusRequest"]);
            }
            if (object[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] != null) {
                if (typeof object[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..KeyRangeLockingRequestMsg.keyRangeLockingRequest: object expected");
                message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] = $root.KeyRangeLockingRequestMsg.fromObject(object[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"]);
            }
            if (object[".SnapshotRequestMsg.snapshotRequest"] != null) {
                if (typeof object[".SnapshotRequestMsg.snapshotRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..SnapshotRequestMsg.snapshotRequest: object expected");
                message[".SnapshotRequestMsg.snapshotRequest"] = $root.SnapshotRequestMsg.fromObject(object[".SnapshotRequestMsg.snapshotRequest"]);
            }
            if (object[".TimeSyncRequestMsg.timeSyncRequest"] != null) {
                if (typeof object[".TimeSyncRequestMsg.timeSyncRequest"] !== "object")
                    throw TypeError(".ServiceBaseProto.RequestMsg..TimeSyncRequestMsg.timeSyncRequest: object expected");
                message[".TimeSyncRequestMsg.timeSyncRequest"] = $root.TimeSyncRequestMsg.fromObject(object[".TimeSyncRequestMsg.timeSyncRequest"]);
            }
            return message;
        };

        /**
         * Creates a plain object from a RequestMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {ServiceBaseProto.RequestMsg} message RequestMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.priority = 0;
                object.versionMajor = 0;
                object.versionMinor = 0;
                object.versionBuild = 0;
                if (options.bytes === String)
                    object.sessionToken = "";
                else {
                    object.sessionToken = [];
                    if (options.bytes !== Array)
                        object.sessionToken = $util.newBuffer(object.sessionToken);
                }
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.timeoutMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.timeoutMs = options.longs === String ? "0" : 0;
                object[".SnapshotRequestMsg.snapshotRequest"] = null;
                object[".CounterRequestMsg.counterRequest"] = null;
                object[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] = null;
                object[".MetaStoreRequestMsg.metaStoreRequest"] = null;
                object[".SessionRequestMsg.sessionRequest"] = null;
                object[".EpochRequestMsg.epochRequest"] = null;
                object[".StatusRequestMsg.statusRequest"] = null;
                object[".TimeSyncRequestMsg.timeSyncRequest"] = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.versionMajor != null && message.hasOwnProperty("versionMajor"))
                object.versionMajor = message.versionMajor;
            if (message.versionMinor != null && message.hasOwnProperty("versionMinor"))
                object.versionMinor = message.versionMinor;
            if (message.versionBuild != null && message.hasOwnProperty("versionBuild"))
                object.versionBuild = message.versionBuild;
            if (message.sessionToken != null && message.hasOwnProperty("sessionToken"))
                object.sessionToken = options.bytes === String ? $util.base64.encode(message.sessionToken, 0, message.sessionToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.sessionToken) : message.sessionToken;
            if (message.timeoutMs != null && message.hasOwnProperty("timeoutMs"))
                if (typeof message.timeoutMs === "number")
                    object.timeoutMs = options.longs === String ? String(message.timeoutMs) : message.timeoutMs;
                else
                    object.timeoutMs = options.longs === String ? $util.Long.prototype.toString.call(message.timeoutMs) : options.longs === Number ? new $util.LongBits(message.timeoutMs.low >>> 0, message.timeoutMs.high >>> 0).toNumber() : message.timeoutMs;
            if (message[".SnapshotRequestMsg.snapshotRequest"] != null && message.hasOwnProperty(".SnapshotRequestMsg.snapshotRequest"))
                object[".SnapshotRequestMsg.snapshotRequest"] = $root.SnapshotRequestMsg.toObject(message[".SnapshotRequestMsg.snapshotRequest"], options);
            if (message[".CounterRequestMsg.counterRequest"] != null && message.hasOwnProperty(".CounterRequestMsg.counterRequest"))
                object[".CounterRequestMsg.counterRequest"] = $root.CounterRequestMsg.toObject(message[".CounterRequestMsg.counterRequest"], options);
            if (message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] != null && message.hasOwnProperty(".KeyRangeLockingRequestMsg.keyRangeLockingRequest"))
                object[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"] = $root.KeyRangeLockingRequestMsg.toObject(message[".KeyRangeLockingRequestMsg.keyRangeLockingRequest"], options);
            if (message[".MetaStoreRequestMsg.metaStoreRequest"] != null && message.hasOwnProperty(".MetaStoreRequestMsg.metaStoreRequest"))
                object[".MetaStoreRequestMsg.metaStoreRequest"] = $root.MetaStoreRequestMsg.toObject(message[".MetaStoreRequestMsg.metaStoreRequest"], options);
            if (message[".SessionRequestMsg.sessionRequest"] != null && message.hasOwnProperty(".SessionRequestMsg.sessionRequest"))
                object[".SessionRequestMsg.sessionRequest"] = $root.SessionRequestMsg.toObject(message[".SessionRequestMsg.sessionRequest"], options);
            if (message[".EpochRequestMsg.epochRequest"] != null && message.hasOwnProperty(".EpochRequestMsg.epochRequest"))
                object[".EpochRequestMsg.epochRequest"] = $root.EpochRequestMsg.toObject(message[".EpochRequestMsg.epochRequest"], options);
            if (message[".StatusRequestMsg.statusRequest"] != null && message.hasOwnProperty(".StatusRequestMsg.statusRequest"))
                object[".StatusRequestMsg.statusRequest"] = $root.StatusRequestMsg.toObject(message[".StatusRequestMsg.statusRequest"], options);
            if (message[".TimeSyncRequestMsg.timeSyncRequest"] != null && message.hasOwnProperty(".TimeSyncRequestMsg.timeSyncRequest"))
                object[".TimeSyncRequestMsg.timeSyncRequest"] = $root.TimeSyncRequestMsg.toObject(message[".TimeSyncRequestMsg.timeSyncRequest"], options);
            return object;
        };

        /**
         * Converts this RequestMsg to JSON.
         * @function toJSON
         * @memberof ServiceBaseProto.RequestMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RequestMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for RequestMsg
         * @function getTypeUrl
         * @memberof ServiceBaseProto.RequestMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        RequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ServiceBaseProto.RequestMsg";
        };

        return RequestMsg;
    })();

    ServiceBaseProto.ResponseError = (function() {

        /**
         * Properties of a ResponseError.
         * @memberof ServiceBaseProto
         * @interface IResponseError
         * @property {ServiceBaseProto.ResponseError.ErrorCode} code ResponseError code
         * @property {string|null} [details] ResponseError details
         * @property {IConflictErrorResponseMsg|null} [".ConflictErrorResponseMsg.conflictErrorResponse"] ResponseError .ConflictErrorResponseMsg.conflictErrorResponse
         * @property {ICheckConstraintErrorResponseMsg|null} [".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] ResponseError .CheckConstraintErrorResponseMsg.checkConstraintErrorResponse
         */

        /**
         * Constructs a new ResponseError.
         * @memberof ServiceBaseProto
         * @classdesc Represents a ResponseError.
         * @implements IResponseError
         * @constructor
         * @param {ServiceBaseProto.IResponseError=} [properties] Properties to set
         */
        function ResponseError(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseError code.
         * @member {ServiceBaseProto.ResponseError.ErrorCode} code
         * @memberof ServiceBaseProto.ResponseError
         * @instance
         */
        ResponseError.prototype.code = 0;

        /**
         * ResponseError details.
         * @member {string} details
         * @memberof ServiceBaseProto.ResponseError
         * @instance
         */
        ResponseError.prototype.details = "";

        /**
         * ResponseError .ConflictErrorResponseMsg.conflictErrorResponse.
         * @member {IConflictErrorResponseMsg|null|undefined} .ConflictErrorResponseMsg.conflictErrorResponse
         * @memberof ServiceBaseProto.ResponseError
         * @instance
         */
        ResponseError.prototype[".ConflictErrorResponseMsg.conflictErrorResponse"] = null;

        /**
         * ResponseError .CheckConstraintErrorResponseMsg.checkConstraintErrorResponse.
         * @member {ICheckConstraintErrorResponseMsg|null|undefined} .CheckConstraintErrorResponseMsg.checkConstraintErrorResponse
         * @memberof ServiceBaseProto.ResponseError
         * @instance
         */
        ResponseError.prototype[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] = null;

        /**
         * Creates a new ResponseError instance using the specified properties.
         * @function create
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {ServiceBaseProto.IResponseError=} [properties] Properties to set
         * @returns {ServiceBaseProto.ResponseError} ResponseError instance
         */
        ResponseError.create = function create(properties) {
            return new ResponseError(properties);
        };

        /**
         * Encodes the specified ResponseError message. Does not implicitly {@link ServiceBaseProto.ResponseError.verify|verify} messages.
         * @function encode
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {ServiceBaseProto.IResponseError} message ResponseError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseError.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.code);
            if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.details);
            if (message[".ConflictErrorResponseMsg.conflictErrorResponse"] != null && Object.hasOwnProperty.call(message, ".ConflictErrorResponseMsg.conflictErrorResponse"))
                $root.ConflictErrorResponseMsg.encode(message[".ConflictErrorResponseMsg.conflictErrorResponse"], writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
            if (message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] != null && Object.hasOwnProperty.call(message, ".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"))
                $root.CheckConstraintErrorResponseMsg.encode(message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"], writer.uint32(/* id 101, wireType 2 =*/810).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a ResponseError message from the specified reader or buffer.
         * @function decode
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ServiceBaseProto.ResponseError} ResponseError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseError.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServiceBaseProto.ResponseError();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.code = reader.int32();
                        break;
                    }
                case 2: {
                        message.details = reader.string();
                        break;
                    }
                case 100: {
                        message[".ConflictErrorResponseMsg.conflictErrorResponse"] = $root.ConflictErrorResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 101: {
                        message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] = $root.CheckConstraintErrorResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("code"))
                throw $util.ProtocolError("missing required 'code'", { instance: message });
            return message;
        };

        /**
         * Creates a ResponseError message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ServiceBaseProto.ResponseError} ResponseError
         */
        ResponseError.fromObject = function fromObject(object) {
            if (object instanceof $root.ServiceBaseProto.ResponseError)
                return object;
            let message = new $root.ServiceBaseProto.ResponseError();
            switch (object.code) {
            default:
                if (typeof object.code === "number") {
                    message.code = object.code;
                    break;
                }
                break;
            case "UNKNOWN":
            case 0:
                message.code = 0;
                break;
            case "INTERNAL_ERROR":
            case 1:
                message.code = 1;
                break;
            case "IO_ERROR":
            case 2:
                message.code = 2;
                break;
            case "INVALID_KEY":
            case 3:
                message.code = 3;
                break;
            case "INVALID_ARGUMENT":
            case 4:
                message.code = 4;
                break;
            case "INVALID_STATE":
            case 5:
                message.code = 5;
                break;
            case "UNAUTHORIZED":
            case 6:
                message.code = 6;
                break;
            case "EPOCH_ERROR":
            case 7:
                message.code = 7;
                break;
            case "TERMINATE_CLIENT":
            case 8:
                message.code = 8;
                break;
            case "SUCCESS":
            case 1000:
                message.code = 1000;
                break;
            }
            if (object.details != null)
                message.details = String(object.details);
            if (object[".ConflictErrorResponseMsg.conflictErrorResponse"] != null) {
                if (typeof object[".ConflictErrorResponseMsg.conflictErrorResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseError..ConflictErrorResponseMsg.conflictErrorResponse: object expected");
                message[".ConflictErrorResponseMsg.conflictErrorResponse"] = $root.ConflictErrorResponseMsg.fromObject(object[".ConflictErrorResponseMsg.conflictErrorResponse"]);
            }
            if (object[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] != null) {
                if (typeof object[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseError..CheckConstraintErrorResponseMsg.checkConstraintErrorResponse: object expected");
                message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] = $root.CheckConstraintErrorResponseMsg.fromObject(object[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseError message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {ServiceBaseProto.ResponseError} message ResponseError
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseError.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.code = options.enums === String ? "UNKNOWN" : 0;
                object.details = "";
                object[".ConflictErrorResponseMsg.conflictErrorResponse"] = null;
                object[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] = null;
            }
            if (message.code != null && message.hasOwnProperty("code"))
                object.code = options.enums === String ? $root.ServiceBaseProto.ResponseError.ErrorCode[message.code] === undefined ? message.code : $root.ServiceBaseProto.ResponseError.ErrorCode[message.code] : message.code;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = message.details;
            if (message[".ConflictErrorResponseMsg.conflictErrorResponse"] != null && message.hasOwnProperty(".ConflictErrorResponseMsg.conflictErrorResponse"))
                object[".ConflictErrorResponseMsg.conflictErrorResponse"] = $root.ConflictErrorResponseMsg.toObject(message[".ConflictErrorResponseMsg.conflictErrorResponse"], options);
            if (message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] != null && message.hasOwnProperty(".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"))
                object[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"] = $root.CheckConstraintErrorResponseMsg.toObject(message[".CheckConstraintErrorResponseMsg.checkConstraintErrorResponse"], options);
            return object;
        };

        /**
         * Converts this ResponseError to JSON.
         * @function toJSON
         * @memberof ServiceBaseProto.ResponseError
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseError.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResponseError
         * @function getTypeUrl
         * @memberof ServiceBaseProto.ResponseError
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResponseError.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ServiceBaseProto.ResponseError";
        };

        /**
         * ErrorCode enum.
         * @name ServiceBaseProto.ResponseError.ErrorCode
         * @enum {number}
         * @property {number} UNKNOWN=0 UNKNOWN value
         * @property {number} INTERNAL_ERROR=1 INTERNAL_ERROR value
         * @property {number} IO_ERROR=2 IO_ERROR value
         * @property {number} INVALID_KEY=3 INVALID_KEY value
         * @property {number} INVALID_ARGUMENT=4 INVALID_ARGUMENT value
         * @property {number} INVALID_STATE=5 INVALID_STATE value
         * @property {number} UNAUTHORIZED=6 UNAUTHORIZED value
         * @property {number} EPOCH_ERROR=7 EPOCH_ERROR value
         * @property {number} TERMINATE_CLIENT=8 TERMINATE_CLIENT value
         * @property {number} SUCCESS=1000 SUCCESS value
         */
        ResponseError.ErrorCode = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN"] = 0;
            values[valuesById[1] = "INTERNAL_ERROR"] = 1;
            values[valuesById[2] = "IO_ERROR"] = 2;
            values[valuesById[3] = "INVALID_KEY"] = 3;
            values[valuesById[4] = "INVALID_ARGUMENT"] = 4;
            values[valuesById[5] = "INVALID_STATE"] = 5;
            values[valuesById[6] = "UNAUTHORIZED"] = 6;
            values[valuesById[7] = "EPOCH_ERROR"] = 7;
            values[valuesById[8] = "TERMINATE_CLIENT"] = 8;
            values[valuesById[1000] = "SUCCESS"] = 1000;
            return values;
        })();

        return ResponseError;
    })();

    ServiceBaseProto.ResponseMsg = (function() {

        /**
         * Properties of a ResponseMsg.
         * @memberof ServiceBaseProto
         * @interface IResponseMsg
         * @property {Long} id ResponseMsg id
         * @property {ServiceBaseProto.IResponseError} error ResponseMsg error
         * @property {number|null} [priority] ResponseMsg priority
         * @property {number} versionMajor ResponseMsg versionMajor
         * @property {number} versionMinor ResponseMsg versionMinor
         * @property {number|null} [versionBuild] ResponseMsg versionBuild
         * @property {IMetaStoreResponseMsg|null} [".MetaStoreResponseMsg.keyStoreResponse"] ResponseMsg .MetaStoreResponseMsg.keyStoreResponse
         * @property {ICounterResponseMsg|null} [".CounterResponseMsg.counterResponse"] ResponseMsg .CounterResponseMsg.counterResponse
         * @property {IEpochResponseMsg|null} [".EpochResponseMsg.epochResponse"] ResponseMsg .EpochResponseMsg.epochResponse
         * @property {ISessionResponseMsg|null} [".SessionResponseMsg.sessionResponse"] ResponseMsg .SessionResponseMsg.sessionResponse
         * @property {IStatusResponseMsg|null} [".StatusResponseMsg.statusResponse"] ResponseMsg .StatusResponseMsg.statusResponse
         * @property {IKeyRangeLockingResponseMsg|null} [".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] ResponseMsg .KeyRangeLockingResponseMsg.keyRangeLockingResponse
         * @property {ISnapshotResponseMsg|null} [".SnapshotResponseMsg.snapshotResponse"] ResponseMsg .SnapshotResponseMsg.snapshotResponse
         * @property {ITimeSyncResponseMsg|null} [".TimeSyncResponseMsg.timeSyncResponse"] ResponseMsg .TimeSyncResponseMsg.timeSyncResponse
         */

        /**
         * Constructs a new ResponseMsg.
         * @memberof ServiceBaseProto
         * @classdesc Represents a ResponseMsg.
         * @implements IResponseMsg
         * @constructor
         * @param {ServiceBaseProto.IResponseMsg=} [properties] Properties to set
         */
        function ResponseMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseMsg id.
         * @member {Long} id
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * ResponseMsg error.
         * @member {ServiceBaseProto.IResponseError} error
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.error = null;

        /**
         * ResponseMsg priority.
         * @member {number} priority
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.priority = 0;

        /**
         * ResponseMsg versionMajor.
         * @member {number} versionMajor
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.versionMajor = 0;

        /**
         * ResponseMsg versionMinor.
         * @member {number} versionMinor
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.versionMinor = 0;

        /**
         * ResponseMsg versionBuild.
         * @member {number} versionBuild
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype.versionBuild = 0;

        /**
         * ResponseMsg .MetaStoreResponseMsg.keyStoreResponse.
         * @member {IMetaStoreResponseMsg|null|undefined} .MetaStoreResponseMsg.keyStoreResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".MetaStoreResponseMsg.keyStoreResponse"] = null;

        /**
         * ResponseMsg .CounterResponseMsg.counterResponse.
         * @member {ICounterResponseMsg|null|undefined} .CounterResponseMsg.counterResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".CounterResponseMsg.counterResponse"] = null;

        /**
         * ResponseMsg .EpochResponseMsg.epochResponse.
         * @member {IEpochResponseMsg|null|undefined} .EpochResponseMsg.epochResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".EpochResponseMsg.epochResponse"] = null;

        /**
         * ResponseMsg .SessionResponseMsg.sessionResponse.
         * @member {ISessionResponseMsg|null|undefined} .SessionResponseMsg.sessionResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".SessionResponseMsg.sessionResponse"] = null;

        /**
         * ResponseMsg .StatusResponseMsg.statusResponse.
         * @member {IStatusResponseMsg|null|undefined} .StatusResponseMsg.statusResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".StatusResponseMsg.statusResponse"] = null;

        /**
         * ResponseMsg .KeyRangeLockingResponseMsg.keyRangeLockingResponse.
         * @member {IKeyRangeLockingResponseMsg|null|undefined} .KeyRangeLockingResponseMsg.keyRangeLockingResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] = null;

        /**
         * ResponseMsg .SnapshotResponseMsg.snapshotResponse.
         * @member {ISnapshotResponseMsg|null|undefined} .SnapshotResponseMsg.snapshotResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".SnapshotResponseMsg.snapshotResponse"] = null;

        /**
         * ResponseMsg .TimeSyncResponseMsg.timeSyncResponse.
         * @member {ITimeSyncResponseMsg|null|undefined} .TimeSyncResponseMsg.timeSyncResponse
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         */
        ResponseMsg.prototype[".TimeSyncResponseMsg.timeSyncResponse"] = null;

        /**
         * Creates a new ResponseMsg instance using the specified properties.
         * @function create
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {ServiceBaseProto.IResponseMsg=} [properties] Properties to set
         * @returns {ServiceBaseProto.ResponseMsg} ResponseMsg instance
         */
        ResponseMsg.create = function create(properties) {
            return new ResponseMsg(properties);
        };

        /**
         * Encodes the specified ResponseMsg message. Does not implicitly {@link ServiceBaseProto.ResponseMsg.verify|verify} messages.
         * @function encode
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {ServiceBaseProto.IResponseMsg} message ResponseMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
            $root.ServiceBaseProto.ResponseError.encode(message.error, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                writer.uint32(/* id 3, wireType 0 =*/24).sint32(message.priority);
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.versionMajor);
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.versionMinor);
            if (message.versionBuild != null && Object.hasOwnProperty.call(message, "versionBuild"))
                writer.uint32(/* id 6, wireType 0 =*/48).uint32(message.versionBuild);
            if (message[".SnapshotResponseMsg.snapshotResponse"] != null && Object.hasOwnProperty.call(message, ".SnapshotResponseMsg.snapshotResponse"))
                $root.SnapshotResponseMsg.encode(message[".SnapshotResponseMsg.snapshotResponse"], writer.uint32(/* id 102, wireType 2 =*/818).fork()).ldelim();
            if (message[".CounterResponseMsg.counterResponse"] != null && Object.hasOwnProperty.call(message, ".CounterResponseMsg.counterResponse"))
                $root.CounterResponseMsg.encode(message[".CounterResponseMsg.counterResponse"], writer.uint32(/* id 103, wireType 2 =*/826).fork()).ldelim();
            if (message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] != null && Object.hasOwnProperty.call(message, ".KeyRangeLockingResponseMsg.keyRangeLockingResponse"))
                $root.KeyRangeLockingResponseMsg.encode(message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"], writer.uint32(/* id 106, wireType 2 =*/850).fork()).ldelim();
            if (message[".MetaStoreResponseMsg.keyStoreResponse"] != null && Object.hasOwnProperty.call(message, ".MetaStoreResponseMsg.keyStoreResponse"))
                $root.MetaStoreResponseMsg.encode(message[".MetaStoreResponseMsg.keyStoreResponse"], writer.uint32(/* id 201, wireType 2 =*/1610).fork()).ldelim();
            if (message[".SessionResponseMsg.sessionResponse"] != null && Object.hasOwnProperty.call(message, ".SessionResponseMsg.sessionResponse"))
                $root.SessionResponseMsg.encode(message[".SessionResponseMsg.sessionResponse"], writer.uint32(/* id 202, wireType 2 =*/1618).fork()).ldelim();
            if (message[".EpochResponseMsg.epochResponse"] != null && Object.hasOwnProperty.call(message, ".EpochResponseMsg.epochResponse"))
                $root.EpochResponseMsg.encode(message[".EpochResponseMsg.epochResponse"], writer.uint32(/* id 204, wireType 2 =*/1634).fork()).ldelim();
            if (message[".StatusResponseMsg.statusResponse"] != null && Object.hasOwnProperty.call(message, ".StatusResponseMsg.statusResponse"))
                $root.StatusResponseMsg.encode(message[".StatusResponseMsg.statusResponse"], writer.uint32(/* id 206, wireType 2 =*/1650).fork()).ldelim();
            if (message[".TimeSyncResponseMsg.timeSyncResponse"] != null && Object.hasOwnProperty.call(message, ".TimeSyncResponseMsg.timeSyncResponse"))
                $root.TimeSyncResponseMsg.encode(message[".TimeSyncResponseMsg.timeSyncResponse"], writer.uint32(/* id 207, wireType 2 =*/1658).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a ResponseMsg message from the specified reader or buffer.
         * @function decode
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ServiceBaseProto.ResponseMsg} ResponseMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseMsg.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServiceBaseProto.ResponseMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.id = reader.int64();
                        break;
                    }
                case 2: {
                        message.error = $root.ServiceBaseProto.ResponseError.decode(reader, reader.uint32());
                        break;
                    }
                case 3: {
                        message.priority = reader.sint32();
                        break;
                    }
                case 4: {
                        message.versionMajor = reader.uint32();
                        break;
                    }
                case 5: {
                        message.versionMinor = reader.uint32();
                        break;
                    }
                case 6: {
                        message.versionBuild = reader.uint32();
                        break;
                    }
                case 201: {
                        message[".MetaStoreResponseMsg.keyStoreResponse"] = $root.MetaStoreResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 103: {
                        message[".CounterResponseMsg.counterResponse"] = $root.CounterResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 204: {
                        message[".EpochResponseMsg.epochResponse"] = $root.EpochResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 202: {
                        message[".SessionResponseMsg.sessionResponse"] = $root.SessionResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 206: {
                        message[".StatusResponseMsg.statusResponse"] = $root.StatusResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 106: {
                        message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] = $root.KeyRangeLockingResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 102: {
                        message[".SnapshotResponseMsg.snapshotResponse"] = $root.SnapshotResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                case 207: {
                        message[".TimeSyncResponseMsg.timeSyncResponse"] = $root.TimeSyncResponseMsg.decode(reader, reader.uint32());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("id"))
                throw $util.ProtocolError("missing required 'id'", { instance: message });
            if (!message.hasOwnProperty("error"))
                throw $util.ProtocolError("missing required 'error'", { instance: message });
            if (!message.hasOwnProperty("versionMajor"))
                throw $util.ProtocolError("missing required 'versionMajor'", { instance: message });
            if (!message.hasOwnProperty("versionMinor"))
                throw $util.ProtocolError("missing required 'versionMinor'", { instance: message });
            return message;
        };

        /**
         * Creates a ResponseMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ServiceBaseProto.ResponseMsg} ResponseMsg
         */
        ResponseMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.ServiceBaseProto.ResponseMsg)
                return object;
            let message = new $root.ServiceBaseProto.ResponseMsg();
            if (object.id != null)
                if ($util.Long)
                    (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                else if (typeof object.id === "string")
                    message.id = parseInt(object.id, 10);
                else if (typeof object.id === "number")
                    message.id = object.id;
                else if (typeof object.id === "object")
                    message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
            if (object.error != null) {
                if (typeof object.error !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg.error: object expected");
                message.error = $root.ServiceBaseProto.ResponseError.fromObject(object.error);
            }
            if (object.priority != null)
                message.priority = object.priority | 0;
            if (object.versionMajor != null)
                message.versionMajor = object.versionMajor >>> 0;
            if (object.versionMinor != null)
                message.versionMinor = object.versionMinor >>> 0;
            if (object.versionBuild != null)
                message.versionBuild = object.versionBuild >>> 0;
            if (object[".MetaStoreResponseMsg.keyStoreResponse"] != null) {
                if (typeof object[".MetaStoreResponseMsg.keyStoreResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..MetaStoreResponseMsg.keyStoreResponse: object expected");
                message[".MetaStoreResponseMsg.keyStoreResponse"] = $root.MetaStoreResponseMsg.fromObject(object[".MetaStoreResponseMsg.keyStoreResponse"]);
            }
            if (object[".CounterResponseMsg.counterResponse"] != null) {
                if (typeof object[".CounterResponseMsg.counterResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..CounterResponseMsg.counterResponse: object expected");
                message[".CounterResponseMsg.counterResponse"] = $root.CounterResponseMsg.fromObject(object[".CounterResponseMsg.counterResponse"]);
            }
            if (object[".EpochResponseMsg.epochResponse"] != null) {
                if (typeof object[".EpochResponseMsg.epochResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..EpochResponseMsg.epochResponse: object expected");
                message[".EpochResponseMsg.epochResponse"] = $root.EpochResponseMsg.fromObject(object[".EpochResponseMsg.epochResponse"]);
            }
            if (object[".SessionResponseMsg.sessionResponse"] != null) {
                if (typeof object[".SessionResponseMsg.sessionResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..SessionResponseMsg.sessionResponse: object expected");
                message[".SessionResponseMsg.sessionResponse"] = $root.SessionResponseMsg.fromObject(object[".SessionResponseMsg.sessionResponse"]);
            }
            if (object[".StatusResponseMsg.statusResponse"] != null) {
                if (typeof object[".StatusResponseMsg.statusResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..StatusResponseMsg.statusResponse: object expected");
                message[".StatusResponseMsg.statusResponse"] = $root.StatusResponseMsg.fromObject(object[".StatusResponseMsg.statusResponse"]);
            }
            if (object[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] != null) {
                if (typeof object[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..KeyRangeLockingResponseMsg.keyRangeLockingResponse: object expected");
                message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] = $root.KeyRangeLockingResponseMsg.fromObject(object[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"]);
            }
            if (object[".SnapshotResponseMsg.snapshotResponse"] != null) {
                if (typeof object[".SnapshotResponseMsg.snapshotResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..SnapshotResponseMsg.snapshotResponse: object expected");
                message[".SnapshotResponseMsg.snapshotResponse"] = $root.SnapshotResponseMsg.fromObject(object[".SnapshotResponseMsg.snapshotResponse"]);
            }
            if (object[".TimeSyncResponseMsg.timeSyncResponse"] != null) {
                if (typeof object[".TimeSyncResponseMsg.timeSyncResponse"] !== "object")
                    throw TypeError(".ServiceBaseProto.ResponseMsg..TimeSyncResponseMsg.timeSyncResponse: object expected");
                message[".TimeSyncResponseMsg.timeSyncResponse"] = $root.TimeSyncResponseMsg.fromObject(object[".TimeSyncResponseMsg.timeSyncResponse"]);
            }
            return message;
        };

        /**
         * Creates a plain object from a ResponseMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {ServiceBaseProto.ResponseMsg} message ResponseMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, false);
                    object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.id = options.longs === String ? "0" : 0;
                object.error = null;
                object.priority = 0;
                object.versionMajor = 0;
                object.versionMinor = 0;
                object.versionBuild = 0;
                object[".SnapshotResponseMsg.snapshotResponse"] = null;
                object[".CounterResponseMsg.counterResponse"] = null;
                object[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] = null;
                object[".MetaStoreResponseMsg.keyStoreResponse"] = null;
                object[".SessionResponseMsg.sessionResponse"] = null;
                object[".EpochResponseMsg.epochResponse"] = null;
                object[".StatusResponseMsg.statusResponse"] = null;
                object[".TimeSyncResponseMsg.timeSyncResponse"] = null;
            }
            if (message.id != null && message.hasOwnProperty("id"))
                if (typeof message.id === "number")
                    object.id = options.longs === String ? String(message.id) : message.id;
                else
                    object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = $root.ServiceBaseProto.ResponseError.toObject(message.error, options);
            if (message.priority != null && message.hasOwnProperty("priority"))
                object.priority = message.priority;
            if (message.versionMajor != null && message.hasOwnProperty("versionMajor"))
                object.versionMajor = message.versionMajor;
            if (message.versionMinor != null && message.hasOwnProperty("versionMinor"))
                object.versionMinor = message.versionMinor;
            if (message.versionBuild != null && message.hasOwnProperty("versionBuild"))
                object.versionBuild = message.versionBuild;
            if (message[".SnapshotResponseMsg.snapshotResponse"] != null && message.hasOwnProperty(".SnapshotResponseMsg.snapshotResponse"))
                object[".SnapshotResponseMsg.snapshotResponse"] = $root.SnapshotResponseMsg.toObject(message[".SnapshotResponseMsg.snapshotResponse"], options);
            if (message[".CounterResponseMsg.counterResponse"] != null && message.hasOwnProperty(".CounterResponseMsg.counterResponse"))
                object[".CounterResponseMsg.counterResponse"] = $root.CounterResponseMsg.toObject(message[".CounterResponseMsg.counterResponse"], options);
            if (message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] != null && message.hasOwnProperty(".KeyRangeLockingResponseMsg.keyRangeLockingResponse"))
                object[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"] = $root.KeyRangeLockingResponseMsg.toObject(message[".KeyRangeLockingResponseMsg.keyRangeLockingResponse"], options);
            if (message[".MetaStoreResponseMsg.keyStoreResponse"] != null && message.hasOwnProperty(".MetaStoreResponseMsg.keyStoreResponse"))
                object[".MetaStoreResponseMsg.keyStoreResponse"] = $root.MetaStoreResponseMsg.toObject(message[".MetaStoreResponseMsg.keyStoreResponse"], options);
            if (message[".SessionResponseMsg.sessionResponse"] != null && message.hasOwnProperty(".SessionResponseMsg.sessionResponse"))
                object[".SessionResponseMsg.sessionResponse"] = $root.SessionResponseMsg.toObject(message[".SessionResponseMsg.sessionResponse"], options);
            if (message[".EpochResponseMsg.epochResponse"] != null && message.hasOwnProperty(".EpochResponseMsg.epochResponse"))
                object[".EpochResponseMsg.epochResponse"] = $root.EpochResponseMsg.toObject(message[".EpochResponseMsg.epochResponse"], options);
            if (message[".StatusResponseMsg.statusResponse"] != null && message.hasOwnProperty(".StatusResponseMsg.statusResponse"))
                object[".StatusResponseMsg.statusResponse"] = $root.StatusResponseMsg.toObject(message[".StatusResponseMsg.statusResponse"], options);
            if (message[".TimeSyncResponseMsg.timeSyncResponse"] != null && message.hasOwnProperty(".TimeSyncResponseMsg.timeSyncResponse"))
                object[".TimeSyncResponseMsg.timeSyncResponse"] = $root.TimeSyncResponseMsg.toObject(message[".TimeSyncResponseMsg.timeSyncResponse"], options);
            return object;
        };

        /**
         * Converts this ResponseMsg to JSON.
         * @function toJSON
         * @memberof ServiceBaseProto.ResponseMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResponseMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ResponseMsg
         * @function getTypeUrl
         * @memberof ServiceBaseProto.ResponseMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ServiceBaseProto.ResponseMsg";
        };

        return ResponseMsg;
    })();

    ServiceBaseProto.KeyValueMsg = (function() {

        /**
         * Properties of a KeyValueMsg.
         * @memberof ServiceBaseProto
         * @interface IKeyValueMsg
         * @property {Uint8Array} key KeyValueMsg key
         * @property {Uint8Array} value KeyValueMsg value
         */

        /**
         * Constructs a new KeyValueMsg.
         * @memberof ServiceBaseProto
         * @classdesc Represents a KeyValueMsg.
         * @implements IKeyValueMsg
         * @constructor
         * @param {ServiceBaseProto.IKeyValueMsg=} [properties] Properties to set
         */
        function KeyValueMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KeyValueMsg key.
         * @member {Uint8Array} key
         * @memberof ServiceBaseProto.KeyValueMsg
         * @instance
         */
        KeyValueMsg.prototype.key = $util.newBuffer([]);

        /**
         * KeyValueMsg value.
         * @member {Uint8Array} value
         * @memberof ServiceBaseProto.KeyValueMsg
         * @instance
         */
        KeyValueMsg.prototype.value = $util.newBuffer([]);

        /**
         * Creates a new KeyValueMsg instance using the specified properties.
         * @function create
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {ServiceBaseProto.IKeyValueMsg=} [properties] Properties to set
         * @returns {ServiceBaseProto.KeyValueMsg} KeyValueMsg instance
         */
        KeyValueMsg.create = function create(properties) {
            return new KeyValueMsg(properties);
        };

        /**
         * Encodes the specified KeyValueMsg message. Does not implicitly {@link ServiceBaseProto.KeyValueMsg.verify|verify} messages.
         * @function encode
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {ServiceBaseProto.IKeyValueMsg} message KeyValueMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KeyValueMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.key);
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.value);
            return writer;
        };

        /**
         * Decodes a KeyValueMsg message from the specified reader or buffer.
         * @function decode
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ServiceBaseProto.KeyValueMsg} KeyValueMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KeyValueMsg.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ServiceBaseProto.KeyValueMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.key = reader.bytes();
                        break;
                    }
                case 2: {
                        message.value = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("key"))
                throw $util.ProtocolError("missing required 'key'", { instance: message });
            if (!message.hasOwnProperty("value"))
                throw $util.ProtocolError("missing required 'value'", { instance: message });
            return message;
        };

        /**
         * Creates a KeyValueMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ServiceBaseProto.KeyValueMsg} KeyValueMsg
         */
        KeyValueMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.ServiceBaseProto.KeyValueMsg)
                return object;
            let message = new $root.ServiceBaseProto.KeyValueMsg();
            if (object.key != null)
                if (typeof object.key === "string")
                    $util.base64.decode(object.key, message.key = $util.newBuffer($util.base64.length(object.key)), 0);
                else if (object.key.length >= 0)
                    message.key = object.key;
            if (object.value != null)
                if (typeof object.value === "string")
                    $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                else if (object.value.length >= 0)
                    message.value = object.value;
            return message;
        };

        /**
         * Creates a plain object from a KeyValueMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {ServiceBaseProto.KeyValueMsg} message KeyValueMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KeyValueMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array)
                        object.key = $util.newBuffer(object.key);
                }
                if (options.bytes === String)
                    object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array)
                        object.value = $util.newBuffer(object.value);
                }
            }
            if (message.key != null && message.hasOwnProperty("key"))
                object.key = options.bytes === String ? $util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value"))
                object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            return object;
        };

        /**
         * Converts this KeyValueMsg to JSON.
         * @function toJSON
         * @memberof ServiceBaseProto.KeyValueMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KeyValueMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for KeyValueMsg
         * @function getTypeUrl
         * @memberof ServiceBaseProto.KeyValueMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        KeyValueMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/ServiceBaseProto.KeyValueMsg";
        };

        return KeyValueMsg;
    })();

    return ServiceBaseProto;
})();

export const VersionMsg = $root.VersionMsg = (() => {

    /**
     * Properties of a VersionMsg.
     * @exports IVersionMsg
     * @interface IVersionMsg
     * @property {number} nodeId VersionMsg nodeId
     * @property {Long} value VersionMsg value
     */

    /**
     * Constructs a new VersionMsg.
     * @exports VersionMsg
     * @classdesc Represents a VersionMsg.
     * @implements IVersionMsg
     * @constructor
     * @param {IVersionMsg=} [properties] Properties to set
     */
    function VersionMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * VersionMsg nodeId.
     * @member {number} nodeId
     * @memberof VersionMsg
     * @instance
     */
    VersionMsg.prototype.nodeId = 0;

    /**
     * VersionMsg value.
     * @member {Long} value
     * @memberof VersionMsg
     * @instance
     */
    VersionMsg.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new VersionMsg instance using the specified properties.
     * @function create
     * @memberof VersionMsg
     * @static
     * @param {IVersionMsg=} [properties] Properties to set
     * @returns {VersionMsg} VersionMsg instance
     */
    VersionMsg.create = function create(properties) {
        return new VersionMsg(properties);
    };

    /**
     * Encodes the specified VersionMsg message. Does not implicitly {@link VersionMsg.verify|verify} messages.
     * @function encode
     * @memberof VersionMsg
     * @static
     * @param {IVersionMsg} message VersionMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    VersionMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.nodeId);
        writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.value);
        return writer;
    };

    /**
     * Decodes a VersionMsg message from the specified reader or buffer.
     * @function decode
     * @memberof VersionMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {VersionMsg} VersionMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    VersionMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.VersionMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.nodeId = reader.uint32();
                    break;
                }
            case 2: {
                    message.value = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nodeId"))
            throw $util.ProtocolError("missing required 'nodeId'", { instance: message });
        if (!message.hasOwnProperty("value"))
            throw $util.ProtocolError("missing required 'value'", { instance: message });
        return message;
    };

    /**
     * Creates a VersionMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof VersionMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {VersionMsg} VersionMsg
     */
    VersionMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.VersionMsg)
            return object;
        let message = new $root.VersionMsg();
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        if (object.value != null)
            if ($util.Long)
                (message.value = $util.Long.fromValue(object.value)).unsigned = true;
            else if (typeof object.value === "string")
                message.value = parseInt(object.value, 10);
            else if (typeof object.value === "number")
                message.value = object.value;
            else if (typeof object.value === "object")
                message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a VersionMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof VersionMsg
     * @static
     * @param {VersionMsg} message VersionMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    VersionMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.nodeId = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.value = options.longs === String ? "0" : 0;
        }
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        if (message.value != null && message.hasOwnProperty("value"))
            if (typeof message.value === "number")
                object.value = options.longs === String ? String(message.value) : message.value;
            else
                object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
        return object;
    };

    /**
     * Converts this VersionMsg to JSON.
     * @function toJSON
     * @memberof VersionMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    VersionMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for VersionMsg
     * @function getTypeUrl
     * @memberof VersionMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    VersionMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/VersionMsg";
    };

    return VersionMsg;
})();

export const MetaStoreRequestMsg = $root.MetaStoreRequestMsg = (() => {

    /**
     * Properties of a MetaStoreRequestMsg.
     * @exports IMetaStoreRequestMsg
     * @interface IMetaStoreRequestMsg
     * @property {MetaStoreRequestMsg.RequestType} type MetaStoreRequestMsg type
     * @property {Long|null} [startTimeKeyStackV2] MetaStoreRequestMsg startTimeKeyStackV2
     * @property {IFetchKeysMsg|null} [fetch] MetaStoreRequestMsg fetch
     * @property {IApplyDataMsg|null} [apply] MetaStoreRequestMsg apply
     * @property {IInvokeProcMsg|null} [invoke] MetaStoreRequestMsg invoke
     * @property {IVersionMsg|null} [startTime] MetaStoreRequestMsg startTime
     * @property {IVersionMsg|null} [currentTime] MetaStoreRequestMsg currentTime
     */

    /**
     * Constructs a new MetaStoreRequestMsg.
     * @exports MetaStoreRequestMsg
     * @classdesc Represents a MetaStoreRequestMsg.
     * @implements IMetaStoreRequestMsg
     * @constructor
     * @param {IMetaStoreRequestMsg=} [properties] Properties to set
     */
    function MetaStoreRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MetaStoreRequestMsg type.
     * @member {MetaStoreRequestMsg.RequestType} type
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.type = 1;

    /**
     * MetaStoreRequestMsg startTimeKeyStackV2.
     * @member {Long} startTimeKeyStackV2
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.startTimeKeyStackV2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * MetaStoreRequestMsg fetch.
     * @member {IFetchKeysMsg|null|undefined} fetch
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.fetch = null;

    /**
     * MetaStoreRequestMsg apply.
     * @member {IApplyDataMsg|null|undefined} apply
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.apply = null;

    /**
     * MetaStoreRequestMsg invoke.
     * @member {IInvokeProcMsg|null|undefined} invoke
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.invoke = null;

    /**
     * MetaStoreRequestMsg startTime.
     * @member {IVersionMsg|null|undefined} startTime
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.startTime = null;

    /**
     * MetaStoreRequestMsg currentTime.
     * @member {IVersionMsg|null|undefined} currentTime
     * @memberof MetaStoreRequestMsg
     * @instance
     */
    MetaStoreRequestMsg.prototype.currentTime = null;

    /**
     * Creates a new MetaStoreRequestMsg instance using the specified properties.
     * @function create
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {IMetaStoreRequestMsg=} [properties] Properties to set
     * @returns {MetaStoreRequestMsg} MetaStoreRequestMsg instance
     */
    MetaStoreRequestMsg.create = function create(properties) {
        return new MetaStoreRequestMsg(properties);
    };

    /**
     * Encodes the specified MetaStoreRequestMsg message. Does not implicitly {@link MetaStoreRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {IMetaStoreRequestMsg} message MetaStoreRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetaStoreRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.startTimeKeyStackV2 != null && Object.hasOwnProperty.call(message, "startTimeKeyStackV2"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTimeKeyStackV2);
        if (message.fetch != null && Object.hasOwnProperty.call(message, "fetch"))
            $root.FetchKeysMsg.encode(message.fetch, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.apply != null && Object.hasOwnProperty.call(message, "apply"))
            $root.ApplyDataMsg.encode(message.apply, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.invoke != null && Object.hasOwnProperty.call(message, "invoke"))
            $root.InvokeProcMsg.encode(message.invoke, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
            $root.VersionMsg.encode(message.startTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.currentTime != null && Object.hasOwnProperty.call(message, "currentTime"))
            $root.VersionMsg.encode(message.currentTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a MetaStoreRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetaStoreRequestMsg} MetaStoreRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetaStoreRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MetaStoreRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.startTimeKeyStackV2 = reader.uint64();
                    break;
                }
            case 3: {
                    message.fetch = $root.FetchKeysMsg.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.apply = $root.ApplyDataMsg.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.invoke = $root.InvokeProcMsg.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.startTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.currentTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a MetaStoreRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetaStoreRequestMsg} MetaStoreRequestMsg
     */
    MetaStoreRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.MetaStoreRequestMsg)
            return object;
        let message = new $root.MetaStoreRequestMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "FETCH_DATA_REQUEST":
        case 1:
            message.type = 1;
            break;
        case "APPLY_DATA_REQUEST":
        case 2:
            message.type = 2;
            break;
        case "INVOKE_PROCEDURE_REQUEST":
        case 3:
            message.type = 3;
            break;
        }
        if (object.startTimeKeyStackV2 != null)
            if ($util.Long)
                (message.startTimeKeyStackV2 = $util.Long.fromValue(object.startTimeKeyStackV2)).unsigned = true;
            else if (typeof object.startTimeKeyStackV2 === "string")
                message.startTimeKeyStackV2 = parseInt(object.startTimeKeyStackV2, 10);
            else if (typeof object.startTimeKeyStackV2 === "number")
                message.startTimeKeyStackV2 = object.startTimeKeyStackV2;
            else if (typeof object.startTimeKeyStackV2 === "object")
                message.startTimeKeyStackV2 = new $util.LongBits(object.startTimeKeyStackV2.low >>> 0, object.startTimeKeyStackV2.high >>> 0).toNumber(true);
        if (object.fetch != null) {
            if (typeof object.fetch !== "object")
                throw TypeError(".MetaStoreRequestMsg.fetch: object expected");
            message.fetch = $root.FetchKeysMsg.fromObject(object.fetch);
        }
        if (object.apply != null) {
            if (typeof object.apply !== "object")
                throw TypeError(".MetaStoreRequestMsg.apply: object expected");
            message.apply = $root.ApplyDataMsg.fromObject(object.apply);
        }
        if (object.invoke != null) {
            if (typeof object.invoke !== "object")
                throw TypeError(".MetaStoreRequestMsg.invoke: object expected");
            message.invoke = $root.InvokeProcMsg.fromObject(object.invoke);
        }
        if (object.startTime != null) {
            if (typeof object.startTime !== "object")
                throw TypeError(".MetaStoreRequestMsg.startTime: object expected");
            message.startTime = $root.VersionMsg.fromObject(object.startTime);
        }
        if (object.currentTime != null) {
            if (typeof object.currentTime !== "object")
                throw TypeError(".MetaStoreRequestMsg.currentTime: object expected");
            message.currentTime = $root.VersionMsg.fromObject(object.currentTime);
        }
        return message;
    };

    /**
     * Creates a plain object from a MetaStoreRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {MetaStoreRequestMsg} message MetaStoreRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetaStoreRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "FETCH_DATA_REQUEST" : 1;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.startTimeKeyStackV2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimeKeyStackV2 = options.longs === String ? "0" : 0;
            object.fetch = null;
            object.apply = null;
            object.invoke = null;
            object.startTime = null;
            object.currentTime = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.MetaStoreRequestMsg.RequestType[message.type] === undefined ? message.type : $root.MetaStoreRequestMsg.RequestType[message.type] : message.type;
        if (message.startTimeKeyStackV2 != null && message.hasOwnProperty("startTimeKeyStackV2"))
            if (typeof message.startTimeKeyStackV2 === "number")
                object.startTimeKeyStackV2 = options.longs === String ? String(message.startTimeKeyStackV2) : message.startTimeKeyStackV2;
            else
                object.startTimeKeyStackV2 = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeKeyStackV2) : options.longs === Number ? new $util.LongBits(message.startTimeKeyStackV2.low >>> 0, message.startTimeKeyStackV2.high >>> 0).toNumber(true) : message.startTimeKeyStackV2;
        if (message.fetch != null && message.hasOwnProperty("fetch"))
            object.fetch = $root.FetchKeysMsg.toObject(message.fetch, options);
        if (message.apply != null && message.hasOwnProperty("apply"))
            object.apply = $root.ApplyDataMsg.toObject(message.apply, options);
        if (message.invoke != null && message.hasOwnProperty("invoke"))
            object.invoke = $root.InvokeProcMsg.toObject(message.invoke, options);
        if (message.startTime != null && message.hasOwnProperty("startTime"))
            object.startTime = $root.VersionMsg.toObject(message.startTime, options);
        if (message.currentTime != null && message.hasOwnProperty("currentTime"))
            object.currentTime = $root.VersionMsg.toObject(message.currentTime, options);
        return object;
    };

    /**
     * Converts this MetaStoreRequestMsg to JSON.
     * @function toJSON
     * @memberof MetaStoreRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetaStoreRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MetaStoreRequestMsg
     * @function getTypeUrl
     * @memberof MetaStoreRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MetaStoreRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MetaStoreRequestMsg";
    };

    /**
     * RequestType enum.
     * @name MetaStoreRequestMsg.RequestType
     * @enum {number}
     * @property {number} FETCH_DATA_REQUEST=1 FETCH_DATA_REQUEST value
     * @property {number} APPLY_DATA_REQUEST=2 APPLY_DATA_REQUEST value
     * @property {number} INVOKE_PROCEDURE_REQUEST=3 INVOKE_PROCEDURE_REQUEST value
     */
    MetaStoreRequestMsg.RequestType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "FETCH_DATA_REQUEST"] = 1;
        values[valuesById[2] = "APPLY_DATA_REQUEST"] = 2;
        values[valuesById[3] = "INVOKE_PROCEDURE_REQUEST"] = 3;
        return values;
    })();

    return MetaStoreRequestMsg;
})();

export const KeyRangeMsg = $root.KeyRangeMsg = (() => {

    /**
     * Properties of a KeyRangeMsg.
     * @exports IKeyRangeMsg
     * @interface IKeyRangeMsg
     * @property {Uint8Array} start KeyRangeMsg start
     * @property {Uint8Array} limit KeyRangeMsg limit
     */

    /**
     * Constructs a new KeyRangeMsg.
     * @exports KeyRangeMsg
     * @classdesc Represents a KeyRangeMsg.
     * @implements IKeyRangeMsg
     * @constructor
     * @param {IKeyRangeMsg=} [properties] Properties to set
     */
    function KeyRangeMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KeyRangeMsg start.
     * @member {Uint8Array} start
     * @memberof KeyRangeMsg
     * @instance
     */
    KeyRangeMsg.prototype.start = $util.newBuffer([]);

    /**
     * KeyRangeMsg limit.
     * @member {Uint8Array} limit
     * @memberof KeyRangeMsg
     * @instance
     */
    KeyRangeMsg.prototype.limit = $util.newBuffer([]);

    /**
     * Creates a new KeyRangeMsg instance using the specified properties.
     * @function create
     * @memberof KeyRangeMsg
     * @static
     * @param {IKeyRangeMsg=} [properties] Properties to set
     * @returns {KeyRangeMsg} KeyRangeMsg instance
     */
    KeyRangeMsg.create = function create(properties) {
        return new KeyRangeMsg(properties);
    };

    /**
     * Encodes the specified KeyRangeMsg message. Does not implicitly {@link KeyRangeMsg.verify|verify} messages.
     * @function encode
     * @memberof KeyRangeMsg
     * @static
     * @param {IKeyRangeMsg} message KeyRangeMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KeyRangeMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.start);
        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.limit);
        return writer;
    };

    /**
     * Decodes a KeyRangeMsg message from the specified reader or buffer.
     * @function decode
     * @memberof KeyRangeMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KeyRangeMsg} KeyRangeMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KeyRangeMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KeyRangeMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.start = reader.bytes();
                    break;
                }
            case 2: {
                    message.limit = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("start"))
            throw $util.ProtocolError("missing required 'start'", { instance: message });
        if (!message.hasOwnProperty("limit"))
            throw $util.ProtocolError("missing required 'limit'", { instance: message });
        return message;
    };

    /**
     * Creates a KeyRangeMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KeyRangeMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KeyRangeMsg} KeyRangeMsg
     */
    KeyRangeMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.KeyRangeMsg)
            return object;
        let message = new $root.KeyRangeMsg();
        if (object.start != null)
            if (typeof object.start === "string")
                $util.base64.decode(object.start, message.start = $util.newBuffer($util.base64.length(object.start)), 0);
            else if (object.start.length >= 0)
                message.start = object.start;
        if (object.limit != null)
            if (typeof object.limit === "string")
                $util.base64.decode(object.limit, message.limit = $util.newBuffer($util.base64.length(object.limit)), 0);
            else if (object.limit.length >= 0)
                message.limit = object.limit;
        return message;
    };

    /**
     * Creates a plain object from a KeyRangeMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KeyRangeMsg
     * @static
     * @param {KeyRangeMsg} message KeyRangeMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KeyRangeMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.start = "";
            else {
                object.start = [];
                if (options.bytes !== Array)
                    object.start = $util.newBuffer(object.start);
            }
            if (options.bytes === String)
                object.limit = "";
            else {
                object.limit = [];
                if (options.bytes !== Array)
                    object.limit = $util.newBuffer(object.limit);
            }
        }
        if (message.start != null && message.hasOwnProperty("start"))
            object.start = options.bytes === String ? $util.base64.encode(message.start, 0, message.start.length) : options.bytes === Array ? Array.prototype.slice.call(message.start) : message.start;
        if (message.limit != null && message.hasOwnProperty("limit"))
            object.limit = options.bytes === String ? $util.base64.encode(message.limit, 0, message.limit.length) : options.bytes === Array ? Array.prototype.slice.call(message.limit) : message.limit;
        return object;
    };

    /**
     * Converts this KeyRangeMsg to JSON.
     * @function toJSON
     * @memberof KeyRangeMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KeyRangeMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KeyRangeMsg
     * @function getTypeUrl
     * @memberof KeyRangeMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KeyRangeMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KeyRangeMsg";
    };

    return KeyRangeMsg;
})();

export const KeyRangeDataMsg = $root.KeyRangeDataMsg = (() => {

    /**
     * Properties of a KeyRangeDataMsg.
     * @exports IKeyRangeDataMsg
     * @interface IKeyRangeDataMsg
     * @property {IKeyRangeMsg} range KeyRangeDataMsg range
     * @property {Array.<ServiceBaseProto.IKeyValueMsg>|null} [data] KeyRangeDataMsg data
     * @property {IKeyRangeMsg|null} [partialRange] KeyRangeDataMsg partialRange
     */

    /**
     * Constructs a new KeyRangeDataMsg.
     * @exports KeyRangeDataMsg
     * @classdesc Represents a KeyRangeDataMsg.
     * @implements IKeyRangeDataMsg
     * @constructor
     * @param {IKeyRangeDataMsg=} [properties] Properties to set
     */
    function KeyRangeDataMsg(properties) {
        this.data = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KeyRangeDataMsg range.
     * @member {IKeyRangeMsg} range
     * @memberof KeyRangeDataMsg
     * @instance
     */
    KeyRangeDataMsg.prototype.range = null;

    /**
     * KeyRangeDataMsg data.
     * @member {Array.<ServiceBaseProto.IKeyValueMsg>} data
     * @memberof KeyRangeDataMsg
     * @instance
     */
    KeyRangeDataMsg.prototype.data = $util.emptyArray;

    /**
     * KeyRangeDataMsg partialRange.
     * @member {IKeyRangeMsg|null|undefined} partialRange
     * @memberof KeyRangeDataMsg
     * @instance
     */
    KeyRangeDataMsg.prototype.partialRange = null;

    /**
     * Creates a new KeyRangeDataMsg instance using the specified properties.
     * @function create
     * @memberof KeyRangeDataMsg
     * @static
     * @param {IKeyRangeDataMsg=} [properties] Properties to set
     * @returns {KeyRangeDataMsg} KeyRangeDataMsg instance
     */
    KeyRangeDataMsg.create = function create(properties) {
        return new KeyRangeDataMsg(properties);
    };

    /**
     * Encodes the specified KeyRangeDataMsg message. Does not implicitly {@link KeyRangeDataMsg.verify|verify} messages.
     * @function encode
     * @memberof KeyRangeDataMsg
     * @static
     * @param {IKeyRangeDataMsg} message KeyRangeDataMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KeyRangeDataMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.KeyRangeMsg.encode(message.range, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.data != null && message.data.length)
            for (let i = 0; i < message.data.length; ++i)
                $root.ServiceBaseProto.KeyValueMsg.encode(message.data[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.partialRange != null && Object.hasOwnProperty.call(message, "partialRange"))
            $root.KeyRangeMsg.encode(message.partialRange, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a KeyRangeDataMsg message from the specified reader or buffer.
     * @function decode
     * @memberof KeyRangeDataMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KeyRangeDataMsg} KeyRangeDataMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KeyRangeDataMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KeyRangeDataMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.range = $root.KeyRangeMsg.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push($root.ServiceBaseProto.KeyValueMsg.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.partialRange = $root.KeyRangeMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("range"))
            throw $util.ProtocolError("missing required 'range'", { instance: message });
        return message;
    };

    /**
     * Creates a KeyRangeDataMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KeyRangeDataMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KeyRangeDataMsg} KeyRangeDataMsg
     */
    KeyRangeDataMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.KeyRangeDataMsg)
            return object;
        let message = new $root.KeyRangeDataMsg();
        if (object.range != null) {
            if (typeof object.range !== "object")
                throw TypeError(".KeyRangeDataMsg.range: object expected");
            message.range = $root.KeyRangeMsg.fromObject(object.range);
        }
        if (object.data) {
            if (!Array.isArray(object.data))
                throw TypeError(".KeyRangeDataMsg.data: array expected");
            message.data = [];
            for (let i = 0; i < object.data.length; ++i) {
                if (typeof object.data[i] !== "object")
                    throw TypeError(".KeyRangeDataMsg.data: object expected");
                message.data[i] = $root.ServiceBaseProto.KeyValueMsg.fromObject(object.data[i]);
            }
        }
        if (object.partialRange != null) {
            if (typeof object.partialRange !== "object")
                throw TypeError(".KeyRangeDataMsg.partialRange: object expected");
            message.partialRange = $root.KeyRangeMsg.fromObject(object.partialRange);
        }
        return message;
    };

    /**
     * Creates a plain object from a KeyRangeDataMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KeyRangeDataMsg
     * @static
     * @param {KeyRangeDataMsg} message KeyRangeDataMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KeyRangeDataMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (options.defaults) {
            object.range = null;
            object.partialRange = null;
        }
        if (message.range != null && message.hasOwnProperty("range"))
            object.range = $root.KeyRangeMsg.toObject(message.range, options);
        if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = $root.ServiceBaseProto.KeyValueMsg.toObject(message.data[j], options);
        }
        if (message.partialRange != null && message.hasOwnProperty("partialRange"))
            object.partialRange = $root.KeyRangeMsg.toObject(message.partialRange, options);
        return object;
    };

    /**
     * Converts this KeyRangeDataMsg to JSON.
     * @function toJSON
     * @memberof KeyRangeDataMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KeyRangeDataMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KeyRangeDataMsg
     * @function getTypeUrl
     * @memberof KeyRangeDataMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KeyRangeDataMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KeyRangeDataMsg";
    };

    return KeyRangeDataMsg;
})();

export const FetchKeysMsg = $root.FetchKeysMsg = (() => {

    /**
     * Properties of a FetchKeysMsg.
     * @exports IFetchKeysMsg
     * @interface IFetchKeysMsg
     * @property {IKeyRangeMsg} range FetchKeysMsg range
     * @property {Long|null} [maxSize] FetchKeysMsg maxSize
     * @property {Long|null} [maxKeys] FetchKeysMsg maxKeys
     * @property {Uint8Array|null} [cursor] FetchKeysMsg cursor
     * @property {number|null} [nodeId] FetchKeysMsg nodeId
     */

    /**
     * Constructs a new FetchKeysMsg.
     * @exports FetchKeysMsg
     * @classdesc Represents a FetchKeysMsg.
     * @implements IFetchKeysMsg
     * @constructor
     * @param {IFetchKeysMsg=} [properties] Properties to set
     */
    function FetchKeysMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FetchKeysMsg range.
     * @member {IKeyRangeMsg} range
     * @memberof FetchKeysMsg
     * @instance
     */
    FetchKeysMsg.prototype.range = null;

    /**
     * FetchKeysMsg maxSize.
     * @member {Long} maxSize
     * @memberof FetchKeysMsg
     * @instance
     */
    FetchKeysMsg.prototype.maxSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * FetchKeysMsg maxKeys.
     * @member {Long} maxKeys
     * @memberof FetchKeysMsg
     * @instance
     */
    FetchKeysMsg.prototype.maxKeys = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * FetchKeysMsg cursor.
     * @member {Uint8Array} cursor
     * @memberof FetchKeysMsg
     * @instance
     */
    FetchKeysMsg.prototype.cursor = $util.newBuffer([]);

    /**
     * FetchKeysMsg nodeId.
     * @member {number} nodeId
     * @memberof FetchKeysMsg
     * @instance
     */
    FetchKeysMsg.prototype.nodeId = 0;

    /**
     * Creates a new FetchKeysMsg instance using the specified properties.
     * @function create
     * @memberof FetchKeysMsg
     * @static
     * @param {IFetchKeysMsg=} [properties] Properties to set
     * @returns {FetchKeysMsg} FetchKeysMsg instance
     */
    FetchKeysMsg.create = function create(properties) {
        return new FetchKeysMsg(properties);
    };

    /**
     * Encodes the specified FetchKeysMsg message. Does not implicitly {@link FetchKeysMsg.verify|verify} messages.
     * @function encode
     * @memberof FetchKeysMsg
     * @static
     * @param {IFetchKeysMsg} message FetchKeysMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FetchKeysMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.KeyRangeMsg.encode(message.range, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.maxSize != null && Object.hasOwnProperty.call(message, "maxSize"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.maxSize);
        if (message.maxKeys != null && Object.hasOwnProperty.call(message, "maxKeys"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.maxKeys);
        if (message.cursor != null && Object.hasOwnProperty.call(message, "cursor"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.cursor);
        if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint32(message.nodeId);
        return writer;
    };

    /**
     * Decodes a FetchKeysMsg message from the specified reader or buffer.
     * @function decode
     * @memberof FetchKeysMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FetchKeysMsg} FetchKeysMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FetchKeysMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FetchKeysMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.range = $root.KeyRangeMsg.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.maxSize = reader.uint64();
                    break;
                }
            case 3: {
                    message.maxKeys = reader.uint64();
                    break;
                }
            case 4: {
                    message.cursor = reader.bytes();
                    break;
                }
            case 5: {
                    message.nodeId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("range"))
            throw $util.ProtocolError("missing required 'range'", { instance: message });
        return message;
    };

    /**
     * Creates a FetchKeysMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FetchKeysMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FetchKeysMsg} FetchKeysMsg
     */
    FetchKeysMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.FetchKeysMsg)
            return object;
        let message = new $root.FetchKeysMsg();
        if (object.range != null) {
            if (typeof object.range !== "object")
                throw TypeError(".FetchKeysMsg.range: object expected");
            message.range = $root.KeyRangeMsg.fromObject(object.range);
        }
        if (object.maxSize != null)
            if ($util.Long)
                (message.maxSize = $util.Long.fromValue(object.maxSize)).unsigned = true;
            else if (typeof object.maxSize === "string")
                message.maxSize = parseInt(object.maxSize, 10);
            else if (typeof object.maxSize === "number")
                message.maxSize = object.maxSize;
            else if (typeof object.maxSize === "object")
                message.maxSize = new $util.LongBits(object.maxSize.low >>> 0, object.maxSize.high >>> 0).toNumber(true);
        if (object.maxKeys != null)
            if ($util.Long)
                (message.maxKeys = $util.Long.fromValue(object.maxKeys)).unsigned = true;
            else if (typeof object.maxKeys === "string")
                message.maxKeys = parseInt(object.maxKeys, 10);
            else if (typeof object.maxKeys === "number")
                message.maxKeys = object.maxKeys;
            else if (typeof object.maxKeys === "object")
                message.maxKeys = new $util.LongBits(object.maxKeys.low >>> 0, object.maxKeys.high >>> 0).toNumber(true);
        if (object.cursor != null)
            if (typeof object.cursor === "string")
                $util.base64.decode(object.cursor, message.cursor = $util.newBuffer($util.base64.length(object.cursor)), 0);
            else if (object.cursor.length >= 0)
                message.cursor = object.cursor;
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a FetchKeysMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FetchKeysMsg
     * @static
     * @param {FetchKeysMsg} message FetchKeysMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FetchKeysMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.range = null;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.maxSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.maxSize = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.maxKeys = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.maxKeys = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.cursor = "";
            else {
                object.cursor = [];
                if (options.bytes !== Array)
                    object.cursor = $util.newBuffer(object.cursor);
            }
            object.nodeId = 0;
        }
        if (message.range != null && message.hasOwnProperty("range"))
            object.range = $root.KeyRangeMsg.toObject(message.range, options);
        if (message.maxSize != null && message.hasOwnProperty("maxSize"))
            if (typeof message.maxSize === "number")
                object.maxSize = options.longs === String ? String(message.maxSize) : message.maxSize;
            else
                object.maxSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxSize) : options.longs === Number ? new $util.LongBits(message.maxSize.low >>> 0, message.maxSize.high >>> 0).toNumber(true) : message.maxSize;
        if (message.maxKeys != null && message.hasOwnProperty("maxKeys"))
            if (typeof message.maxKeys === "number")
                object.maxKeys = options.longs === String ? String(message.maxKeys) : message.maxKeys;
            else
                object.maxKeys = options.longs === String ? $util.Long.prototype.toString.call(message.maxKeys) : options.longs === Number ? new $util.LongBits(message.maxKeys.low >>> 0, message.maxKeys.high >>> 0).toNumber(true) : message.maxKeys;
        if (message.cursor != null && message.hasOwnProperty("cursor"))
            object.cursor = options.bytes === String ? $util.base64.encode(message.cursor, 0, message.cursor.length) : options.bytes === Array ? Array.prototype.slice.call(message.cursor) : message.cursor;
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        return object;
    };

    /**
     * Converts this FetchKeysMsg to JSON.
     * @function toJSON
     * @memberof FetchKeysMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FetchKeysMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FetchKeysMsg
     * @function getTypeUrl
     * @memberof FetchKeysMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FetchKeysMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FetchKeysMsg";
    };

    return FetchKeysMsg;
})();

export const ApplyDataMsg = $root.ApplyDataMsg = (() => {

    /**
     * Properties of an ApplyDataMsg.
     * @exports IApplyDataMsg
     * @interface IApplyDataMsg
     * @property {IKeyRangeDataMsg} data ApplyDataMsg data
     * @property {Long|null} [startTimeKeyStackV2] ApplyDataMsg startTimeKeyStackV2
     * @property {Long|null} [currentTimeKeyStackV2] ApplyDataMsg currentTimeKeyStackV2
     * @property {number|null} [nodeId] ApplyDataMsg nodeId
     * @property {Long|null} [epoch] ApplyDataMsg epoch
     * @property {Long|null} [connection] ApplyDataMsg connection
     * @property {IVersionMsg|null} [startTime] ApplyDataMsg startTime
     * @property {IVersionMsg|null} [currentTime] ApplyDataMsg currentTime
     */

    /**
     * Constructs a new ApplyDataMsg.
     * @exports ApplyDataMsg
     * @classdesc Represents an ApplyDataMsg.
     * @implements IApplyDataMsg
     * @constructor
     * @param {IApplyDataMsg=} [properties] Properties to set
     */
    function ApplyDataMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApplyDataMsg data.
     * @member {IKeyRangeDataMsg} data
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.data = null;

    /**
     * ApplyDataMsg startTimeKeyStackV2.
     * @member {Long} startTimeKeyStackV2
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.startTimeKeyStackV2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ApplyDataMsg currentTimeKeyStackV2.
     * @member {Long} currentTimeKeyStackV2
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.currentTimeKeyStackV2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ApplyDataMsg nodeId.
     * @member {number} nodeId
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.nodeId = 0;

    /**
     * ApplyDataMsg epoch.
     * @member {Long} epoch
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.epoch = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ApplyDataMsg connection.
     * @member {Long} connection
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.connection = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * ApplyDataMsg startTime.
     * @member {IVersionMsg|null|undefined} startTime
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.startTime = null;

    /**
     * ApplyDataMsg currentTime.
     * @member {IVersionMsg|null|undefined} currentTime
     * @memberof ApplyDataMsg
     * @instance
     */
    ApplyDataMsg.prototype.currentTime = null;

    /**
     * Creates a new ApplyDataMsg instance using the specified properties.
     * @function create
     * @memberof ApplyDataMsg
     * @static
     * @param {IApplyDataMsg=} [properties] Properties to set
     * @returns {ApplyDataMsg} ApplyDataMsg instance
     */
    ApplyDataMsg.create = function create(properties) {
        return new ApplyDataMsg(properties);
    };

    /**
     * Encodes the specified ApplyDataMsg message. Does not implicitly {@link ApplyDataMsg.verify|verify} messages.
     * @function encode
     * @memberof ApplyDataMsg
     * @static
     * @param {IApplyDataMsg} message ApplyDataMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplyDataMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.KeyRangeDataMsg.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.startTimeKeyStackV2 != null && Object.hasOwnProperty.call(message, "startTimeKeyStackV2"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTimeKeyStackV2);
        if (message.currentTimeKeyStackV2 != null && Object.hasOwnProperty.call(message, "currentTimeKeyStackV2"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.currentTimeKeyStackV2);
        if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint32(message.nodeId);
        if (message.epoch != null && Object.hasOwnProperty.call(message, "epoch"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.epoch);
        if (message.connection != null && Object.hasOwnProperty.call(message, "connection"))
            writer.uint32(/* id 6, wireType 0 =*/48).uint64(message.connection);
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
            $root.VersionMsg.encode(message.startTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.currentTime != null && Object.hasOwnProperty.call(message, "currentTime"))
            $root.VersionMsg.encode(message.currentTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes an ApplyDataMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ApplyDataMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApplyDataMsg} ApplyDataMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplyDataMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplyDataMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.data = $root.KeyRangeDataMsg.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.startTimeKeyStackV2 = reader.uint64();
                    break;
                }
            case 3: {
                    message.currentTimeKeyStackV2 = reader.uint64();
                    break;
                }
            case 4: {
                    message.nodeId = reader.uint32();
                    break;
                }
            case 5: {
                    message.epoch = reader.uint64();
                    break;
                }
            case 6: {
                    message.connection = reader.uint64();
                    break;
                }
            case 7: {
                    message.startTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            case 8: {
                    message.currentTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    /**
     * Creates an ApplyDataMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApplyDataMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApplyDataMsg} ApplyDataMsg
     */
    ApplyDataMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplyDataMsg)
            return object;
        let message = new $root.ApplyDataMsg();
        if (object.data != null) {
            if (typeof object.data !== "object")
                throw TypeError(".ApplyDataMsg.data: object expected");
            message.data = $root.KeyRangeDataMsg.fromObject(object.data);
        }
        if (object.startTimeKeyStackV2 != null)
            if ($util.Long)
                (message.startTimeKeyStackV2 = $util.Long.fromValue(object.startTimeKeyStackV2)).unsigned = true;
            else if (typeof object.startTimeKeyStackV2 === "string")
                message.startTimeKeyStackV2 = parseInt(object.startTimeKeyStackV2, 10);
            else if (typeof object.startTimeKeyStackV2 === "number")
                message.startTimeKeyStackV2 = object.startTimeKeyStackV2;
            else if (typeof object.startTimeKeyStackV2 === "object")
                message.startTimeKeyStackV2 = new $util.LongBits(object.startTimeKeyStackV2.low >>> 0, object.startTimeKeyStackV2.high >>> 0).toNumber(true);
        if (object.currentTimeKeyStackV2 != null)
            if ($util.Long)
                (message.currentTimeKeyStackV2 = $util.Long.fromValue(object.currentTimeKeyStackV2)).unsigned = true;
            else if (typeof object.currentTimeKeyStackV2 === "string")
                message.currentTimeKeyStackV2 = parseInt(object.currentTimeKeyStackV2, 10);
            else if (typeof object.currentTimeKeyStackV2 === "number")
                message.currentTimeKeyStackV2 = object.currentTimeKeyStackV2;
            else if (typeof object.currentTimeKeyStackV2 === "object")
                message.currentTimeKeyStackV2 = new $util.LongBits(object.currentTimeKeyStackV2.low >>> 0, object.currentTimeKeyStackV2.high >>> 0).toNumber(true);
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        if (object.epoch != null)
            if ($util.Long)
                (message.epoch = $util.Long.fromValue(object.epoch)).unsigned = true;
            else if (typeof object.epoch === "string")
                message.epoch = parseInt(object.epoch, 10);
            else if (typeof object.epoch === "number")
                message.epoch = object.epoch;
            else if (typeof object.epoch === "object")
                message.epoch = new $util.LongBits(object.epoch.low >>> 0, object.epoch.high >>> 0).toNumber(true);
        if (object.connection != null)
            if ($util.Long)
                (message.connection = $util.Long.fromValue(object.connection)).unsigned = true;
            else if (typeof object.connection === "string")
                message.connection = parseInt(object.connection, 10);
            else if (typeof object.connection === "number")
                message.connection = object.connection;
            else if (typeof object.connection === "object")
                message.connection = new $util.LongBits(object.connection.low >>> 0, object.connection.high >>> 0).toNumber(true);
        if (object.startTime != null) {
            if (typeof object.startTime !== "object")
                throw TypeError(".ApplyDataMsg.startTime: object expected");
            message.startTime = $root.VersionMsg.fromObject(object.startTime);
        }
        if (object.currentTime != null) {
            if (typeof object.currentTime !== "object")
                throw TypeError(".ApplyDataMsg.currentTime: object expected");
            message.currentTime = $root.VersionMsg.fromObject(object.currentTime);
        }
        return message;
    };

    /**
     * Creates a plain object from an ApplyDataMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApplyDataMsg
     * @static
     * @param {ApplyDataMsg} message ApplyDataMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApplyDataMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.data = null;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.startTimeKeyStackV2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimeKeyStackV2 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.currentTimeKeyStackV2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.currentTimeKeyStackV2 = options.longs === String ? "0" : 0;
            object.nodeId = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.epoch = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.epoch = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.connection = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.connection = options.longs === String ? "0" : 0;
            object.startTime = null;
            object.currentTime = null;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = $root.KeyRangeDataMsg.toObject(message.data, options);
        if (message.startTimeKeyStackV2 != null && message.hasOwnProperty("startTimeKeyStackV2"))
            if (typeof message.startTimeKeyStackV2 === "number")
                object.startTimeKeyStackV2 = options.longs === String ? String(message.startTimeKeyStackV2) : message.startTimeKeyStackV2;
            else
                object.startTimeKeyStackV2 = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeKeyStackV2) : options.longs === Number ? new $util.LongBits(message.startTimeKeyStackV2.low >>> 0, message.startTimeKeyStackV2.high >>> 0).toNumber(true) : message.startTimeKeyStackV2;
        if (message.currentTimeKeyStackV2 != null && message.hasOwnProperty("currentTimeKeyStackV2"))
            if (typeof message.currentTimeKeyStackV2 === "number")
                object.currentTimeKeyStackV2 = options.longs === String ? String(message.currentTimeKeyStackV2) : message.currentTimeKeyStackV2;
            else
                object.currentTimeKeyStackV2 = options.longs === String ? $util.Long.prototype.toString.call(message.currentTimeKeyStackV2) : options.longs === Number ? new $util.LongBits(message.currentTimeKeyStackV2.low >>> 0, message.currentTimeKeyStackV2.high >>> 0).toNumber(true) : message.currentTimeKeyStackV2;
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        if (message.epoch != null && message.hasOwnProperty("epoch"))
            if (typeof message.epoch === "number")
                object.epoch = options.longs === String ? String(message.epoch) : message.epoch;
            else
                object.epoch = options.longs === String ? $util.Long.prototype.toString.call(message.epoch) : options.longs === Number ? new $util.LongBits(message.epoch.low >>> 0, message.epoch.high >>> 0).toNumber(true) : message.epoch;
        if (message.connection != null && message.hasOwnProperty("connection"))
            if (typeof message.connection === "number")
                object.connection = options.longs === String ? String(message.connection) : message.connection;
            else
                object.connection = options.longs === String ? $util.Long.prototype.toString.call(message.connection) : options.longs === Number ? new $util.LongBits(message.connection.low >>> 0, message.connection.high >>> 0).toNumber(true) : message.connection;
        if (message.startTime != null && message.hasOwnProperty("startTime"))
            object.startTime = $root.VersionMsg.toObject(message.startTime, options);
        if (message.currentTime != null && message.hasOwnProperty("currentTime"))
            object.currentTime = $root.VersionMsg.toObject(message.currentTime, options);
        return object;
    };

    /**
     * Converts this ApplyDataMsg to JSON.
     * @function toJSON
     * @memberof ApplyDataMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApplyDataMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApplyDataMsg
     * @function getTypeUrl
     * @memberof ApplyDataMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApplyDataMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApplyDataMsg";
    };

    return ApplyDataMsg;
})();

export const InvokeProcMsg = $root.InvokeProcMsg = (() => {

    /**
     * Properties of an InvokeProcMsg.
     * @exports IInvokeProcMsg
     * @interface IInvokeProcMsg
     * @property {string} name InvokeProcMsg name
     * @property {Uint8Array|null} [args] InvokeProcMsg args
     * @property {Long|null} [maxKeys] InvokeProcMsg maxKeys
     * @property {Long|null} [maxSize] InvokeProcMsg maxSize
     * @property {Uint8Array|null} [cursor] InvokeProcMsg cursor
     */

    /**
     * Constructs a new InvokeProcMsg.
     * @exports InvokeProcMsg
     * @classdesc Represents an InvokeProcMsg.
     * @implements IInvokeProcMsg
     * @constructor
     * @param {IInvokeProcMsg=} [properties] Properties to set
     */
    function InvokeProcMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InvokeProcMsg name.
     * @member {string} name
     * @memberof InvokeProcMsg
     * @instance
     */
    InvokeProcMsg.prototype.name = "";

    /**
     * InvokeProcMsg args.
     * @member {Uint8Array} args
     * @memberof InvokeProcMsg
     * @instance
     */
    InvokeProcMsg.prototype.args = $util.newBuffer([]);

    /**
     * InvokeProcMsg maxKeys.
     * @member {Long} maxKeys
     * @memberof InvokeProcMsg
     * @instance
     */
    InvokeProcMsg.prototype.maxKeys = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * InvokeProcMsg maxSize.
     * @member {Long} maxSize
     * @memberof InvokeProcMsg
     * @instance
     */
    InvokeProcMsg.prototype.maxSize = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * InvokeProcMsg cursor.
     * @member {Uint8Array} cursor
     * @memberof InvokeProcMsg
     * @instance
     */
    InvokeProcMsg.prototype.cursor = $util.newBuffer([]);

    /**
     * Creates a new InvokeProcMsg instance using the specified properties.
     * @function create
     * @memberof InvokeProcMsg
     * @static
     * @param {IInvokeProcMsg=} [properties] Properties to set
     * @returns {InvokeProcMsg} InvokeProcMsg instance
     */
    InvokeProcMsg.create = function create(properties) {
        return new InvokeProcMsg(properties);
    };

    /**
     * Encodes the specified InvokeProcMsg message. Does not implicitly {@link InvokeProcMsg.verify|verify} messages.
     * @function encode
     * @memberof InvokeProcMsg
     * @static
     * @param {IInvokeProcMsg} message InvokeProcMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InvokeProcMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
        if (message.args != null && Object.hasOwnProperty.call(message, "args"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.args);
        if (message.maxKeys != null && Object.hasOwnProperty.call(message, "maxKeys"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.maxKeys);
        if (message.maxSize != null && Object.hasOwnProperty.call(message, "maxSize"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.maxSize);
        if (message.cursor != null && Object.hasOwnProperty.call(message, "cursor"))
            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.cursor);
        return writer;
    };

    /**
     * Decodes an InvokeProcMsg message from the specified reader or buffer.
     * @function decode
     * @memberof InvokeProcMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InvokeProcMsg} InvokeProcMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InvokeProcMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InvokeProcMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.name = reader.string();
                    break;
                }
            case 2: {
                    message.args = reader.bytes();
                    break;
                }
            case 3: {
                    message.maxKeys = reader.uint64();
                    break;
                }
            case 4: {
                    message.maxSize = reader.uint64();
                    break;
                }
            case 5: {
                    message.cursor = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("name"))
            throw $util.ProtocolError("missing required 'name'", { instance: message });
        return message;
    };

    /**
     * Creates an InvokeProcMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InvokeProcMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InvokeProcMsg} InvokeProcMsg
     */
    InvokeProcMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.InvokeProcMsg)
            return object;
        let message = new $root.InvokeProcMsg();
        if (object.name != null)
            message.name = String(object.name);
        if (object.args != null)
            if (typeof object.args === "string")
                $util.base64.decode(object.args, message.args = $util.newBuffer($util.base64.length(object.args)), 0);
            else if (object.args.length >= 0)
                message.args = object.args;
        if (object.maxKeys != null)
            if ($util.Long)
                (message.maxKeys = $util.Long.fromValue(object.maxKeys)).unsigned = true;
            else if (typeof object.maxKeys === "string")
                message.maxKeys = parseInt(object.maxKeys, 10);
            else if (typeof object.maxKeys === "number")
                message.maxKeys = object.maxKeys;
            else if (typeof object.maxKeys === "object")
                message.maxKeys = new $util.LongBits(object.maxKeys.low >>> 0, object.maxKeys.high >>> 0).toNumber(true);
        if (object.maxSize != null)
            if ($util.Long)
                (message.maxSize = $util.Long.fromValue(object.maxSize)).unsigned = true;
            else if (typeof object.maxSize === "string")
                message.maxSize = parseInt(object.maxSize, 10);
            else if (typeof object.maxSize === "number")
                message.maxSize = object.maxSize;
            else if (typeof object.maxSize === "object")
                message.maxSize = new $util.LongBits(object.maxSize.low >>> 0, object.maxSize.high >>> 0).toNumber(true);
        if (object.cursor != null)
            if (typeof object.cursor === "string")
                $util.base64.decode(object.cursor, message.cursor = $util.newBuffer($util.base64.length(object.cursor)), 0);
            else if (object.cursor.length >= 0)
                message.cursor = object.cursor;
        return message;
    };

    /**
     * Creates a plain object from an InvokeProcMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InvokeProcMsg
     * @static
     * @param {InvokeProcMsg} message InvokeProcMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InvokeProcMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.name = "";
            if (options.bytes === String)
                object.args = "";
            else {
                object.args = [];
                if (options.bytes !== Array)
                    object.args = $util.newBuffer(object.args);
            }
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.maxKeys = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.maxKeys = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.maxSize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.maxSize = options.longs === String ? "0" : 0;
            if (options.bytes === String)
                object.cursor = "";
            else {
                object.cursor = [];
                if (options.bytes !== Array)
                    object.cursor = $util.newBuffer(object.cursor);
            }
        }
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.args != null && message.hasOwnProperty("args"))
            object.args = options.bytes === String ? $util.base64.encode(message.args, 0, message.args.length) : options.bytes === Array ? Array.prototype.slice.call(message.args) : message.args;
        if (message.maxKeys != null && message.hasOwnProperty("maxKeys"))
            if (typeof message.maxKeys === "number")
                object.maxKeys = options.longs === String ? String(message.maxKeys) : message.maxKeys;
            else
                object.maxKeys = options.longs === String ? $util.Long.prototype.toString.call(message.maxKeys) : options.longs === Number ? new $util.LongBits(message.maxKeys.low >>> 0, message.maxKeys.high >>> 0).toNumber(true) : message.maxKeys;
        if (message.maxSize != null && message.hasOwnProperty("maxSize"))
            if (typeof message.maxSize === "number")
                object.maxSize = options.longs === String ? String(message.maxSize) : message.maxSize;
            else
                object.maxSize = options.longs === String ? $util.Long.prototype.toString.call(message.maxSize) : options.longs === Number ? new $util.LongBits(message.maxSize.low >>> 0, message.maxSize.high >>> 0).toNumber(true) : message.maxSize;
        if (message.cursor != null && message.hasOwnProperty("cursor"))
            object.cursor = options.bytes === String ? $util.base64.encode(message.cursor, 0, message.cursor.length) : options.bytes === Array ? Array.prototype.slice.call(message.cursor) : message.cursor;
        return object;
    };

    /**
     * Converts this InvokeProcMsg to JSON.
     * @function toJSON
     * @memberof InvokeProcMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InvokeProcMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InvokeProcMsg
     * @function getTypeUrl
     * @memberof InvokeProcMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InvokeProcMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InvokeProcMsg";
    };

    return InvokeProcMsg;
})();

export const MetaStoreResponseMsg = $root.MetaStoreResponseMsg = (() => {

    /**
     * Properties of a MetaStoreResponseMsg.
     * @exports IMetaStoreResponseMsg
     * @interface IMetaStoreResponseMsg
     * @property {MetaStoreResponseMsg.ResponseType} type MetaStoreResponseMsg type
     * @property {Long|null} [startTimeKeyStackV2] MetaStoreResponseMsg startTimeKeyStackV2
     * @property {Long|null} [currentTimeKeyStackV2] MetaStoreResponseMsg currentTimeKeyStackV2
     * @property {IFetchKeysResponse|null} [fetch] MetaStoreResponseMsg fetch
     * @property {IInvokeProcResponse|null} [invoke] MetaStoreResponseMsg invoke
     * @property {IApplyResponse|null} [apply] MetaStoreResponseMsg apply
     * @property {IVersionMsg|null} [startTime] MetaStoreResponseMsg startTime
     * @property {IVersionMsg|null} [currentTime] MetaStoreResponseMsg currentTime
     * @property {IVersionMsg|null} [knownClientTime] MetaStoreResponseMsg knownClientTime
     */

    /**
     * Constructs a new MetaStoreResponseMsg.
     * @exports MetaStoreResponseMsg
     * @classdesc Represents a MetaStoreResponseMsg.
     * @implements IMetaStoreResponseMsg
     * @constructor
     * @param {IMetaStoreResponseMsg=} [properties] Properties to set
     */
    function MetaStoreResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MetaStoreResponseMsg type.
     * @member {MetaStoreResponseMsg.ResponseType} type
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.type = 1;

    /**
     * MetaStoreResponseMsg startTimeKeyStackV2.
     * @member {Long} startTimeKeyStackV2
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.startTimeKeyStackV2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * MetaStoreResponseMsg currentTimeKeyStackV2.
     * @member {Long} currentTimeKeyStackV2
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.currentTimeKeyStackV2 = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * MetaStoreResponseMsg fetch.
     * @member {IFetchKeysResponse|null|undefined} fetch
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.fetch = null;

    /**
     * MetaStoreResponseMsg invoke.
     * @member {IInvokeProcResponse|null|undefined} invoke
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.invoke = null;

    /**
     * MetaStoreResponseMsg apply.
     * @member {IApplyResponse|null|undefined} apply
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.apply = null;

    /**
     * MetaStoreResponseMsg startTime.
     * @member {IVersionMsg|null|undefined} startTime
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.startTime = null;

    /**
     * MetaStoreResponseMsg currentTime.
     * @member {IVersionMsg|null|undefined} currentTime
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.currentTime = null;

    /**
     * MetaStoreResponseMsg knownClientTime.
     * @member {IVersionMsg|null|undefined} knownClientTime
     * @memberof MetaStoreResponseMsg
     * @instance
     */
    MetaStoreResponseMsg.prototype.knownClientTime = null;

    /**
     * Creates a new MetaStoreResponseMsg instance using the specified properties.
     * @function create
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {IMetaStoreResponseMsg=} [properties] Properties to set
     * @returns {MetaStoreResponseMsg} MetaStoreResponseMsg instance
     */
    MetaStoreResponseMsg.create = function create(properties) {
        return new MetaStoreResponseMsg(properties);
    };

    /**
     * Encodes the specified MetaStoreResponseMsg message. Does not implicitly {@link MetaStoreResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {IMetaStoreResponseMsg} message MetaStoreResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MetaStoreResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.startTimeKeyStackV2 != null && Object.hasOwnProperty.call(message, "startTimeKeyStackV2"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.startTimeKeyStackV2);
        if (message.currentTimeKeyStackV2 != null && Object.hasOwnProperty.call(message, "currentTimeKeyStackV2"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.currentTimeKeyStackV2);
        if (message.fetch != null && Object.hasOwnProperty.call(message, "fetch"))
            $root.FetchKeysResponse.encode(message.fetch, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.invoke != null && Object.hasOwnProperty.call(message, "invoke"))
            $root.InvokeProcResponse.encode(message.invoke, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.apply != null && Object.hasOwnProperty.call(message, "apply"))
            $root.ApplyResponse.encode(message.apply, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
            $root.VersionMsg.encode(message.startTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.currentTime != null && Object.hasOwnProperty.call(message, "currentTime"))
            $root.VersionMsg.encode(message.currentTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.knownClientTime != null && Object.hasOwnProperty.call(message, "knownClientTime"))
            $root.VersionMsg.encode(message.knownClientTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a MetaStoreResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MetaStoreResponseMsg} MetaStoreResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MetaStoreResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.MetaStoreResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.startTimeKeyStackV2 = reader.uint64();
                    break;
                }
            case 3: {
                    message.currentTimeKeyStackV2 = reader.uint64();
                    break;
                }
            case 4: {
                    message.fetch = $root.FetchKeysResponse.decode(reader, reader.uint32());
                    break;
                }
            case 5: {
                    message.invoke = $root.InvokeProcResponse.decode(reader, reader.uint32());
                    break;
                }
            case 6: {
                    message.apply = $root.ApplyResponse.decode(reader, reader.uint32());
                    break;
                }
            case 7: {
                    message.startTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            case 8: {
                    message.currentTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            case 9: {
                    message.knownClientTime = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a MetaStoreResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MetaStoreResponseMsg} MetaStoreResponseMsg
     */
    MetaStoreResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.MetaStoreResponseMsg)
            return object;
        let message = new $root.MetaStoreResponseMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "FETCH_DATA_RESPONSE":
        case 1:
            message.type = 1;
            break;
        case "APPLY_DATA_RESPONSE":
        case 2:
            message.type = 2;
            break;
        case "INVOKE_PROCEDURE_RESPONSE":
        case 3:
            message.type = 3;
            break;
        }
        if (object.startTimeKeyStackV2 != null)
            if ($util.Long)
                (message.startTimeKeyStackV2 = $util.Long.fromValue(object.startTimeKeyStackV2)).unsigned = true;
            else if (typeof object.startTimeKeyStackV2 === "string")
                message.startTimeKeyStackV2 = parseInt(object.startTimeKeyStackV2, 10);
            else if (typeof object.startTimeKeyStackV2 === "number")
                message.startTimeKeyStackV2 = object.startTimeKeyStackV2;
            else if (typeof object.startTimeKeyStackV2 === "object")
                message.startTimeKeyStackV2 = new $util.LongBits(object.startTimeKeyStackV2.low >>> 0, object.startTimeKeyStackV2.high >>> 0).toNumber(true);
        if (object.currentTimeKeyStackV2 != null)
            if ($util.Long)
                (message.currentTimeKeyStackV2 = $util.Long.fromValue(object.currentTimeKeyStackV2)).unsigned = true;
            else if (typeof object.currentTimeKeyStackV2 === "string")
                message.currentTimeKeyStackV2 = parseInt(object.currentTimeKeyStackV2, 10);
            else if (typeof object.currentTimeKeyStackV2 === "number")
                message.currentTimeKeyStackV2 = object.currentTimeKeyStackV2;
            else if (typeof object.currentTimeKeyStackV2 === "object")
                message.currentTimeKeyStackV2 = new $util.LongBits(object.currentTimeKeyStackV2.low >>> 0, object.currentTimeKeyStackV2.high >>> 0).toNumber(true);
        if (object.fetch != null) {
            if (typeof object.fetch !== "object")
                throw TypeError(".MetaStoreResponseMsg.fetch: object expected");
            message.fetch = $root.FetchKeysResponse.fromObject(object.fetch);
        }
        if (object.invoke != null) {
            if (typeof object.invoke !== "object")
                throw TypeError(".MetaStoreResponseMsg.invoke: object expected");
            message.invoke = $root.InvokeProcResponse.fromObject(object.invoke);
        }
        if (object.apply != null) {
            if (typeof object.apply !== "object")
                throw TypeError(".MetaStoreResponseMsg.apply: object expected");
            message.apply = $root.ApplyResponse.fromObject(object.apply);
        }
        if (object.startTime != null) {
            if (typeof object.startTime !== "object")
                throw TypeError(".MetaStoreResponseMsg.startTime: object expected");
            message.startTime = $root.VersionMsg.fromObject(object.startTime);
        }
        if (object.currentTime != null) {
            if (typeof object.currentTime !== "object")
                throw TypeError(".MetaStoreResponseMsg.currentTime: object expected");
            message.currentTime = $root.VersionMsg.fromObject(object.currentTime);
        }
        if (object.knownClientTime != null) {
            if (typeof object.knownClientTime !== "object")
                throw TypeError(".MetaStoreResponseMsg.knownClientTime: object expected");
            message.knownClientTime = $root.VersionMsg.fromObject(object.knownClientTime);
        }
        return message;
    };

    /**
     * Creates a plain object from a MetaStoreResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {MetaStoreResponseMsg} message MetaStoreResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MetaStoreResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "FETCH_DATA_RESPONSE" : 1;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.startTimeKeyStackV2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.startTimeKeyStackV2 = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.currentTimeKeyStackV2 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.currentTimeKeyStackV2 = options.longs === String ? "0" : 0;
            object.fetch = null;
            object.invoke = null;
            object.apply = null;
            object.startTime = null;
            object.currentTime = null;
            object.knownClientTime = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.MetaStoreResponseMsg.ResponseType[message.type] === undefined ? message.type : $root.MetaStoreResponseMsg.ResponseType[message.type] : message.type;
        if (message.startTimeKeyStackV2 != null && message.hasOwnProperty("startTimeKeyStackV2"))
            if (typeof message.startTimeKeyStackV2 === "number")
                object.startTimeKeyStackV2 = options.longs === String ? String(message.startTimeKeyStackV2) : message.startTimeKeyStackV2;
            else
                object.startTimeKeyStackV2 = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeKeyStackV2) : options.longs === Number ? new $util.LongBits(message.startTimeKeyStackV2.low >>> 0, message.startTimeKeyStackV2.high >>> 0).toNumber(true) : message.startTimeKeyStackV2;
        if (message.currentTimeKeyStackV2 != null && message.hasOwnProperty("currentTimeKeyStackV2"))
            if (typeof message.currentTimeKeyStackV2 === "number")
                object.currentTimeKeyStackV2 = options.longs === String ? String(message.currentTimeKeyStackV2) : message.currentTimeKeyStackV2;
            else
                object.currentTimeKeyStackV2 = options.longs === String ? $util.Long.prototype.toString.call(message.currentTimeKeyStackV2) : options.longs === Number ? new $util.LongBits(message.currentTimeKeyStackV2.low >>> 0, message.currentTimeKeyStackV2.high >>> 0).toNumber(true) : message.currentTimeKeyStackV2;
        if (message.fetch != null && message.hasOwnProperty("fetch"))
            object.fetch = $root.FetchKeysResponse.toObject(message.fetch, options);
        if (message.invoke != null && message.hasOwnProperty("invoke"))
            object.invoke = $root.InvokeProcResponse.toObject(message.invoke, options);
        if (message.apply != null && message.hasOwnProperty("apply"))
            object.apply = $root.ApplyResponse.toObject(message.apply, options);
        if (message.startTime != null && message.hasOwnProperty("startTime"))
            object.startTime = $root.VersionMsg.toObject(message.startTime, options);
        if (message.currentTime != null && message.hasOwnProperty("currentTime"))
            object.currentTime = $root.VersionMsg.toObject(message.currentTime, options);
        if (message.knownClientTime != null && message.hasOwnProperty("knownClientTime"))
            object.knownClientTime = $root.VersionMsg.toObject(message.knownClientTime, options);
        return object;
    };

    /**
     * Converts this MetaStoreResponseMsg to JSON.
     * @function toJSON
     * @memberof MetaStoreResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MetaStoreResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for MetaStoreResponseMsg
     * @function getTypeUrl
     * @memberof MetaStoreResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    MetaStoreResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/MetaStoreResponseMsg";
    };

    /**
     * ResponseType enum.
     * @name MetaStoreResponseMsg.ResponseType
     * @enum {number}
     * @property {number} FETCH_DATA_RESPONSE=1 FETCH_DATA_RESPONSE value
     * @property {number} APPLY_DATA_RESPONSE=2 APPLY_DATA_RESPONSE value
     * @property {number} INVOKE_PROCEDURE_RESPONSE=3 INVOKE_PROCEDURE_RESPONSE value
     */
    MetaStoreResponseMsg.ResponseType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "FETCH_DATA_RESPONSE"] = 1;
        values[valuesById[2] = "APPLY_DATA_RESPONSE"] = 2;
        values[valuesById[3] = "INVOKE_PROCEDURE_RESPONSE"] = 3;
        return values;
    })();

    return MetaStoreResponseMsg;
})();

export const FetchKeysResponse = $root.FetchKeysResponse = (() => {

    /**
     * Properties of a FetchKeysResponse.
     * @exports IFetchKeysResponse
     * @interface IFetchKeysResponse
     * @property {IKeyRangeDataMsg} data FetchKeysResponse data
     * @property {Uint8Array|null} [cursor] FetchKeysResponse cursor
     */

    /**
     * Constructs a new FetchKeysResponse.
     * @exports FetchKeysResponse
     * @classdesc Represents a FetchKeysResponse.
     * @implements IFetchKeysResponse
     * @constructor
     * @param {IFetchKeysResponse=} [properties] Properties to set
     */
    function FetchKeysResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FetchKeysResponse data.
     * @member {IKeyRangeDataMsg} data
     * @memberof FetchKeysResponse
     * @instance
     */
    FetchKeysResponse.prototype.data = null;

    /**
     * FetchKeysResponse cursor.
     * @member {Uint8Array} cursor
     * @memberof FetchKeysResponse
     * @instance
     */
    FetchKeysResponse.prototype.cursor = $util.newBuffer([]);

    /**
     * Creates a new FetchKeysResponse instance using the specified properties.
     * @function create
     * @memberof FetchKeysResponse
     * @static
     * @param {IFetchKeysResponse=} [properties] Properties to set
     * @returns {FetchKeysResponse} FetchKeysResponse instance
     */
    FetchKeysResponse.create = function create(properties) {
        return new FetchKeysResponse(properties);
    };

    /**
     * Encodes the specified FetchKeysResponse message. Does not implicitly {@link FetchKeysResponse.verify|verify} messages.
     * @function encode
     * @memberof FetchKeysResponse
     * @static
     * @param {IFetchKeysResponse} message FetchKeysResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FetchKeysResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        $root.KeyRangeDataMsg.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.cursor != null && Object.hasOwnProperty.call(message, "cursor"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.cursor);
        return writer;
    };

    /**
     * Decodes a FetchKeysResponse message from the specified reader or buffer.
     * @function decode
     * @memberof FetchKeysResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FetchKeysResponse} FetchKeysResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FetchKeysResponse.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.FetchKeysResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.data = $root.KeyRangeDataMsg.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.cursor = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("data"))
            throw $util.ProtocolError("missing required 'data'", { instance: message });
        return message;
    };

    /**
     * Creates a FetchKeysResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FetchKeysResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FetchKeysResponse} FetchKeysResponse
     */
    FetchKeysResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.FetchKeysResponse)
            return object;
        let message = new $root.FetchKeysResponse();
        if (object.data != null) {
            if (typeof object.data !== "object")
                throw TypeError(".FetchKeysResponse.data: object expected");
            message.data = $root.KeyRangeDataMsg.fromObject(object.data);
        }
        if (object.cursor != null)
            if (typeof object.cursor === "string")
                $util.base64.decode(object.cursor, message.cursor = $util.newBuffer($util.base64.length(object.cursor)), 0);
            else if (object.cursor.length >= 0)
                message.cursor = object.cursor;
        return message;
    };

    /**
     * Creates a plain object from a FetchKeysResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FetchKeysResponse
     * @static
     * @param {FetchKeysResponse} message FetchKeysResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FetchKeysResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.data = null;
            if (options.bytes === String)
                object.cursor = "";
            else {
                object.cursor = [];
                if (options.bytes !== Array)
                    object.cursor = $util.newBuffer(object.cursor);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = $root.KeyRangeDataMsg.toObject(message.data, options);
        if (message.cursor != null && message.hasOwnProperty("cursor"))
            object.cursor = options.bytes === String ? $util.base64.encode(message.cursor, 0, message.cursor.length) : options.bytes === Array ? Array.prototype.slice.call(message.cursor) : message.cursor;
        return object;
    };

    /**
     * Converts this FetchKeysResponse to JSON.
     * @function toJSON
     * @memberof FetchKeysResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FetchKeysResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for FetchKeysResponse
     * @function getTypeUrl
     * @memberof FetchKeysResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    FetchKeysResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/FetchKeysResponse";
    };

    return FetchKeysResponse;
})();

export const InvokeProcResponse = $root.InvokeProcResponse = (() => {

    /**
     * Properties of an InvokeProcResponse.
     * @exports IInvokeProcResponse
     * @interface IInvokeProcResponse
     * @property {Uint8Array|null} [scalarResult] InvokeProcResponse scalarResult
     * @property {Uint8Array|null} [cursor] InvokeProcResponse cursor
     * @property {Array.<IKeyRangeDataMsg>|null} [dataResult] InvokeProcResponse dataResult
     */

    /**
     * Constructs a new InvokeProcResponse.
     * @exports InvokeProcResponse
     * @classdesc Represents an InvokeProcResponse.
     * @implements IInvokeProcResponse
     * @constructor
     * @param {IInvokeProcResponse=} [properties] Properties to set
     */
    function InvokeProcResponse(properties) {
        this.dataResult = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * InvokeProcResponse scalarResult.
     * @member {Uint8Array} scalarResult
     * @memberof InvokeProcResponse
     * @instance
     */
    InvokeProcResponse.prototype.scalarResult = $util.newBuffer([]);

    /**
     * InvokeProcResponse cursor.
     * @member {Uint8Array} cursor
     * @memberof InvokeProcResponse
     * @instance
     */
    InvokeProcResponse.prototype.cursor = $util.newBuffer([]);

    /**
     * InvokeProcResponse dataResult.
     * @member {Array.<IKeyRangeDataMsg>} dataResult
     * @memberof InvokeProcResponse
     * @instance
     */
    InvokeProcResponse.prototype.dataResult = $util.emptyArray;

    /**
     * Creates a new InvokeProcResponse instance using the specified properties.
     * @function create
     * @memberof InvokeProcResponse
     * @static
     * @param {IInvokeProcResponse=} [properties] Properties to set
     * @returns {InvokeProcResponse} InvokeProcResponse instance
     */
    InvokeProcResponse.create = function create(properties) {
        return new InvokeProcResponse(properties);
    };

    /**
     * Encodes the specified InvokeProcResponse message. Does not implicitly {@link InvokeProcResponse.verify|verify} messages.
     * @function encode
     * @memberof InvokeProcResponse
     * @static
     * @param {IInvokeProcResponse} message InvokeProcResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    InvokeProcResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.scalarResult != null && Object.hasOwnProperty.call(message, "scalarResult"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.scalarResult);
        if (message.cursor != null && Object.hasOwnProperty.call(message, "cursor"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.cursor);
        if (message.dataResult != null && message.dataResult.length)
            for (let i = 0; i < message.dataResult.length; ++i)
                $root.KeyRangeDataMsg.encode(message.dataResult[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes an InvokeProcResponse message from the specified reader or buffer.
     * @function decode
     * @memberof InvokeProcResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {InvokeProcResponse} InvokeProcResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    InvokeProcResponse.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.InvokeProcResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.scalarResult = reader.bytes();
                    break;
                }
            case 2: {
                    message.cursor = reader.bytes();
                    break;
                }
            case 3: {
                    if (!(message.dataResult && message.dataResult.length))
                        message.dataResult = [];
                    message.dataResult.push($root.KeyRangeDataMsg.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates an InvokeProcResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof InvokeProcResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {InvokeProcResponse} InvokeProcResponse
     */
    InvokeProcResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.InvokeProcResponse)
            return object;
        let message = new $root.InvokeProcResponse();
        if (object.scalarResult != null)
            if (typeof object.scalarResult === "string")
                $util.base64.decode(object.scalarResult, message.scalarResult = $util.newBuffer($util.base64.length(object.scalarResult)), 0);
            else if (object.scalarResult.length >= 0)
                message.scalarResult = object.scalarResult;
        if (object.cursor != null)
            if (typeof object.cursor === "string")
                $util.base64.decode(object.cursor, message.cursor = $util.newBuffer($util.base64.length(object.cursor)), 0);
            else if (object.cursor.length >= 0)
                message.cursor = object.cursor;
        if (object.dataResult) {
            if (!Array.isArray(object.dataResult))
                throw TypeError(".InvokeProcResponse.dataResult: array expected");
            message.dataResult = [];
            for (let i = 0; i < object.dataResult.length; ++i) {
                if (typeof object.dataResult[i] !== "object")
                    throw TypeError(".InvokeProcResponse.dataResult: object expected");
                message.dataResult[i] = $root.KeyRangeDataMsg.fromObject(object.dataResult[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from an InvokeProcResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof InvokeProcResponse
     * @static
     * @param {InvokeProcResponse} message InvokeProcResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    InvokeProcResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.dataResult = [];
        if (options.defaults) {
            if (options.bytes === String)
                object.scalarResult = "";
            else {
                object.scalarResult = [];
                if (options.bytes !== Array)
                    object.scalarResult = $util.newBuffer(object.scalarResult);
            }
            if (options.bytes === String)
                object.cursor = "";
            else {
                object.cursor = [];
                if (options.bytes !== Array)
                    object.cursor = $util.newBuffer(object.cursor);
            }
        }
        if (message.scalarResult != null && message.hasOwnProperty("scalarResult"))
            object.scalarResult = options.bytes === String ? $util.base64.encode(message.scalarResult, 0, message.scalarResult.length) : options.bytes === Array ? Array.prototype.slice.call(message.scalarResult) : message.scalarResult;
        if (message.cursor != null && message.hasOwnProperty("cursor"))
            object.cursor = options.bytes === String ? $util.base64.encode(message.cursor, 0, message.cursor.length) : options.bytes === Array ? Array.prototype.slice.call(message.cursor) : message.cursor;
        if (message.dataResult && message.dataResult.length) {
            object.dataResult = [];
            for (let j = 0; j < message.dataResult.length; ++j)
                object.dataResult[j] = $root.KeyRangeDataMsg.toObject(message.dataResult[j], options);
        }
        return object;
    };

    /**
     * Converts this InvokeProcResponse to JSON.
     * @function toJSON
     * @memberof InvokeProcResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    InvokeProcResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for InvokeProcResponse
     * @function getTypeUrl
     * @memberof InvokeProcResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    InvokeProcResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/InvokeProcResponse";
    };

    return InvokeProcResponse;
})();

export const ApplyResponse = $root.ApplyResponse = (() => {

    /**
     * Properties of an ApplyResponse.
     * @exports IApplyResponse
     * @interface IApplyResponse
     * @property {boolean|null} [conflictsDetected] ApplyResponse conflictsDetected
     */

    /**
     * Constructs a new ApplyResponse.
     * @exports ApplyResponse
     * @classdesc Represents an ApplyResponse.
     * @implements IApplyResponse
     * @constructor
     * @param {IApplyResponse=} [properties] Properties to set
     */
    function ApplyResponse(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ApplyResponse conflictsDetected.
     * @member {boolean} conflictsDetected
     * @memberof ApplyResponse
     * @instance
     */
    ApplyResponse.prototype.conflictsDetected = false;

    /**
     * Creates a new ApplyResponse instance using the specified properties.
     * @function create
     * @memberof ApplyResponse
     * @static
     * @param {IApplyResponse=} [properties] Properties to set
     * @returns {ApplyResponse} ApplyResponse instance
     */
    ApplyResponse.create = function create(properties) {
        return new ApplyResponse(properties);
    };

    /**
     * Encodes the specified ApplyResponse message. Does not implicitly {@link ApplyResponse.verify|verify} messages.
     * @function encode
     * @memberof ApplyResponse
     * @static
     * @param {IApplyResponse} message ApplyResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ApplyResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.conflictsDetected != null && Object.hasOwnProperty.call(message, "conflictsDetected"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.conflictsDetected);
        return writer;
    };

    /**
     * Decodes an ApplyResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ApplyResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ApplyResponse} ApplyResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ApplyResponse.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ApplyResponse();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.conflictsDetected = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates an ApplyResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ApplyResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ApplyResponse} ApplyResponse
     */
    ApplyResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.ApplyResponse)
            return object;
        let message = new $root.ApplyResponse();
        if (object.conflictsDetected != null)
            message.conflictsDetected = Boolean(object.conflictsDetected);
        return message;
    };

    /**
     * Creates a plain object from an ApplyResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ApplyResponse
     * @static
     * @param {ApplyResponse} message ApplyResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ApplyResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.conflictsDetected = false;
        if (message.conflictsDetected != null && message.hasOwnProperty("conflictsDetected"))
            object.conflictsDetected = message.conflictsDetected;
        return object;
    };

    /**
     * Converts this ApplyResponse to JSON.
     * @function toJSON
     * @memberof ApplyResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ApplyResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ApplyResponse
     * @function getTypeUrl
     * @memberof ApplyResponse
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ApplyResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ApplyResponse";
    };

    return ApplyResponse;
})();

export const ConflictedTransactionMsg = $root.ConflictedTransactionMsg = (() => {

    /**
     * Properties of a ConflictedTransactionMsg.
     * @exports IConflictedTransactionMsg
     * @interface IConflictedTransactionMsg
     * @property {Array.<ServiceBaseProto.IKeyValueMsg>|null} [data] ConflictedTransactionMsg data
     */

    /**
     * Constructs a new ConflictedTransactionMsg.
     * @exports ConflictedTransactionMsg
     * @classdesc Represents a ConflictedTransactionMsg.
     * @implements IConflictedTransactionMsg
     * @constructor
     * @param {IConflictedTransactionMsg=} [properties] Properties to set
     */
    function ConflictedTransactionMsg(properties) {
        this.data = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ConflictedTransactionMsg data.
     * @member {Array.<ServiceBaseProto.IKeyValueMsg>} data
     * @memberof ConflictedTransactionMsg
     * @instance
     */
    ConflictedTransactionMsg.prototype.data = $util.emptyArray;

    /**
     * Creates a new ConflictedTransactionMsg instance using the specified properties.
     * @function create
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {IConflictedTransactionMsg=} [properties] Properties to set
     * @returns {ConflictedTransactionMsg} ConflictedTransactionMsg instance
     */
    ConflictedTransactionMsg.create = function create(properties) {
        return new ConflictedTransactionMsg(properties);
    };

    /**
     * Encodes the specified ConflictedTransactionMsg message. Does not implicitly {@link ConflictedTransactionMsg.verify|verify} messages.
     * @function encode
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {IConflictedTransactionMsg} message ConflictedTransactionMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConflictedTransactionMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && message.data.length)
            for (let i = 0; i < message.data.length; ++i)
                $root.ServiceBaseProto.KeyValueMsg.encode(message.data[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a ConflictedTransactionMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ConflictedTransactionMsg} ConflictedTransactionMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConflictedTransactionMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConflictedTransactionMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.data && message.data.length))
                        message.data = [];
                    message.data.push($root.ServiceBaseProto.KeyValueMsg.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a ConflictedTransactionMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ConflictedTransactionMsg} ConflictedTransactionMsg
     */
    ConflictedTransactionMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.ConflictedTransactionMsg)
            return object;
        let message = new $root.ConflictedTransactionMsg();
        if (object.data) {
            if (!Array.isArray(object.data))
                throw TypeError(".ConflictedTransactionMsg.data: array expected");
            message.data = [];
            for (let i = 0; i < object.data.length; ++i) {
                if (typeof object.data[i] !== "object")
                    throw TypeError(".ConflictedTransactionMsg.data: object expected");
                message.data[i] = $root.ServiceBaseProto.KeyValueMsg.fromObject(object.data[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ConflictedTransactionMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {ConflictedTransactionMsg} message ConflictedTransactionMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ConflictedTransactionMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.data = [];
        if (message.data && message.data.length) {
            object.data = [];
            for (let j = 0; j < message.data.length; ++j)
                object.data[j] = $root.ServiceBaseProto.KeyValueMsg.toObject(message.data[j], options);
        }
        return object;
    };

    /**
     * Converts this ConflictedTransactionMsg to JSON.
     * @function toJSON
     * @memberof ConflictedTransactionMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ConflictedTransactionMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ConflictedTransactionMsg
     * @function getTypeUrl
     * @memberof ConflictedTransactionMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ConflictedTransactionMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ConflictedTransactionMsg";
    };

    return ConflictedTransactionMsg;
})();

export const ConflictErrorResponseMsg = $root.ConflictErrorResponseMsg = (() => {

    /**
     * Properties of a ConflictErrorResponseMsg.
     * @exports IConflictErrorResponseMsg
     * @interface IConflictErrorResponseMsg
     * @property {Array.<IConflictedTransactionMsg>|null} [transactions] ConflictErrorResponseMsg transactions
     */

    /**
     * Constructs a new ConflictErrorResponseMsg.
     * @exports ConflictErrorResponseMsg
     * @classdesc Represents a ConflictErrorResponseMsg.
     * @implements IConflictErrorResponseMsg
     * @constructor
     * @param {IConflictErrorResponseMsg=} [properties] Properties to set
     */
    function ConflictErrorResponseMsg(properties) {
        this.transactions = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ConflictErrorResponseMsg transactions.
     * @member {Array.<IConflictedTransactionMsg>} transactions
     * @memberof ConflictErrorResponseMsg
     * @instance
     */
    ConflictErrorResponseMsg.prototype.transactions = $util.emptyArray;

    /**
     * Creates a new ConflictErrorResponseMsg instance using the specified properties.
     * @function create
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {IConflictErrorResponseMsg=} [properties] Properties to set
     * @returns {ConflictErrorResponseMsg} ConflictErrorResponseMsg instance
     */
    ConflictErrorResponseMsg.create = function create(properties) {
        return new ConflictErrorResponseMsg(properties);
    };

    /**
     * Encodes the specified ConflictErrorResponseMsg message. Does not implicitly {@link ConflictErrorResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {IConflictErrorResponseMsg} message ConflictErrorResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ConflictErrorResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.transactions != null && message.transactions.length)
            for (let i = 0; i < message.transactions.length; ++i)
                $root.ConflictedTransactionMsg.encode(message.transactions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a ConflictErrorResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ConflictErrorResponseMsg} ConflictErrorResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ConflictErrorResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ConflictErrorResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.transactions && message.transactions.length))
                        message.transactions = [];
                    message.transactions.push($root.ConflictedTransactionMsg.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a ConflictErrorResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ConflictErrorResponseMsg} ConflictErrorResponseMsg
     */
    ConflictErrorResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.ConflictErrorResponseMsg)
            return object;
        let message = new $root.ConflictErrorResponseMsg();
        if (object.transactions) {
            if (!Array.isArray(object.transactions))
                throw TypeError(".ConflictErrorResponseMsg.transactions: array expected");
            message.transactions = [];
            for (let i = 0; i < object.transactions.length; ++i) {
                if (typeof object.transactions[i] !== "object")
                    throw TypeError(".ConflictErrorResponseMsg.transactions: object expected");
                message.transactions[i] = $root.ConflictedTransactionMsg.fromObject(object.transactions[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ConflictErrorResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {ConflictErrorResponseMsg} message ConflictErrorResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ConflictErrorResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.transactions = [];
        if (message.transactions && message.transactions.length) {
            object.transactions = [];
            for (let j = 0; j < message.transactions.length; ++j)
                object.transactions[j] = $root.ConflictedTransactionMsg.toObject(message.transactions[j], options);
        }
        return object;
    };

    /**
     * Converts this ConflictErrorResponseMsg to JSON.
     * @function toJSON
     * @memberof ConflictErrorResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ConflictErrorResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ConflictErrorResponseMsg
     * @function getTypeUrl
     * @memberof ConflictErrorResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ConflictErrorResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ConflictErrorResponseMsg";
    };

    return ConflictErrorResponseMsg;
})();

export const CheckConstraintErrorResponseMsg = $root.CheckConstraintErrorResponseMsg = (() => {

    /**
     * Properties of a CheckConstraintErrorResponseMsg.
     * @exports ICheckConstraintErrorResponseMsg
     * @interface ICheckConstraintErrorResponseMsg
     * @property {Uint8Array|null} [details] CheckConstraintErrorResponseMsg details
     * @property {IVersionMsg|null} [committedWatermark] CheckConstraintErrorResponseMsg committedWatermark
     */

    /**
     * Constructs a new CheckConstraintErrorResponseMsg.
     * @exports CheckConstraintErrorResponseMsg
     * @classdesc Represents a CheckConstraintErrorResponseMsg.
     * @implements ICheckConstraintErrorResponseMsg
     * @constructor
     * @param {ICheckConstraintErrorResponseMsg=} [properties] Properties to set
     */
    function CheckConstraintErrorResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CheckConstraintErrorResponseMsg details.
     * @member {Uint8Array} details
     * @memberof CheckConstraintErrorResponseMsg
     * @instance
     */
    CheckConstraintErrorResponseMsg.prototype.details = $util.newBuffer([]);

    /**
     * CheckConstraintErrorResponseMsg committedWatermark.
     * @member {IVersionMsg|null|undefined} committedWatermark
     * @memberof CheckConstraintErrorResponseMsg
     * @instance
     */
    CheckConstraintErrorResponseMsg.prototype.committedWatermark = null;

    /**
     * Creates a new CheckConstraintErrorResponseMsg instance using the specified properties.
     * @function create
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {ICheckConstraintErrorResponseMsg=} [properties] Properties to set
     * @returns {CheckConstraintErrorResponseMsg} CheckConstraintErrorResponseMsg instance
     */
    CheckConstraintErrorResponseMsg.create = function create(properties) {
        return new CheckConstraintErrorResponseMsg(properties);
    };

    /**
     * Encodes the specified CheckConstraintErrorResponseMsg message. Does not implicitly {@link CheckConstraintErrorResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {ICheckConstraintErrorResponseMsg} message CheckConstraintErrorResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CheckConstraintErrorResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.details);
        if (message.committedWatermark != null && Object.hasOwnProperty.call(message, "committedWatermark"))
            $root.VersionMsg.encode(message.committedWatermark, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a CheckConstraintErrorResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CheckConstraintErrorResponseMsg} CheckConstraintErrorResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CheckConstraintErrorResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CheckConstraintErrorResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.details = reader.bytes();
                    break;
                }
            case 2: {
                    message.committedWatermark = $root.VersionMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a CheckConstraintErrorResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CheckConstraintErrorResponseMsg} CheckConstraintErrorResponseMsg
     */
    CheckConstraintErrorResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.CheckConstraintErrorResponseMsg)
            return object;
        let message = new $root.CheckConstraintErrorResponseMsg();
        if (object.details != null)
            if (typeof object.details === "string")
                $util.base64.decode(object.details, message.details = $util.newBuffer($util.base64.length(object.details)), 0);
            else if (object.details.length >= 0)
                message.details = object.details;
        if (object.committedWatermark != null) {
            if (typeof object.committedWatermark !== "object")
                throw TypeError(".CheckConstraintErrorResponseMsg.committedWatermark: object expected");
            message.committedWatermark = $root.VersionMsg.fromObject(object.committedWatermark);
        }
        return message;
    };

    /**
     * Creates a plain object from a CheckConstraintErrorResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {CheckConstraintErrorResponseMsg} message CheckConstraintErrorResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CheckConstraintErrorResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.details = "";
            else {
                object.details = [];
                if (options.bytes !== Array)
                    object.details = $util.newBuffer(object.details);
            }
            object.committedWatermark = null;
        }
        if (message.details != null && message.hasOwnProperty("details"))
            object.details = options.bytes === String ? $util.base64.encode(message.details, 0, message.details.length) : options.bytes === Array ? Array.prototype.slice.call(message.details) : message.details;
        if (message.committedWatermark != null && message.hasOwnProperty("committedWatermark"))
            object.committedWatermark = $root.VersionMsg.toObject(message.committedWatermark, options);
        return object;
    };

    /**
     * Converts this CheckConstraintErrorResponseMsg to JSON.
     * @function toJSON
     * @memberof CheckConstraintErrorResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CheckConstraintErrorResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CheckConstraintErrorResponseMsg
     * @function getTypeUrl
     * @memberof CheckConstraintErrorResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CheckConstraintErrorResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CheckConstraintErrorResponseMsg";
    };

    return CheckConstraintErrorResponseMsg;
})();

export const CounterRequestMsg = $root.CounterRequestMsg = (() => {

    /**
     * Properties of a CounterRequestMsg.
     * @exports ICounterRequestMsg
     * @interface ICounterRequestMsg
     * @property {CounterRequestMsg.OperationType} operation CounterRequestMsg operation
     * @property {string} counterName CounterRequestMsg counterName
     * @property {Long} counterValue CounterRequestMsg counterValue
     */

    /**
     * Constructs a new CounterRequestMsg.
     * @exports CounterRequestMsg
     * @classdesc Represents a CounterRequestMsg.
     * @implements ICounterRequestMsg
     * @constructor
     * @param {ICounterRequestMsg=} [properties] Properties to set
     */
    function CounterRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CounterRequestMsg operation.
     * @member {CounterRequestMsg.OperationType} operation
     * @memberof CounterRequestMsg
     * @instance
     */
    CounterRequestMsg.prototype.operation = 1;

    /**
     * CounterRequestMsg counterName.
     * @member {string} counterName
     * @memberof CounterRequestMsg
     * @instance
     */
    CounterRequestMsg.prototype.counterName = "";

    /**
     * CounterRequestMsg counterValue.
     * @member {Long} counterValue
     * @memberof CounterRequestMsg
     * @instance
     */
    CounterRequestMsg.prototype.counterValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new CounterRequestMsg instance using the specified properties.
     * @function create
     * @memberof CounterRequestMsg
     * @static
     * @param {ICounterRequestMsg=} [properties] Properties to set
     * @returns {CounterRequestMsg} CounterRequestMsg instance
     */
    CounterRequestMsg.create = function create(properties) {
        return new CounterRequestMsg(properties);
    };

    /**
     * Encodes the specified CounterRequestMsg message. Does not implicitly {@link CounterRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof CounterRequestMsg
     * @static
     * @param {ICounterRequestMsg} message CounterRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.operation);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.counterName);
        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.counterValue);
        return writer;
    };

    /**
     * Decodes a CounterRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof CounterRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CounterRequestMsg} CounterRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CounterRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.operation = reader.int32();
                    break;
                }
            case 2: {
                    message.counterName = reader.string();
                    break;
                }
            case 3: {
                    message.counterValue = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        if (!message.hasOwnProperty("counterName"))
            throw $util.ProtocolError("missing required 'counterName'", { instance: message });
        if (!message.hasOwnProperty("counterValue"))
            throw $util.ProtocolError("missing required 'counterValue'", { instance: message });
        return message;
    };

    /**
     * Creates a CounterRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CounterRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CounterRequestMsg} CounterRequestMsg
     */
    CounterRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.CounterRequestMsg)
            return object;
        let message = new $root.CounterRequestMsg();
        switch (object.operation) {
        default:
            if (typeof object.operation === "number") {
                message.operation = object.operation;
                break;
            }
            break;
        case "EXCHANGE_COUNTER":
        case 1:
            message.operation = 1;
            break;
        case "INCREMENT_COUNTER":
        case 2:
            message.operation = 2;
            break;
        }
        if (object.counterName != null)
            message.counterName = String(object.counterName);
        if (object.counterValue != null)
            if ($util.Long)
                (message.counterValue = $util.Long.fromValue(object.counterValue)).unsigned = false;
            else if (typeof object.counterValue === "string")
                message.counterValue = parseInt(object.counterValue, 10);
            else if (typeof object.counterValue === "number")
                message.counterValue = object.counterValue;
            else if (typeof object.counterValue === "object")
                message.counterValue = new $util.LongBits(object.counterValue.low >>> 0, object.counterValue.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a CounterRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CounterRequestMsg
     * @static
     * @param {CounterRequestMsg} message CounterRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CounterRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.operation = options.enums === String ? "EXCHANGE_COUNTER" : 1;
            object.counterName = "";
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.counterValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.counterValue = options.longs === String ? "0" : 0;
        }
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.CounterRequestMsg.OperationType[message.operation] === undefined ? message.operation : $root.CounterRequestMsg.OperationType[message.operation] : message.operation;
        if (message.counterName != null && message.hasOwnProperty("counterName"))
            object.counterName = message.counterName;
        if (message.counterValue != null && message.hasOwnProperty("counterValue"))
            if (typeof message.counterValue === "number")
                object.counterValue = options.longs === String ? String(message.counterValue) : message.counterValue;
            else
                object.counterValue = options.longs === String ? $util.Long.prototype.toString.call(message.counterValue) : options.longs === Number ? new $util.LongBits(message.counterValue.low >>> 0, message.counterValue.high >>> 0).toNumber() : message.counterValue;
        return object;
    };

    /**
     * Converts this CounterRequestMsg to JSON.
     * @function toJSON
     * @memberof CounterRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CounterRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CounterRequestMsg
     * @function getTypeUrl
     * @memberof CounterRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CounterRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CounterRequestMsg";
    };

    /**
     * OperationType enum.
     * @name CounterRequestMsg.OperationType
     * @enum {number}
     * @property {number} EXCHANGE_COUNTER=1 EXCHANGE_COUNTER value
     * @property {number} INCREMENT_COUNTER=2 INCREMENT_COUNTER value
     */
    CounterRequestMsg.OperationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "EXCHANGE_COUNTER"] = 1;
        values[valuesById[2] = "INCREMENT_COUNTER"] = 2;
        return values;
    })();

    return CounterRequestMsg;
})();

export const CounterResponseMsg = $root.CounterResponseMsg = (() => {

    /**
     * Properties of a CounterResponseMsg.
     * @exports ICounterResponseMsg
     * @interface ICounterResponseMsg
     * @property {Long} counterValue CounterResponseMsg counterValue
     */

    /**
     * Constructs a new CounterResponseMsg.
     * @exports CounterResponseMsg
     * @classdesc Represents a CounterResponseMsg.
     * @implements ICounterResponseMsg
     * @constructor
     * @param {ICounterResponseMsg=} [properties] Properties to set
     */
    function CounterResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CounterResponseMsg counterValue.
     * @member {Long} counterValue
     * @memberof CounterResponseMsg
     * @instance
     */
    CounterResponseMsg.prototype.counterValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new CounterResponseMsg instance using the specified properties.
     * @function create
     * @memberof CounterResponseMsg
     * @static
     * @param {ICounterResponseMsg=} [properties] Properties to set
     * @returns {CounterResponseMsg} CounterResponseMsg instance
     */
    CounterResponseMsg.create = function create(properties) {
        return new CounterResponseMsg(properties);
    };

    /**
     * Encodes the specified CounterResponseMsg message. Does not implicitly {@link CounterResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof CounterResponseMsg
     * @static
     * @param {ICounterResponseMsg} message CounterResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CounterResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.counterValue);
        return writer;
    };

    /**
     * Decodes a CounterResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof CounterResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CounterResponseMsg} CounterResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CounterResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.CounterResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.counterValue = reader.int64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("counterValue"))
            throw $util.ProtocolError("missing required 'counterValue'", { instance: message });
        return message;
    };

    /**
     * Creates a CounterResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CounterResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CounterResponseMsg} CounterResponseMsg
     */
    CounterResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.CounterResponseMsg)
            return object;
        let message = new $root.CounterResponseMsg();
        if (object.counterValue != null)
            if ($util.Long)
                (message.counterValue = $util.Long.fromValue(object.counterValue)).unsigned = false;
            else if (typeof object.counterValue === "string")
                message.counterValue = parseInt(object.counterValue, 10);
            else if (typeof object.counterValue === "number")
                message.counterValue = object.counterValue;
            else if (typeof object.counterValue === "object")
                message.counterValue = new $util.LongBits(object.counterValue.low >>> 0, object.counterValue.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a CounterResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CounterResponseMsg
     * @static
     * @param {CounterResponseMsg} message CounterResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CounterResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, false);
                object.counterValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.counterValue = options.longs === String ? "0" : 0;
        if (message.counterValue != null && message.hasOwnProperty("counterValue"))
            if (typeof message.counterValue === "number")
                object.counterValue = options.longs === String ? String(message.counterValue) : message.counterValue;
            else
                object.counterValue = options.longs === String ? $util.Long.prototype.toString.call(message.counterValue) : options.longs === Number ? new $util.LongBits(message.counterValue.low >>> 0, message.counterValue.high >>> 0).toNumber() : message.counterValue;
        return object;
    };

    /**
     * Converts this CounterResponseMsg to JSON.
     * @function toJSON
     * @memberof CounterResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CounterResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for CounterResponseMsg
     * @function getTypeUrl
     * @memberof CounterResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    CounterResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CounterResponseMsg";
    };

    return CounterResponseMsg;
})();

export const EpochRequestMsg = $root.EpochRequestMsg = (() => {

    /**
     * Properties of an EpochRequestMsg.
     * @exports IEpochRequestMsg
     * @interface IEpochRequestMsg
     * @property {EpochRequestMsg.OperationType} operation EpochRequestMsg operation
     * @property {number} nodeId EpochRequestMsg nodeId
     * @property {Long} clientEpoch EpochRequestMsg clientEpoch
     * @property {Long|null} [clientConnection] EpochRequestMsg clientConnection
     */

    /**
     * Constructs a new EpochRequestMsg.
     * @exports EpochRequestMsg
     * @classdesc Represents an EpochRequestMsg.
     * @implements IEpochRequestMsg
     * @constructor
     * @param {IEpochRequestMsg=} [properties] Properties to set
     */
    function EpochRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EpochRequestMsg operation.
     * @member {EpochRequestMsg.OperationType} operation
     * @memberof EpochRequestMsg
     * @instance
     */
    EpochRequestMsg.prototype.operation = 1;

    /**
     * EpochRequestMsg nodeId.
     * @member {number} nodeId
     * @memberof EpochRequestMsg
     * @instance
     */
    EpochRequestMsg.prototype.nodeId = 0;

    /**
     * EpochRequestMsg clientEpoch.
     * @member {Long} clientEpoch
     * @memberof EpochRequestMsg
     * @instance
     */
    EpochRequestMsg.prototype.clientEpoch = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * EpochRequestMsg clientConnection.
     * @member {Long} clientConnection
     * @memberof EpochRequestMsg
     * @instance
     */
    EpochRequestMsg.prototype.clientConnection = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new EpochRequestMsg instance using the specified properties.
     * @function create
     * @memberof EpochRequestMsg
     * @static
     * @param {IEpochRequestMsg=} [properties] Properties to set
     * @returns {EpochRequestMsg} EpochRequestMsg instance
     */
    EpochRequestMsg.create = function create(properties) {
        return new EpochRequestMsg(properties);
    };

    /**
     * Encodes the specified EpochRequestMsg message. Does not implicitly {@link EpochRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof EpochRequestMsg
     * @static
     * @param {IEpochRequestMsg} message EpochRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EpochRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.operation);
        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.nodeId);
        writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.clientEpoch);
        if (message.clientConnection != null && Object.hasOwnProperty.call(message, "clientConnection"))
            writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.clientConnection);
        return writer;
    };

    /**
     * Decodes an EpochRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof EpochRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EpochRequestMsg} EpochRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EpochRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EpochRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.operation = reader.int32();
                    break;
                }
            case 2: {
                    message.nodeId = reader.uint32();
                    break;
                }
            case 3: {
                    message.clientEpoch = reader.uint64();
                    break;
                }
            case 4: {
                    message.clientConnection = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("operation"))
            throw $util.ProtocolError("missing required 'operation'", { instance: message });
        if (!message.hasOwnProperty("nodeId"))
            throw $util.ProtocolError("missing required 'nodeId'", { instance: message });
        if (!message.hasOwnProperty("clientEpoch"))
            throw $util.ProtocolError("missing required 'clientEpoch'", { instance: message });
        return message;
    };

    /**
     * Creates an EpochRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EpochRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EpochRequestMsg} EpochRequestMsg
     */
    EpochRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.EpochRequestMsg)
            return object;
        let message = new $root.EpochRequestMsg();
        switch (object.operation) {
        default:
            if (typeof object.operation === "number") {
                message.operation = object.operation;
                break;
            }
            break;
        case "CONNECT_EPOCH":
        case 1:
            message.operation = 1;
            break;
        case "REPORT_EPOCH":
        case 2:
            message.operation = 2;
            break;
        }
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        if (object.clientEpoch != null)
            if ($util.Long)
                (message.clientEpoch = $util.Long.fromValue(object.clientEpoch)).unsigned = true;
            else if (typeof object.clientEpoch === "string")
                message.clientEpoch = parseInt(object.clientEpoch, 10);
            else if (typeof object.clientEpoch === "number")
                message.clientEpoch = object.clientEpoch;
            else if (typeof object.clientEpoch === "object")
                message.clientEpoch = new $util.LongBits(object.clientEpoch.low >>> 0, object.clientEpoch.high >>> 0).toNumber(true);
        if (object.clientConnection != null)
            if ($util.Long)
                (message.clientConnection = $util.Long.fromValue(object.clientConnection)).unsigned = true;
            else if (typeof object.clientConnection === "string")
                message.clientConnection = parseInt(object.clientConnection, 10);
            else if (typeof object.clientConnection === "number")
                message.clientConnection = object.clientConnection;
            else if (typeof object.clientConnection === "object")
                message.clientConnection = new $util.LongBits(object.clientConnection.low >>> 0, object.clientConnection.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from an EpochRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EpochRequestMsg
     * @static
     * @param {EpochRequestMsg} message EpochRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EpochRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.operation = options.enums === String ? "CONNECT_EPOCH" : 1;
            object.nodeId = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.clientEpoch = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.clientEpoch = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.clientConnection = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.clientConnection = options.longs === String ? "0" : 0;
        }
        if (message.operation != null && message.hasOwnProperty("operation"))
            object.operation = options.enums === String ? $root.EpochRequestMsg.OperationType[message.operation] === undefined ? message.operation : $root.EpochRequestMsg.OperationType[message.operation] : message.operation;
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        if (message.clientEpoch != null && message.hasOwnProperty("clientEpoch"))
            if (typeof message.clientEpoch === "number")
                object.clientEpoch = options.longs === String ? String(message.clientEpoch) : message.clientEpoch;
            else
                object.clientEpoch = options.longs === String ? $util.Long.prototype.toString.call(message.clientEpoch) : options.longs === Number ? new $util.LongBits(message.clientEpoch.low >>> 0, message.clientEpoch.high >>> 0).toNumber(true) : message.clientEpoch;
        if (message.clientConnection != null && message.hasOwnProperty("clientConnection"))
            if (typeof message.clientConnection === "number")
                object.clientConnection = options.longs === String ? String(message.clientConnection) : message.clientConnection;
            else
                object.clientConnection = options.longs === String ? $util.Long.prototype.toString.call(message.clientConnection) : options.longs === Number ? new $util.LongBits(message.clientConnection.low >>> 0, message.clientConnection.high >>> 0).toNumber(true) : message.clientConnection;
        return object;
    };

    /**
     * Converts this EpochRequestMsg to JSON.
     * @function toJSON
     * @memberof EpochRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EpochRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for EpochRequestMsg
     * @function getTypeUrl
     * @memberof EpochRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    EpochRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/EpochRequestMsg";
    };

    /**
     * OperationType enum.
     * @name EpochRequestMsg.OperationType
     * @enum {number}
     * @property {number} CONNECT_EPOCH=1 CONNECT_EPOCH value
     * @property {number} REPORT_EPOCH=2 REPORT_EPOCH value
     */
    EpochRequestMsg.OperationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "CONNECT_EPOCH"] = 1;
        values[valuesById[2] = "REPORT_EPOCH"] = 2;
        return values;
    })();

    return EpochRequestMsg;
})();

export const EpochResponseMsg = $root.EpochResponseMsg = (() => {

    /**
     * Properties of an EpochResponseMsg.
     * @exports IEpochResponseMsg
     * @interface IEpochResponseMsg
     * @property {EpochResponseMsg.ResultCode} resultCode EpochResponseMsg resultCode
     * @property {Long|null} [prevHubEpoch] EpochResponseMsg prevHubEpoch
     * @property {Long|null} [hubConnection] EpochResponseMsg hubConnection
     */

    /**
     * Constructs a new EpochResponseMsg.
     * @exports EpochResponseMsg
     * @classdesc Represents an EpochResponseMsg.
     * @implements IEpochResponseMsg
     * @constructor
     * @param {IEpochResponseMsg=} [properties] Properties to set
     */
    function EpochResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EpochResponseMsg resultCode.
     * @member {EpochResponseMsg.ResultCode} resultCode
     * @memberof EpochResponseMsg
     * @instance
     */
    EpochResponseMsg.prototype.resultCode = 0;

    /**
     * EpochResponseMsg prevHubEpoch.
     * @member {Long} prevHubEpoch
     * @memberof EpochResponseMsg
     * @instance
     */
    EpochResponseMsg.prototype.prevHubEpoch = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * EpochResponseMsg hubConnection.
     * @member {Long} hubConnection
     * @memberof EpochResponseMsg
     * @instance
     */
    EpochResponseMsg.prototype.hubConnection = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new EpochResponseMsg instance using the specified properties.
     * @function create
     * @memberof EpochResponseMsg
     * @static
     * @param {IEpochResponseMsg=} [properties] Properties to set
     * @returns {EpochResponseMsg} EpochResponseMsg instance
     */
    EpochResponseMsg.create = function create(properties) {
        return new EpochResponseMsg(properties);
    };

    /**
     * Encodes the specified EpochResponseMsg message. Does not implicitly {@link EpochResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof EpochResponseMsg
     * @static
     * @param {IEpochResponseMsg} message EpochResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EpochResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.resultCode);
        if (message.prevHubEpoch != null && Object.hasOwnProperty.call(message, "prevHubEpoch"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.prevHubEpoch);
        if (message.hubConnection != null && Object.hasOwnProperty.call(message, "hubConnection"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.hubConnection);
        return writer;
    };

    /**
     * Decodes an EpochResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof EpochResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EpochResponseMsg} EpochResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EpochResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.EpochResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.resultCode = reader.int32();
                    break;
                }
            case 2: {
                    message.prevHubEpoch = reader.uint64();
                    break;
                }
            case 3: {
                    message.hubConnection = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("resultCode"))
            throw $util.ProtocolError("missing required 'resultCode'", { instance: message });
        return message;
    };

    /**
     * Creates an EpochResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EpochResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EpochResponseMsg} EpochResponseMsg
     */
    EpochResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.EpochResponseMsg)
            return object;
        let message = new $root.EpochResponseMsg();
        switch (object.resultCode) {
        default:
            if (typeof object.resultCode === "number") {
                message.resultCode = object.resultCode;
                break;
            }
            break;
        case "OK":
        case 0:
            message.resultCode = 0;
            break;
        case "ERROR_OUT_OF_CONNECTION":
        case 1:
            message.resultCode = 1;
            break;
        case "ERROR_OUT_OF_DATE":
        case 2:
            message.resultCode = 2;
            break;
        }
        if (object.prevHubEpoch != null)
            if ($util.Long)
                (message.prevHubEpoch = $util.Long.fromValue(object.prevHubEpoch)).unsigned = true;
            else if (typeof object.prevHubEpoch === "string")
                message.prevHubEpoch = parseInt(object.prevHubEpoch, 10);
            else if (typeof object.prevHubEpoch === "number")
                message.prevHubEpoch = object.prevHubEpoch;
            else if (typeof object.prevHubEpoch === "object")
                message.prevHubEpoch = new $util.LongBits(object.prevHubEpoch.low >>> 0, object.prevHubEpoch.high >>> 0).toNumber(true);
        if (object.hubConnection != null)
            if ($util.Long)
                (message.hubConnection = $util.Long.fromValue(object.hubConnection)).unsigned = true;
            else if (typeof object.hubConnection === "string")
                message.hubConnection = parseInt(object.hubConnection, 10);
            else if (typeof object.hubConnection === "number")
                message.hubConnection = object.hubConnection;
            else if (typeof object.hubConnection === "object")
                message.hubConnection = new $util.LongBits(object.hubConnection.low >>> 0, object.hubConnection.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from an EpochResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EpochResponseMsg
     * @static
     * @param {EpochResponseMsg} message EpochResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EpochResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.resultCode = options.enums === String ? "OK" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.prevHubEpoch = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.prevHubEpoch = options.longs === String ? "0" : 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.hubConnection = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.hubConnection = options.longs === String ? "0" : 0;
        }
        if (message.resultCode != null && message.hasOwnProperty("resultCode"))
            object.resultCode = options.enums === String ? $root.EpochResponseMsg.ResultCode[message.resultCode] === undefined ? message.resultCode : $root.EpochResponseMsg.ResultCode[message.resultCode] : message.resultCode;
        if (message.prevHubEpoch != null && message.hasOwnProperty("prevHubEpoch"))
            if (typeof message.prevHubEpoch === "number")
                object.prevHubEpoch = options.longs === String ? String(message.prevHubEpoch) : message.prevHubEpoch;
            else
                object.prevHubEpoch = options.longs === String ? $util.Long.prototype.toString.call(message.prevHubEpoch) : options.longs === Number ? new $util.LongBits(message.prevHubEpoch.low >>> 0, message.prevHubEpoch.high >>> 0).toNumber(true) : message.prevHubEpoch;
        if (message.hubConnection != null && message.hasOwnProperty("hubConnection"))
            if (typeof message.hubConnection === "number")
                object.hubConnection = options.longs === String ? String(message.hubConnection) : message.hubConnection;
            else
                object.hubConnection = options.longs === String ? $util.Long.prototype.toString.call(message.hubConnection) : options.longs === Number ? new $util.LongBits(message.hubConnection.low >>> 0, message.hubConnection.high >>> 0).toNumber(true) : message.hubConnection;
        return object;
    };

    /**
     * Converts this EpochResponseMsg to JSON.
     * @function toJSON
     * @memberof EpochResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EpochResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for EpochResponseMsg
     * @function getTypeUrl
     * @memberof EpochResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    EpochResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/EpochResponseMsg";
    };

    /**
     * ResultCode enum.
     * @name EpochResponseMsg.ResultCode
     * @enum {number}
     * @property {number} OK=0 OK value
     * @property {number} ERROR_OUT_OF_CONNECTION=1 ERROR_OUT_OF_CONNECTION value
     * @property {number} ERROR_OUT_OF_DATE=2 ERROR_OUT_OF_DATE value
     */
    EpochResponseMsg.ResultCode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "OK"] = 0;
        values[valuesById[1] = "ERROR_OUT_OF_CONNECTION"] = 1;
        values[valuesById[2] = "ERROR_OUT_OF_DATE"] = 2;
        return values;
    })();

    return EpochResponseMsg;
})();

/**
 * SessionMessageType enum.
 * @exports SessionMessageType
 * @enum {number}
 * @property {number} LEGACY_LOGIN=1 LEGACY_LOGIN value
 * @property {number} LOGIN=2 LOGIN value
 */
export const SessionMessageType = $root.SessionMessageType = (() => {
    const valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "LEGACY_LOGIN"] = 1;
    values[valuesById[2] = "LOGIN"] = 2;
    return values;
})();

export const SessionRequestMsg = $root.SessionRequestMsg = (() => {

    /**
     * Properties of a SessionRequestMsg.
     * @exports ISessionRequestMsg
     * @interface ISessionRequestMsg
     * @property {SessionMessageType} type SessionRequestMsg type
     * @property {ILegacyLoginMsg|null} [legacyLogin] SessionRequestMsg legacyLogin
     * @property {ILoginMsg|null} [login] SessionRequestMsg login
     */

    /**
     * Constructs a new SessionRequestMsg.
     * @exports SessionRequestMsg
     * @classdesc Represents a SessionRequestMsg.
     * @implements ISessionRequestMsg
     * @constructor
     * @param {ISessionRequestMsg=} [properties] Properties to set
     */
    function SessionRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SessionRequestMsg type.
     * @member {SessionMessageType} type
     * @memberof SessionRequestMsg
     * @instance
     */
    SessionRequestMsg.prototype.type = 1;

    /**
     * SessionRequestMsg legacyLogin.
     * @member {ILegacyLoginMsg|null|undefined} legacyLogin
     * @memberof SessionRequestMsg
     * @instance
     */
    SessionRequestMsg.prototype.legacyLogin = null;

    /**
     * SessionRequestMsg login.
     * @member {ILoginMsg|null|undefined} login
     * @memberof SessionRequestMsg
     * @instance
     */
    SessionRequestMsg.prototype.login = null;

    /**
     * Creates a new SessionRequestMsg instance using the specified properties.
     * @function create
     * @memberof SessionRequestMsg
     * @static
     * @param {ISessionRequestMsg=} [properties] Properties to set
     * @returns {SessionRequestMsg} SessionRequestMsg instance
     */
    SessionRequestMsg.create = function create(properties) {
        return new SessionRequestMsg(properties);
    };

    /**
     * Encodes the specified SessionRequestMsg message. Does not implicitly {@link SessionRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof SessionRequestMsg
     * @static
     * @param {ISessionRequestMsg} message SessionRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.legacyLogin != null && Object.hasOwnProperty.call(message, "legacyLogin"))
            $root.LegacyLoginMsg.encode(message.legacyLogin, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.login != null && Object.hasOwnProperty.call(message, "login"))
            $root.LoginMsg.encode(message.login, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a SessionRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof SessionRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionRequestMsg} SessionRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.legacyLogin = $root.LegacyLoginMsg.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.login = $root.LoginMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a SessionRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionRequestMsg} SessionRequestMsg
     */
    SessionRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionRequestMsg)
            return object;
        let message = new $root.SessionRequestMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "LEGACY_LOGIN":
        case 1:
            message.type = 1;
            break;
        case "LOGIN":
        case 2:
            message.type = 2;
            break;
        }
        if (object.legacyLogin != null) {
            if (typeof object.legacyLogin !== "object")
                throw TypeError(".SessionRequestMsg.legacyLogin: object expected");
            message.legacyLogin = $root.LegacyLoginMsg.fromObject(object.legacyLogin);
        }
        if (object.login != null) {
            if (typeof object.login !== "object")
                throw TypeError(".SessionRequestMsg.login: object expected");
            message.login = $root.LoginMsg.fromObject(object.login);
        }
        return message;
    };

    /**
     * Creates a plain object from a SessionRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionRequestMsg
     * @static
     * @param {SessionRequestMsg} message SessionRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "LEGACY_LOGIN" : 1;
            object.legacyLogin = null;
            object.login = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.SessionMessageType[message.type] === undefined ? message.type : $root.SessionMessageType[message.type] : message.type;
        if (message.legacyLogin != null && message.hasOwnProperty("legacyLogin"))
            object.legacyLogin = $root.LegacyLoginMsg.toObject(message.legacyLogin, options);
        if (message.login != null && message.hasOwnProperty("login"))
            object.login = $root.LoginMsg.toObject(message.login, options);
        return object;
    };

    /**
     * Converts this SessionRequestMsg to JSON.
     * @function toJSON
     * @memberof SessionRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SessionRequestMsg
     * @function getTypeUrl
     * @memberof SessionRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SessionRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SessionRequestMsg";
    };

    return SessionRequestMsg;
})();

export const LegacyLoginMsg = $root.LegacyLoginMsg = (() => {

    /**
     * Properties of a LegacyLoginMsg.
     * @exports ILegacyLoginMsg
     * @interface ILegacyLoginMsg
     * @property {string} idToken LegacyLoginMsg idToken
     * @property {string} accessToken LegacyLoginMsg accessToken
     */

    /**
     * Constructs a new LegacyLoginMsg.
     * @exports LegacyLoginMsg
     * @classdesc Represents a LegacyLoginMsg.
     * @implements ILegacyLoginMsg
     * @constructor
     * @param {ILegacyLoginMsg=} [properties] Properties to set
     */
    function LegacyLoginMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LegacyLoginMsg idToken.
     * @member {string} idToken
     * @memberof LegacyLoginMsg
     * @instance
     */
    LegacyLoginMsg.prototype.idToken = "";

    /**
     * LegacyLoginMsg accessToken.
     * @member {string} accessToken
     * @memberof LegacyLoginMsg
     * @instance
     */
    LegacyLoginMsg.prototype.accessToken = "";

    /**
     * Creates a new LegacyLoginMsg instance using the specified properties.
     * @function create
     * @memberof LegacyLoginMsg
     * @static
     * @param {ILegacyLoginMsg=} [properties] Properties to set
     * @returns {LegacyLoginMsg} LegacyLoginMsg instance
     */
    LegacyLoginMsg.create = function create(properties) {
        return new LegacyLoginMsg(properties);
    };

    /**
     * Encodes the specified LegacyLoginMsg message. Does not implicitly {@link LegacyLoginMsg.verify|verify} messages.
     * @function encode
     * @memberof LegacyLoginMsg
     * @static
     * @param {ILegacyLoginMsg} message LegacyLoginMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LegacyLoginMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.idToken);
        writer.uint32(/* id 2, wireType 2 =*/18).string(message.accessToken);
        return writer;
    };

    /**
     * Decodes a LegacyLoginMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LegacyLoginMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LegacyLoginMsg} LegacyLoginMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LegacyLoginMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LegacyLoginMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.idToken = reader.string();
                    break;
                }
            case 2: {
                    message.accessToken = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("idToken"))
            throw $util.ProtocolError("missing required 'idToken'", { instance: message });
        if (!message.hasOwnProperty("accessToken"))
            throw $util.ProtocolError("missing required 'accessToken'", { instance: message });
        return message;
    };

    /**
     * Creates a LegacyLoginMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LegacyLoginMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LegacyLoginMsg} LegacyLoginMsg
     */
    LegacyLoginMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LegacyLoginMsg)
            return object;
        let message = new $root.LegacyLoginMsg();
        if (object.idToken != null)
            message.idToken = String(object.idToken);
        if (object.accessToken != null)
            message.accessToken = String(object.accessToken);
        return message;
    };

    /**
     * Creates a plain object from a LegacyLoginMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LegacyLoginMsg
     * @static
     * @param {LegacyLoginMsg} message LegacyLoginMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LegacyLoginMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.idToken = "";
            object.accessToken = "";
        }
        if (message.idToken != null && message.hasOwnProperty("idToken"))
            object.idToken = message.idToken;
        if (message.accessToken != null && message.hasOwnProperty("accessToken"))
            object.accessToken = message.accessToken;
        return object;
    };

    /**
     * Converts this LegacyLoginMsg to JSON.
     * @function toJSON
     * @memberof LegacyLoginMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LegacyLoginMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LegacyLoginMsg
     * @function getTypeUrl
     * @memberof LegacyLoginMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LegacyLoginMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LegacyLoginMsg";
    };

    return LegacyLoginMsg;
})();

export const LoginMsg = $root.LoginMsg = (() => {

    /**
     * Properties of a LoginMsg.
     * @exports ILoginMsg
     * @interface ILoginMsg
     * @property {string} filespaceToken LoginMsg filespaceToken
     */

    /**
     * Constructs a new LoginMsg.
     * @exports LoginMsg
     * @classdesc Represents a LoginMsg.
     * @implements ILoginMsg
     * @constructor
     * @param {ILoginMsg=} [properties] Properties to set
     */
    function LoginMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LoginMsg filespaceToken.
     * @member {string} filespaceToken
     * @memberof LoginMsg
     * @instance
     */
    LoginMsg.prototype.filespaceToken = "";

    /**
     * Creates a new LoginMsg instance using the specified properties.
     * @function create
     * @memberof LoginMsg
     * @static
     * @param {ILoginMsg=} [properties] Properties to set
     * @returns {LoginMsg} LoginMsg instance
     */
    LoginMsg.create = function create(properties) {
        return new LoginMsg(properties);
    };

    /**
     * Encodes the specified LoginMsg message. Does not implicitly {@link LoginMsg.verify|verify} messages.
     * @function encode
     * @memberof LoginMsg
     * @static
     * @param {ILoginMsg} message LoginMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LoginMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.filespaceToken);
        return writer;
    };

    /**
     * Decodes a LoginMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LoginMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LoginMsg} LoginMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LoginMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoginMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.filespaceToken = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("filespaceToken"))
            throw $util.ProtocolError("missing required 'filespaceToken'", { instance: message });
        return message;
    };

    /**
     * Creates a LoginMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LoginMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LoginMsg} LoginMsg
     */
    LoginMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LoginMsg)
            return object;
        let message = new $root.LoginMsg();
        if (object.filespaceToken != null)
            message.filespaceToken = String(object.filespaceToken);
        return message;
    };

    /**
     * Creates a plain object from a LoginMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LoginMsg
     * @static
     * @param {LoginMsg} message LoginMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LoginMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.filespaceToken = "";
        if (message.filespaceToken != null && message.hasOwnProperty("filespaceToken"))
            object.filespaceToken = message.filespaceToken;
        return object;
    };

    /**
     * Converts this LoginMsg to JSON.
     * @function toJSON
     * @memberof LoginMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LoginMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LoginMsg
     * @function getTypeUrl
     * @memberof LoginMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LoginMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LoginMsg";
    };

    return LoginMsg;
})();

export const SessionResponseMsg = $root.SessionResponseMsg = (() => {

    /**
     * Properties of a SessionResponseMsg.
     * @exports ISessionResponseMsg
     * @interface ISessionResponseMsg
     * @property {SessionMessageType} type SessionResponseMsg type
     * @property {Uint8Array|null} [sessionToken] SessionResponseMsg sessionToken
     */

    /**
     * Constructs a new SessionResponseMsg.
     * @exports SessionResponseMsg
     * @classdesc Represents a SessionResponseMsg.
     * @implements ISessionResponseMsg
     * @constructor
     * @param {ISessionResponseMsg=} [properties] Properties to set
     */
    function SessionResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SessionResponseMsg type.
     * @member {SessionMessageType} type
     * @memberof SessionResponseMsg
     * @instance
     */
    SessionResponseMsg.prototype.type = 1;

    /**
     * SessionResponseMsg sessionToken.
     * @member {Uint8Array} sessionToken
     * @memberof SessionResponseMsg
     * @instance
     */
    SessionResponseMsg.prototype.sessionToken = $util.newBuffer([]);

    /**
     * Creates a new SessionResponseMsg instance using the specified properties.
     * @function create
     * @memberof SessionResponseMsg
     * @static
     * @param {ISessionResponseMsg=} [properties] Properties to set
     * @returns {SessionResponseMsg} SessionResponseMsg instance
     */
    SessionResponseMsg.create = function create(properties) {
        return new SessionResponseMsg(properties);
    };

    /**
     * Encodes the specified SessionResponseMsg message. Does not implicitly {@link SessionResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof SessionResponseMsg
     * @static
     * @param {ISessionResponseMsg} message SessionResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SessionResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.sessionToken != null && Object.hasOwnProperty.call(message, "sessionToken"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.sessionToken);
        return writer;
    };

    /**
     * Decodes a SessionResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof SessionResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SessionResponseMsg} SessionResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SessionResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.sessionToken = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a SessionResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SessionResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SessionResponseMsg} SessionResponseMsg
     */
    SessionResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionResponseMsg)
            return object;
        let message = new $root.SessionResponseMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "LEGACY_LOGIN":
        case 1:
            message.type = 1;
            break;
        case "LOGIN":
        case 2:
            message.type = 2;
            break;
        }
        if (object.sessionToken != null)
            if (typeof object.sessionToken === "string")
                $util.base64.decode(object.sessionToken, message.sessionToken = $util.newBuffer($util.base64.length(object.sessionToken)), 0);
            else if (object.sessionToken.length >= 0)
                message.sessionToken = object.sessionToken;
        return message;
    };

    /**
     * Creates a plain object from a SessionResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SessionResponseMsg
     * @static
     * @param {SessionResponseMsg} message SessionResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SessionResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "LEGACY_LOGIN" : 1;
            if (options.bytes === String)
                object.sessionToken = "";
            else {
                object.sessionToken = [];
                if (options.bytes !== Array)
                    object.sessionToken = $util.newBuffer(object.sessionToken);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.SessionMessageType[message.type] === undefined ? message.type : $root.SessionMessageType[message.type] : message.type;
        if (message.sessionToken != null && message.hasOwnProperty("sessionToken"))
            object.sessionToken = options.bytes === String ? $util.base64.encode(message.sessionToken, 0, message.sessionToken.length) : options.bytes === Array ? Array.prototype.slice.call(message.sessionToken) : message.sessionToken;
        return object;
    };

    /**
     * Converts this SessionResponseMsg to JSON.
     * @function toJSON
     * @memberof SessionResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SessionResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SessionResponseMsg
     * @function getTypeUrl
     * @memberof SessionResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SessionResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SessionResponseMsg";
    };

    return SessionResponseMsg;
})();

export const StatusRequestMsg = $root.StatusRequestMsg = (() => {

    /**
     * Properties of a StatusRequestMsg.
     * @exports IStatusRequestMsg
     * @interface IStatusRequestMsg
     * @property {StatusRequestMsg.RequestType} type StatusRequestMsg type
     */

    /**
     * Constructs a new StatusRequestMsg.
     * @exports StatusRequestMsg
     * @classdesc Represents a StatusRequestMsg.
     * @implements IStatusRequestMsg
     * @constructor
     * @param {IStatusRequestMsg=} [properties] Properties to set
     */
    function StatusRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StatusRequestMsg type.
     * @member {StatusRequestMsg.RequestType} type
     * @memberof StatusRequestMsg
     * @instance
     */
    StatusRequestMsg.prototype.type = 1;

    /**
     * Creates a new StatusRequestMsg instance using the specified properties.
     * @function create
     * @memberof StatusRequestMsg
     * @static
     * @param {IStatusRequestMsg=} [properties] Properties to set
     * @returns {StatusRequestMsg} StatusRequestMsg instance
     */
    StatusRequestMsg.create = function create(properties) {
        return new StatusRequestMsg(properties);
    };

    /**
     * Encodes the specified StatusRequestMsg message. Does not implicitly {@link StatusRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof StatusRequestMsg
     * @static
     * @param {IStatusRequestMsg} message StatusRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatusRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        return writer;
    };

    /**
     * Decodes a StatusRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof StatusRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StatusRequestMsg} StatusRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatusRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StatusRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a StatusRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StatusRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StatusRequestMsg} StatusRequestMsg
     */
    StatusRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.StatusRequestMsg)
            return object;
        let message = new $root.StatusRequestMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "ServerInfo":
        case 1:
            message.type = 1;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a StatusRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StatusRequestMsg
     * @static
     * @param {StatusRequestMsg} message StatusRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StatusRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.type = options.enums === String ? "ServerInfo" : 1;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.StatusRequestMsg.RequestType[message.type] === undefined ? message.type : $root.StatusRequestMsg.RequestType[message.type] : message.type;
        return object;
    };

    /**
     * Converts this StatusRequestMsg to JSON.
     * @function toJSON
     * @memberof StatusRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StatusRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StatusRequestMsg
     * @function getTypeUrl
     * @memberof StatusRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StatusRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StatusRequestMsg";
    };

    /**
     * RequestType enum.
     * @name StatusRequestMsg.RequestType
     * @enum {number}
     * @property {number} ServerInfo=1 ServerInfo value
     */
    StatusRequestMsg.RequestType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "ServerInfo"] = 1;
        return values;
    })();

    return StatusRequestMsg;
})();

export const StatusResponseMsg = $root.StatusResponseMsg = (() => {

    /**
     * Properties of a StatusResponseMsg.
     * @exports IStatusResponseMsg
     * @interface IStatusResponseMsg
     * @property {StatusResponseMsg.IServerInfoResponseMsg|null} [serverInfo] StatusResponseMsg serverInfo
     */

    /**
     * Constructs a new StatusResponseMsg.
     * @exports StatusResponseMsg
     * @classdesc Represents a StatusResponseMsg.
     * @implements IStatusResponseMsg
     * @constructor
     * @param {IStatusResponseMsg=} [properties] Properties to set
     */
    function StatusResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * StatusResponseMsg serverInfo.
     * @member {StatusResponseMsg.IServerInfoResponseMsg|null|undefined} serverInfo
     * @memberof StatusResponseMsg
     * @instance
     */
    StatusResponseMsg.prototype.serverInfo = null;

    /**
     * Creates a new StatusResponseMsg instance using the specified properties.
     * @function create
     * @memberof StatusResponseMsg
     * @static
     * @param {IStatusResponseMsg=} [properties] Properties to set
     * @returns {StatusResponseMsg} StatusResponseMsg instance
     */
    StatusResponseMsg.create = function create(properties) {
        return new StatusResponseMsg(properties);
    };

    /**
     * Encodes the specified StatusResponseMsg message. Does not implicitly {@link StatusResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof StatusResponseMsg
     * @static
     * @param {IStatusResponseMsg} message StatusResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    StatusResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.serverInfo != null && Object.hasOwnProperty.call(message, "serverInfo"))
            $root.StatusResponseMsg.ServerInfoResponseMsg.encode(message.serverInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a StatusResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof StatusResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {StatusResponseMsg} StatusResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    StatusResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StatusResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.serverInfo = $root.StatusResponseMsg.ServerInfoResponseMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a StatusResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof StatusResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {StatusResponseMsg} StatusResponseMsg
     */
    StatusResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.StatusResponseMsg)
            return object;
        let message = new $root.StatusResponseMsg();
        if (object.serverInfo != null) {
            if (typeof object.serverInfo !== "object")
                throw TypeError(".StatusResponseMsg.serverInfo: object expected");
            message.serverInfo = $root.StatusResponseMsg.ServerInfoResponseMsg.fromObject(object.serverInfo);
        }
        return message;
    };

    /**
     * Creates a plain object from a StatusResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof StatusResponseMsg
     * @static
     * @param {StatusResponseMsg} message StatusResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    StatusResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.serverInfo = null;
        if (message.serverInfo != null && message.hasOwnProperty("serverInfo"))
            object.serverInfo = $root.StatusResponseMsg.ServerInfoResponseMsg.toObject(message.serverInfo, options);
        return object;
    };

    /**
     * Converts this StatusResponseMsg to JSON.
     * @function toJSON
     * @memberof StatusResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    StatusResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for StatusResponseMsg
     * @function getTypeUrl
     * @memberof StatusResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    StatusResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StatusResponseMsg";
    };

    StatusResponseMsg.ServerInfoResponseMsg = (function() {

        /**
         * Properties of a ServerInfoResponseMsg.
         * @memberof StatusResponseMsg
         * @interface IServerInfoResponseMsg
         * @property {Uint8Array} maskedVersion ServerInfoResponseMsg maskedVersion
         * @property {Uint8Array} syncTime ServerInfoResponseMsg syncTime
         */

        /**
         * Constructs a new ServerInfoResponseMsg.
         * @memberof StatusResponseMsg
         * @classdesc Represents a ServerInfoResponseMsg.
         * @implements IServerInfoResponseMsg
         * @constructor
         * @param {StatusResponseMsg.IServerInfoResponseMsg=} [properties] Properties to set
         */
        function ServerInfoResponseMsg(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServerInfoResponseMsg maskedVersion.
         * @member {Uint8Array} maskedVersion
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @instance
         */
        ServerInfoResponseMsg.prototype.maskedVersion = $util.newBuffer([]);

        /**
         * ServerInfoResponseMsg syncTime.
         * @member {Uint8Array} syncTime
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @instance
         */
        ServerInfoResponseMsg.prototype.syncTime = $util.newBuffer([]);

        /**
         * Creates a new ServerInfoResponseMsg instance using the specified properties.
         * @function create
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {StatusResponseMsg.IServerInfoResponseMsg=} [properties] Properties to set
         * @returns {StatusResponseMsg.ServerInfoResponseMsg} ServerInfoResponseMsg instance
         */
        ServerInfoResponseMsg.create = function create(properties) {
            return new ServerInfoResponseMsg(properties);
        };

        /**
         * Encodes the specified ServerInfoResponseMsg message. Does not implicitly {@link StatusResponseMsg.ServerInfoResponseMsg.verify|verify} messages.
         * @function encode
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {StatusResponseMsg.IServerInfoResponseMsg} message ServerInfoResponseMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerInfoResponseMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.maskedVersion);
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.syncTime);
            return writer;
        };

        /**
         * Decodes a ServerInfoResponseMsg message from the specified reader or buffer.
         * @function decode
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {StatusResponseMsg.ServerInfoResponseMsg} ServerInfoResponseMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerInfoResponseMsg.decode = function decode(reader, length, error) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.StatusResponseMsg.ServerInfoResponseMsg();
            while (reader.pos < end) {
                let tag = reader.uint32();
                if (tag === error)
                    break;
                switch (tag >>> 3) {
                case 1: {
                        message.maskedVersion = reader.bytes();
                        break;
                    }
                case 2: {
                        message.syncTime = reader.bytes();
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("maskedVersion"))
                throw $util.ProtocolError("missing required 'maskedVersion'", { instance: message });
            if (!message.hasOwnProperty("syncTime"))
                throw $util.ProtocolError("missing required 'syncTime'", { instance: message });
            return message;
        };

        /**
         * Creates a ServerInfoResponseMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {StatusResponseMsg.ServerInfoResponseMsg} ServerInfoResponseMsg
         */
        ServerInfoResponseMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.StatusResponseMsg.ServerInfoResponseMsg)
                return object;
            let message = new $root.StatusResponseMsg.ServerInfoResponseMsg();
            if (object.maskedVersion != null)
                if (typeof object.maskedVersion === "string")
                    $util.base64.decode(object.maskedVersion, message.maskedVersion = $util.newBuffer($util.base64.length(object.maskedVersion)), 0);
                else if (object.maskedVersion.length >= 0)
                    message.maskedVersion = object.maskedVersion;
            if (object.syncTime != null)
                if (typeof object.syncTime === "string")
                    $util.base64.decode(object.syncTime, message.syncTime = $util.newBuffer($util.base64.length(object.syncTime)), 0);
                else if (object.syncTime.length >= 0)
                    message.syncTime = object.syncTime;
            return message;
        };

        /**
         * Creates a plain object from a ServerInfoResponseMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {StatusResponseMsg.ServerInfoResponseMsg} message ServerInfoResponseMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerInfoResponseMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.maskedVersion = "";
                else {
                    object.maskedVersion = [];
                    if (options.bytes !== Array)
                        object.maskedVersion = $util.newBuffer(object.maskedVersion);
                }
                if (options.bytes === String)
                    object.syncTime = "";
                else {
                    object.syncTime = [];
                    if (options.bytes !== Array)
                        object.syncTime = $util.newBuffer(object.syncTime);
                }
            }
            if (message.maskedVersion != null && message.hasOwnProperty("maskedVersion"))
                object.maskedVersion = options.bytes === String ? $util.base64.encode(message.maskedVersion, 0, message.maskedVersion.length) : options.bytes === Array ? Array.prototype.slice.call(message.maskedVersion) : message.maskedVersion;
            if (message.syncTime != null && message.hasOwnProperty("syncTime"))
                object.syncTime = options.bytes === String ? $util.base64.encode(message.syncTime, 0, message.syncTime.length) : options.bytes === Array ? Array.prototype.slice.call(message.syncTime) : message.syncTime;
            return object;
        };

        /**
         * Converts this ServerInfoResponseMsg to JSON.
         * @function toJSON
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ServerInfoResponseMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for ServerInfoResponseMsg
         * @function getTypeUrl
         * @memberof StatusResponseMsg.ServerInfoResponseMsg
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        ServerInfoResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/StatusResponseMsg.ServerInfoResponseMsg";
        };

        return ServerInfoResponseMsg;
    })();

    return StatusResponseMsg;
})();

export const KeyRangeLockingRequestMsg = $root.KeyRangeLockingRequestMsg = (() => {

    /**
     * Properties of a KeyRangeLockingRequestMsg.
     * @exports IKeyRangeLockingRequestMsg
     * @interface IKeyRangeLockingRequestMsg
     * @property {KeyRangeLockingRequestMsg.RequestType} type KeyRangeLockingRequestMsg type
     * @property {ILockMsg|null} [lock] KeyRangeLockingRequestMsg lock
     * @property {IUnlockMsg|null} [unlock] KeyRangeLockingRequestMsg unlock
     * @property {IRenewLockMsg|null} [renewLock] KeyRangeLockingRequestMsg renewLock
     */

    /**
     * Constructs a new KeyRangeLockingRequestMsg.
     * @exports KeyRangeLockingRequestMsg
     * @classdesc Represents a KeyRangeLockingRequestMsg.
     * @implements IKeyRangeLockingRequestMsg
     * @constructor
     * @param {IKeyRangeLockingRequestMsg=} [properties] Properties to set
     */
    function KeyRangeLockingRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KeyRangeLockingRequestMsg type.
     * @member {KeyRangeLockingRequestMsg.RequestType} type
     * @memberof KeyRangeLockingRequestMsg
     * @instance
     */
    KeyRangeLockingRequestMsg.prototype.type = 1;

    /**
     * KeyRangeLockingRequestMsg lock.
     * @member {ILockMsg|null|undefined} lock
     * @memberof KeyRangeLockingRequestMsg
     * @instance
     */
    KeyRangeLockingRequestMsg.prototype.lock = null;

    /**
     * KeyRangeLockingRequestMsg unlock.
     * @member {IUnlockMsg|null|undefined} unlock
     * @memberof KeyRangeLockingRequestMsg
     * @instance
     */
    KeyRangeLockingRequestMsg.prototype.unlock = null;

    /**
     * KeyRangeLockingRequestMsg renewLock.
     * @member {IRenewLockMsg|null|undefined} renewLock
     * @memberof KeyRangeLockingRequestMsg
     * @instance
     */
    KeyRangeLockingRequestMsg.prototype.renewLock = null;

    /**
     * Creates a new KeyRangeLockingRequestMsg instance using the specified properties.
     * @function create
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {IKeyRangeLockingRequestMsg=} [properties] Properties to set
     * @returns {KeyRangeLockingRequestMsg} KeyRangeLockingRequestMsg instance
     */
    KeyRangeLockingRequestMsg.create = function create(properties) {
        return new KeyRangeLockingRequestMsg(properties);
    };

    /**
     * Encodes the specified KeyRangeLockingRequestMsg message. Does not implicitly {@link KeyRangeLockingRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {IKeyRangeLockingRequestMsg} message KeyRangeLockingRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KeyRangeLockingRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.lock != null && Object.hasOwnProperty.call(message, "lock"))
            $root.LockMsg.encode(message.lock, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.unlock != null && Object.hasOwnProperty.call(message, "unlock"))
            $root.UnlockMsg.encode(message.unlock, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.renewLock != null && Object.hasOwnProperty.call(message, "renewLock"))
            $root.RenewLockMsg.encode(message.renewLock, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a KeyRangeLockingRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KeyRangeLockingRequestMsg} KeyRangeLockingRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KeyRangeLockingRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KeyRangeLockingRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.lock = $root.LockMsg.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.unlock = $root.UnlockMsg.decode(reader, reader.uint32());
                    break;
                }
            case 4: {
                    message.renewLock = $root.RenewLockMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a KeyRangeLockingRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KeyRangeLockingRequestMsg} KeyRangeLockingRequestMsg
     */
    KeyRangeLockingRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.KeyRangeLockingRequestMsg)
            return object;
        let message = new $root.KeyRangeLockingRequestMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "LOCK":
        case 1:
            message.type = 1;
            break;
        case "UNLOCK":
        case 2:
            message.type = 2;
            break;
        case "RENEW_LOCK":
        case 3:
            message.type = 3;
            break;
        case "LIST_LOCKED_RANGES":
        case 4:
            message.type = 4;
            break;
        }
        if (object.lock != null) {
            if (typeof object.lock !== "object")
                throw TypeError(".KeyRangeLockingRequestMsg.lock: object expected");
            message.lock = $root.LockMsg.fromObject(object.lock);
        }
        if (object.unlock != null) {
            if (typeof object.unlock !== "object")
                throw TypeError(".KeyRangeLockingRequestMsg.unlock: object expected");
            message.unlock = $root.UnlockMsg.fromObject(object.unlock);
        }
        if (object.renewLock != null) {
            if (typeof object.renewLock !== "object")
                throw TypeError(".KeyRangeLockingRequestMsg.renewLock: object expected");
            message.renewLock = $root.RenewLockMsg.fromObject(object.renewLock);
        }
        return message;
    };

    /**
     * Creates a plain object from a KeyRangeLockingRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {KeyRangeLockingRequestMsg} message KeyRangeLockingRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KeyRangeLockingRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "LOCK" : 1;
            object.lock = null;
            object.unlock = null;
            object.renewLock = null;
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.KeyRangeLockingRequestMsg.RequestType[message.type] === undefined ? message.type : $root.KeyRangeLockingRequestMsg.RequestType[message.type] : message.type;
        if (message.lock != null && message.hasOwnProperty("lock"))
            object.lock = $root.LockMsg.toObject(message.lock, options);
        if (message.unlock != null && message.hasOwnProperty("unlock"))
            object.unlock = $root.UnlockMsg.toObject(message.unlock, options);
        if (message.renewLock != null && message.hasOwnProperty("renewLock"))
            object.renewLock = $root.RenewLockMsg.toObject(message.renewLock, options);
        return object;
    };

    /**
     * Converts this KeyRangeLockingRequestMsg to JSON.
     * @function toJSON
     * @memberof KeyRangeLockingRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KeyRangeLockingRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KeyRangeLockingRequestMsg
     * @function getTypeUrl
     * @memberof KeyRangeLockingRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KeyRangeLockingRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KeyRangeLockingRequestMsg";
    };

    /**
     * RequestType enum.
     * @name KeyRangeLockingRequestMsg.RequestType
     * @enum {number}
     * @property {number} LOCK=1 LOCK value
     * @property {number} UNLOCK=2 UNLOCK value
     * @property {number} RENEW_LOCK=3 RENEW_LOCK value
     * @property {number} LIST_LOCKED_RANGES=4 LIST_LOCKED_RANGES value
     */
    KeyRangeLockingRequestMsg.RequestType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "LOCK"] = 1;
        values[valuesById[2] = "UNLOCK"] = 2;
        values[valuesById[3] = "RENEW_LOCK"] = 3;
        values[valuesById[4] = "LIST_LOCKED_RANGES"] = 4;
        return values;
    })();

    return KeyRangeLockingRequestMsg;
})();

export const LockOwner = $root.LockOwner = (() => {

    /**
     * Properties of a LockOwner.
     * @exports ILockOwner
     * @interface ILockOwner
     * @property {number|null} [nodeId] LockOwner nodeId
     * @property {Long|null} [lockId] LockOwner lockId
     */

    /**
     * Constructs a new LockOwner.
     * @exports LockOwner
     * @classdesc Represents a LockOwner.
     * @implements ILockOwner
     * @constructor
     * @param {ILockOwner=} [properties] Properties to set
     */
    function LockOwner(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LockOwner nodeId.
     * @member {number} nodeId
     * @memberof LockOwner
     * @instance
     */
    LockOwner.prototype.nodeId = 0;

    /**
     * LockOwner lockId.
     * @member {Long} lockId
     * @memberof LockOwner
     * @instance
     */
    LockOwner.prototype.lockId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new LockOwner instance using the specified properties.
     * @function create
     * @memberof LockOwner
     * @static
     * @param {ILockOwner=} [properties] Properties to set
     * @returns {LockOwner} LockOwner instance
     */
    LockOwner.create = function create(properties) {
        return new LockOwner(properties);
    };

    /**
     * Encodes the specified LockOwner message. Does not implicitly {@link LockOwner.verify|verify} messages.
     * @function encode
     * @memberof LockOwner
     * @static
     * @param {ILockOwner} message LockOwner message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LockOwner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.nodeId);
        if (message.lockId != null && Object.hasOwnProperty.call(message, "lockId"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.lockId);
        return writer;
    };

    /**
     * Decodes a LockOwner message from the specified reader or buffer.
     * @function decode
     * @memberof LockOwner
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LockOwner} LockOwner
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LockOwner.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockOwner();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.nodeId = reader.uint32();
                    break;
                }
            case 2: {
                    message.lockId = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a LockOwner message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LockOwner
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LockOwner} LockOwner
     */
    LockOwner.fromObject = function fromObject(object) {
        if (object instanceof $root.LockOwner)
            return object;
        let message = new $root.LockOwner();
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        if (object.lockId != null)
            if ($util.Long)
                (message.lockId = $util.Long.fromValue(object.lockId)).unsigned = true;
            else if (typeof object.lockId === "string")
                message.lockId = parseInt(object.lockId, 10);
            else if (typeof object.lockId === "number")
                message.lockId = object.lockId;
            else if (typeof object.lockId === "object")
                message.lockId = new $util.LongBits(object.lockId.low >>> 0, object.lockId.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a LockOwner message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LockOwner
     * @static
     * @param {LockOwner} message LockOwner
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LockOwner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.nodeId = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.lockId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.lockId = options.longs === String ? "0" : 0;
        }
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        if (message.lockId != null && message.hasOwnProperty("lockId"))
            if (typeof message.lockId === "number")
                object.lockId = options.longs === String ? String(message.lockId) : message.lockId;
            else
                object.lockId = options.longs === String ? $util.Long.prototype.toString.call(message.lockId) : options.longs === Number ? new $util.LongBits(message.lockId.low >>> 0, message.lockId.high >>> 0).toNumber(true) : message.lockId;
        return object;
    };

    /**
     * Converts this LockOwner to JSON.
     * @function toJSON
     * @memberof LockOwner
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LockOwner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LockOwner
     * @function getTypeUrl
     * @memberof LockOwner
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LockOwner.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LockOwner";
    };

    return LockOwner;
})();

export const LockRange = $root.LockRange = (() => {

    /**
     * Properties of a LockRange.
     * @exports ILockRange
     * @interface ILockRange
     * @property {ILockOwner|null} [lockOwner] LockRange lockOwner
     * @property {LockRange.LockType|null} [lockType] LockRange lockType
     * @property {Uint8Array|null} [startKey] LockRange startKey
     * @property {Uint8Array|null} [endKey] LockRange endKey
     * @property {Long|null} [retentionTimeInSec] LockRange retentionTimeInSec
     */

    /**
     * Constructs a new LockRange.
     * @exports LockRange
     * @classdesc Represents a LockRange.
     * @implements ILockRange
     * @constructor
     * @param {ILockRange=} [properties] Properties to set
     */
    function LockRange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LockRange lockOwner.
     * @member {ILockOwner|null|undefined} lockOwner
     * @memberof LockRange
     * @instance
     */
    LockRange.prototype.lockOwner = null;

    /**
     * LockRange lockType.
     * @member {LockRange.LockType} lockType
     * @memberof LockRange
     * @instance
     */
    LockRange.prototype.lockType = 1;

    /**
     * LockRange startKey.
     * @member {Uint8Array} startKey
     * @memberof LockRange
     * @instance
     */
    LockRange.prototype.startKey = $util.newBuffer([]);

    /**
     * LockRange endKey.
     * @member {Uint8Array} endKey
     * @memberof LockRange
     * @instance
     */
    LockRange.prototype.endKey = $util.newBuffer([]);

    /**
     * LockRange retentionTimeInSec.
     * @member {Long} retentionTimeInSec
     * @memberof LockRange
     * @instance
     */
    LockRange.prototype.retentionTimeInSec = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new LockRange instance using the specified properties.
     * @function create
     * @memberof LockRange
     * @static
     * @param {ILockRange=} [properties] Properties to set
     * @returns {LockRange} LockRange instance
     */
    LockRange.create = function create(properties) {
        return new LockRange(properties);
    };

    /**
     * Encodes the specified LockRange message. Does not implicitly {@link LockRange.verify|verify} messages.
     * @function encode
     * @memberof LockRange
     * @static
     * @param {ILockRange} message LockRange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LockRange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lockOwner != null && Object.hasOwnProperty.call(message, "lockOwner"))
            $root.LockOwner.encode(message.lockOwner, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.lockType != null && Object.hasOwnProperty.call(message, "lockType"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.lockType);
        if (message.startKey != null && Object.hasOwnProperty.call(message, "startKey"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.startKey);
        if (message.endKey != null && Object.hasOwnProperty.call(message, "endKey"))
            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.endKey);
        if (message.retentionTimeInSec != null && Object.hasOwnProperty.call(message, "retentionTimeInSec"))
            writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.retentionTimeInSec);
        return writer;
    };

    /**
     * Decodes a LockRange message from the specified reader or buffer.
     * @function decode
     * @memberof LockRange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LockRange} LockRange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LockRange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockRange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.lockOwner = $root.LockOwner.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.lockType = reader.int32();
                    break;
                }
            case 3: {
                    message.startKey = reader.bytes();
                    break;
                }
            case 4: {
                    message.endKey = reader.bytes();
                    break;
                }
            case 5: {
                    message.retentionTimeInSec = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a LockRange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LockRange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LockRange} LockRange
     */
    LockRange.fromObject = function fromObject(object) {
        if (object instanceof $root.LockRange)
            return object;
        let message = new $root.LockRange();
        if (object.lockOwner != null) {
            if (typeof object.lockOwner !== "object")
                throw TypeError(".LockRange.lockOwner: object expected");
            message.lockOwner = $root.LockOwner.fromObject(object.lockOwner);
        }
        switch (object.lockType) {
        default:
            if (typeof object.lockType === "number") {
                message.lockType = object.lockType;
                break;
            }
            break;
        case "NIL":
        case 1:
            message.lockType = 1;
            break;
        case "CONCURRENT_READ":
        case 2:
            message.lockType = 2;
            break;
        case "CONCURRENT_WRITE":
        case 3:
            message.lockType = 3;
            break;
        case "PROTECTED_READ":
        case 4:
            message.lockType = 4;
            break;
        case "PROTECTED_WRITE":
        case 5:
            message.lockType = 5;
            break;
        case "EXCLUSIVE":
        case 6:
            message.lockType = 6;
            break;
        }
        if (object.startKey != null)
            if (typeof object.startKey === "string")
                $util.base64.decode(object.startKey, message.startKey = $util.newBuffer($util.base64.length(object.startKey)), 0);
            else if (object.startKey.length >= 0)
                message.startKey = object.startKey;
        if (object.endKey != null)
            if (typeof object.endKey === "string")
                $util.base64.decode(object.endKey, message.endKey = $util.newBuffer($util.base64.length(object.endKey)), 0);
            else if (object.endKey.length >= 0)
                message.endKey = object.endKey;
        if (object.retentionTimeInSec != null)
            if ($util.Long)
                (message.retentionTimeInSec = $util.Long.fromValue(object.retentionTimeInSec)).unsigned = true;
            else if (typeof object.retentionTimeInSec === "string")
                message.retentionTimeInSec = parseInt(object.retentionTimeInSec, 10);
            else if (typeof object.retentionTimeInSec === "number")
                message.retentionTimeInSec = object.retentionTimeInSec;
            else if (typeof object.retentionTimeInSec === "object")
                message.retentionTimeInSec = new $util.LongBits(object.retentionTimeInSec.low >>> 0, object.retentionTimeInSec.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a LockRange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LockRange
     * @static
     * @param {LockRange} message LockRange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LockRange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.lockOwner = null;
            object.lockType = options.enums === String ? "NIL" : 1;
            if (options.bytes === String)
                object.startKey = "";
            else {
                object.startKey = [];
                if (options.bytes !== Array)
                    object.startKey = $util.newBuffer(object.startKey);
            }
            if (options.bytes === String)
                object.endKey = "";
            else {
                object.endKey = [];
                if (options.bytes !== Array)
                    object.endKey = $util.newBuffer(object.endKey);
            }
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.retentionTimeInSec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.retentionTimeInSec = options.longs === String ? "0" : 0;
        }
        if (message.lockOwner != null && message.hasOwnProperty("lockOwner"))
            object.lockOwner = $root.LockOwner.toObject(message.lockOwner, options);
        if (message.lockType != null && message.hasOwnProperty("lockType"))
            object.lockType = options.enums === String ? $root.LockRange.LockType[message.lockType] === undefined ? message.lockType : $root.LockRange.LockType[message.lockType] : message.lockType;
        if (message.startKey != null && message.hasOwnProperty("startKey"))
            object.startKey = options.bytes === String ? $util.base64.encode(message.startKey, 0, message.startKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.startKey) : message.startKey;
        if (message.endKey != null && message.hasOwnProperty("endKey"))
            object.endKey = options.bytes === String ? $util.base64.encode(message.endKey, 0, message.endKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.endKey) : message.endKey;
        if (message.retentionTimeInSec != null && message.hasOwnProperty("retentionTimeInSec"))
            if (typeof message.retentionTimeInSec === "number")
                object.retentionTimeInSec = options.longs === String ? String(message.retentionTimeInSec) : message.retentionTimeInSec;
            else
                object.retentionTimeInSec = options.longs === String ? $util.Long.prototype.toString.call(message.retentionTimeInSec) : options.longs === Number ? new $util.LongBits(message.retentionTimeInSec.low >>> 0, message.retentionTimeInSec.high >>> 0).toNumber(true) : message.retentionTimeInSec;
        return object;
    };

    /**
     * Converts this LockRange to JSON.
     * @function toJSON
     * @memberof LockRange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LockRange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LockRange
     * @function getTypeUrl
     * @memberof LockRange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LockRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LockRange";
    };

    /**
     * LockType enum.
     * @name LockRange.LockType
     * @enum {number}
     * @property {number} NIL=1 NIL value
     * @property {number} CONCURRENT_READ=2 CONCURRENT_READ value
     * @property {number} CONCURRENT_WRITE=3 CONCURRENT_WRITE value
     * @property {number} PROTECTED_READ=4 PROTECTED_READ value
     * @property {number} PROTECTED_WRITE=5 PROTECTED_WRITE value
     * @property {number} EXCLUSIVE=6 EXCLUSIVE value
     */
    LockRange.LockType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "NIL"] = 1;
        values[valuesById[2] = "CONCURRENT_READ"] = 2;
        values[valuesById[3] = "CONCURRENT_WRITE"] = 3;
        values[valuesById[4] = "PROTECTED_READ"] = 4;
        values[valuesById[5] = "PROTECTED_WRITE"] = 5;
        values[valuesById[6] = "EXCLUSIVE"] = 6;
        return values;
    })();

    return LockRange;
})();

export const LockMsg = $root.LockMsg = (() => {

    /**
     * Properties of a LockMsg.
     * @exports ILockMsg
     * @interface ILockMsg
     * @property {Array.<ILockRange>|null} [lockRange] LockMsg lockRange
     */

    /**
     * Constructs a new LockMsg.
     * @exports LockMsg
     * @classdesc Represents a LockMsg.
     * @implements ILockMsg
     * @constructor
     * @param {ILockMsg=} [properties] Properties to set
     */
    function LockMsg(properties) {
        this.lockRange = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LockMsg lockRange.
     * @member {Array.<ILockRange>} lockRange
     * @memberof LockMsg
     * @instance
     */
    LockMsg.prototype.lockRange = $util.emptyArray;

    /**
     * Creates a new LockMsg instance using the specified properties.
     * @function create
     * @memberof LockMsg
     * @static
     * @param {ILockMsg=} [properties] Properties to set
     * @returns {LockMsg} LockMsg instance
     */
    LockMsg.create = function create(properties) {
        return new LockMsg(properties);
    };

    /**
     * Encodes the specified LockMsg message. Does not implicitly {@link LockMsg.verify|verify} messages.
     * @function encode
     * @memberof LockMsg
     * @static
     * @param {ILockMsg} message LockMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LockMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lockRange != null && message.lockRange.length)
            for (let i = 0; i < message.lockRange.length; ++i)
                $root.LockRange.encode(message.lockRange[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a LockMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LockMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LockMsg} LockMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LockMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.lockRange && message.lockRange.length))
                        message.lockRange = [];
                    message.lockRange.push($root.LockRange.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a LockMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LockMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LockMsg} LockMsg
     */
    LockMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LockMsg)
            return object;
        let message = new $root.LockMsg();
        if (object.lockRange) {
            if (!Array.isArray(object.lockRange))
                throw TypeError(".LockMsg.lockRange: array expected");
            message.lockRange = [];
            for (let i = 0; i < object.lockRange.length; ++i) {
                if (typeof object.lockRange[i] !== "object")
                    throw TypeError(".LockMsg.lockRange: object expected");
                message.lockRange[i] = $root.LockRange.fromObject(object.lockRange[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a LockMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LockMsg
     * @static
     * @param {LockMsg} message LockMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LockMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.lockRange = [];
        if (message.lockRange && message.lockRange.length) {
            object.lockRange = [];
            for (let j = 0; j < message.lockRange.length; ++j)
                object.lockRange[j] = $root.LockRange.toObject(message.lockRange[j], options);
        }
        return object;
    };

    /**
     * Converts this LockMsg to JSON.
     * @function toJSON
     * @memberof LockMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LockMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LockMsg
     * @function getTypeUrl
     * @memberof LockMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LockMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LockMsg";
    };

    return LockMsg;
})();

export const UnlockRange = $root.UnlockRange = (() => {

    /**
     * Properties of an UnlockRange.
     * @exports IUnlockRange
     * @interface IUnlockRange
     * @property {ILockOwner|null} [lockOwner] UnlockRange lockOwner
     * @property {Uint8Array|null} [startKey] UnlockRange startKey
     * @property {Uint8Array|null} [endKey] UnlockRange endKey
     */

    /**
     * Constructs a new UnlockRange.
     * @exports UnlockRange
     * @classdesc Represents an UnlockRange.
     * @implements IUnlockRange
     * @constructor
     * @param {IUnlockRange=} [properties] Properties to set
     */
    function UnlockRange(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnlockRange lockOwner.
     * @member {ILockOwner|null|undefined} lockOwner
     * @memberof UnlockRange
     * @instance
     */
    UnlockRange.prototype.lockOwner = null;

    /**
     * UnlockRange startKey.
     * @member {Uint8Array} startKey
     * @memberof UnlockRange
     * @instance
     */
    UnlockRange.prototype.startKey = $util.newBuffer([]);

    /**
     * UnlockRange endKey.
     * @member {Uint8Array} endKey
     * @memberof UnlockRange
     * @instance
     */
    UnlockRange.prototype.endKey = $util.newBuffer([]);

    /**
     * Creates a new UnlockRange instance using the specified properties.
     * @function create
     * @memberof UnlockRange
     * @static
     * @param {IUnlockRange=} [properties] Properties to set
     * @returns {UnlockRange} UnlockRange instance
     */
    UnlockRange.create = function create(properties) {
        return new UnlockRange(properties);
    };

    /**
     * Encodes the specified UnlockRange message. Does not implicitly {@link UnlockRange.verify|verify} messages.
     * @function encode
     * @memberof UnlockRange
     * @static
     * @param {IUnlockRange} message UnlockRange message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnlockRange.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lockOwner != null && Object.hasOwnProperty.call(message, "lockOwner"))
            $root.LockOwner.encode(message.lockOwner, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.startKey != null && Object.hasOwnProperty.call(message, "startKey"))
            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.startKey);
        if (message.endKey != null && Object.hasOwnProperty.call(message, "endKey"))
            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.endKey);
        return writer;
    };

    /**
     * Decodes an UnlockRange message from the specified reader or buffer.
     * @function decode
     * @memberof UnlockRange
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnlockRange} UnlockRange
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnlockRange.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnlockRange();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.lockOwner = $root.LockOwner.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.startKey = reader.bytes();
                    break;
                }
            case 3: {
                    message.endKey = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates an UnlockRange message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnlockRange
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnlockRange} UnlockRange
     */
    UnlockRange.fromObject = function fromObject(object) {
        if (object instanceof $root.UnlockRange)
            return object;
        let message = new $root.UnlockRange();
        if (object.lockOwner != null) {
            if (typeof object.lockOwner !== "object")
                throw TypeError(".UnlockRange.lockOwner: object expected");
            message.lockOwner = $root.LockOwner.fromObject(object.lockOwner);
        }
        if (object.startKey != null)
            if (typeof object.startKey === "string")
                $util.base64.decode(object.startKey, message.startKey = $util.newBuffer($util.base64.length(object.startKey)), 0);
            else if (object.startKey.length >= 0)
                message.startKey = object.startKey;
        if (object.endKey != null)
            if (typeof object.endKey === "string")
                $util.base64.decode(object.endKey, message.endKey = $util.newBuffer($util.base64.length(object.endKey)), 0);
            else if (object.endKey.length >= 0)
                message.endKey = object.endKey;
        return message;
    };

    /**
     * Creates a plain object from an UnlockRange message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnlockRange
     * @static
     * @param {UnlockRange} message UnlockRange
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnlockRange.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.lockOwner = null;
            if (options.bytes === String)
                object.startKey = "";
            else {
                object.startKey = [];
                if (options.bytes !== Array)
                    object.startKey = $util.newBuffer(object.startKey);
            }
            if (options.bytes === String)
                object.endKey = "";
            else {
                object.endKey = [];
                if (options.bytes !== Array)
                    object.endKey = $util.newBuffer(object.endKey);
            }
        }
        if (message.lockOwner != null && message.hasOwnProperty("lockOwner"))
            object.lockOwner = $root.LockOwner.toObject(message.lockOwner, options);
        if (message.startKey != null && message.hasOwnProperty("startKey"))
            object.startKey = options.bytes === String ? $util.base64.encode(message.startKey, 0, message.startKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.startKey) : message.startKey;
        if (message.endKey != null && message.hasOwnProperty("endKey"))
            object.endKey = options.bytes === String ? $util.base64.encode(message.endKey, 0, message.endKey.length) : options.bytes === Array ? Array.prototype.slice.call(message.endKey) : message.endKey;
        return object;
    };

    /**
     * Converts this UnlockRange to JSON.
     * @function toJSON
     * @memberof UnlockRange
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnlockRange.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UnlockRange
     * @function getTypeUrl
     * @memberof UnlockRange
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UnlockRange.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UnlockRange";
    };

    return UnlockRange;
})();

export const UnlockMsg = $root.UnlockMsg = (() => {

    /**
     * Properties of an UnlockMsg.
     * @exports IUnlockMsg
     * @interface IUnlockMsg
     * @property {Array.<IUnlockRange>|null} [unlockRange] UnlockMsg unlockRange
     * @property {ILockOwner|null} [lockOwner] UnlockMsg lockOwner
     * @property {number|null} [nodeId] UnlockMsg nodeId
     */

    /**
     * Constructs a new UnlockMsg.
     * @exports UnlockMsg
     * @classdesc Represents an UnlockMsg.
     * @implements IUnlockMsg
     * @constructor
     * @param {IUnlockMsg=} [properties] Properties to set
     */
    function UnlockMsg(properties) {
        this.unlockRange = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * UnlockMsg unlockRange.
     * @member {Array.<IUnlockRange>} unlockRange
     * @memberof UnlockMsg
     * @instance
     */
    UnlockMsg.prototype.unlockRange = $util.emptyArray;

    /**
     * UnlockMsg lockOwner.
     * @member {ILockOwner|null|undefined} lockOwner
     * @memberof UnlockMsg
     * @instance
     */
    UnlockMsg.prototype.lockOwner = null;

    /**
     * UnlockMsg nodeId.
     * @member {number} nodeId
     * @memberof UnlockMsg
     * @instance
     */
    UnlockMsg.prototype.nodeId = 0;

    /**
     * Creates a new UnlockMsg instance using the specified properties.
     * @function create
     * @memberof UnlockMsg
     * @static
     * @param {IUnlockMsg=} [properties] Properties to set
     * @returns {UnlockMsg} UnlockMsg instance
     */
    UnlockMsg.create = function create(properties) {
        return new UnlockMsg(properties);
    };

    /**
     * Encodes the specified UnlockMsg message. Does not implicitly {@link UnlockMsg.verify|verify} messages.
     * @function encode
     * @memberof UnlockMsg
     * @static
     * @param {IUnlockMsg} message UnlockMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    UnlockMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.unlockRange != null && message.unlockRange.length)
            for (let i = 0; i < message.unlockRange.length; ++i)
                $root.UnlockRange.encode(message.unlockRange[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.lockOwner != null && Object.hasOwnProperty.call(message, "lockOwner"))
            $root.LockOwner.encode(message.lockOwner, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
            writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.nodeId);
        return writer;
    };

    /**
     * Decodes an UnlockMsg message from the specified reader or buffer.
     * @function decode
     * @memberof UnlockMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {UnlockMsg} UnlockMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    UnlockMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.UnlockMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.unlockRange && message.unlockRange.length))
                        message.unlockRange = [];
                    message.unlockRange.push($root.UnlockRange.decode(reader, reader.uint32()));
                    break;
                }
            case 2: {
                    message.lockOwner = $root.LockOwner.decode(reader, reader.uint32());
                    break;
                }
            case 3: {
                    message.nodeId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates an UnlockMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof UnlockMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {UnlockMsg} UnlockMsg
     */
    UnlockMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.UnlockMsg)
            return object;
        let message = new $root.UnlockMsg();
        if (object.unlockRange) {
            if (!Array.isArray(object.unlockRange))
                throw TypeError(".UnlockMsg.unlockRange: array expected");
            message.unlockRange = [];
            for (let i = 0; i < object.unlockRange.length; ++i) {
                if (typeof object.unlockRange[i] !== "object")
                    throw TypeError(".UnlockMsg.unlockRange: object expected");
                message.unlockRange[i] = $root.UnlockRange.fromObject(object.unlockRange[i]);
            }
        }
        if (object.lockOwner != null) {
            if (typeof object.lockOwner !== "object")
                throw TypeError(".UnlockMsg.lockOwner: object expected");
            message.lockOwner = $root.LockOwner.fromObject(object.lockOwner);
        }
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        return message;
    };

    /**
     * Creates a plain object from an UnlockMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof UnlockMsg
     * @static
     * @param {UnlockMsg} message UnlockMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    UnlockMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.unlockRange = [];
        if (options.defaults) {
            object.lockOwner = null;
            object.nodeId = 0;
        }
        if (message.unlockRange && message.unlockRange.length) {
            object.unlockRange = [];
            for (let j = 0; j < message.unlockRange.length; ++j)
                object.unlockRange[j] = $root.UnlockRange.toObject(message.unlockRange[j], options);
        }
        if (message.lockOwner != null && message.hasOwnProperty("lockOwner"))
            object.lockOwner = $root.LockOwner.toObject(message.lockOwner, options);
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        return object;
    };

    /**
     * Converts this UnlockMsg to JSON.
     * @function toJSON
     * @memberof UnlockMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    UnlockMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for UnlockMsg
     * @function getTypeUrl
     * @memberof UnlockMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    UnlockMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UnlockMsg";
    };

    return UnlockMsg;
})();

export const RenewLockMsg = $root.RenewLockMsg = (() => {

    /**
     * Properties of a RenewLockMsg.
     * @exports IRenewLockMsg
     * @interface IRenewLockMsg
     * @property {number|null} [nodeId] RenewLockMsg nodeId
     */

    /**
     * Constructs a new RenewLockMsg.
     * @exports RenewLockMsg
     * @classdesc Represents a RenewLockMsg.
     * @implements IRenewLockMsg
     * @constructor
     * @param {IRenewLockMsg=} [properties] Properties to set
     */
    function RenewLockMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * RenewLockMsg nodeId.
     * @member {number} nodeId
     * @memberof RenewLockMsg
     * @instance
     */
    RenewLockMsg.prototype.nodeId = 0;

    /**
     * Creates a new RenewLockMsg instance using the specified properties.
     * @function create
     * @memberof RenewLockMsg
     * @static
     * @param {IRenewLockMsg=} [properties] Properties to set
     * @returns {RenewLockMsg} RenewLockMsg instance
     */
    RenewLockMsg.create = function create(properties) {
        return new RenewLockMsg(properties);
    };

    /**
     * Encodes the specified RenewLockMsg message. Does not implicitly {@link RenewLockMsg.verify|verify} messages.
     * @function encode
     * @memberof RenewLockMsg
     * @static
     * @param {IRenewLockMsg} message RenewLockMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    RenewLockMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.nodeId != null && Object.hasOwnProperty.call(message, "nodeId"))
            writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.nodeId);
        return writer;
    };

    /**
     * Decodes a RenewLockMsg message from the specified reader or buffer.
     * @function decode
     * @memberof RenewLockMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {RenewLockMsg} RenewLockMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    RenewLockMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.RenewLockMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.nodeId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a RenewLockMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof RenewLockMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {RenewLockMsg} RenewLockMsg
     */
    RenewLockMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.RenewLockMsg)
            return object;
        let message = new $root.RenewLockMsg();
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a RenewLockMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof RenewLockMsg
     * @static
     * @param {RenewLockMsg} message RenewLockMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    RenewLockMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.nodeId = 0;
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        return object;
    };

    /**
     * Converts this RenewLockMsg to JSON.
     * @function toJSON
     * @memberof RenewLockMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    RenewLockMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for RenewLockMsg
     * @function getTypeUrl
     * @memberof RenewLockMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    RenewLockMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RenewLockMsg";
    };

    return RenewLockMsg;
})();

export const LockResponseMsg = $root.LockResponseMsg = (() => {

    /**
     * Properties of a LockResponseMsg.
     * @exports ILockResponseMsg
     * @interface ILockResponseMsg
     * @property {boolean|null} [success] LockResponseMsg success
     */

    /**
     * Constructs a new LockResponseMsg.
     * @exports LockResponseMsg
     * @classdesc Represents a LockResponseMsg.
     * @implements ILockResponseMsg
     * @constructor
     * @param {ILockResponseMsg=} [properties] Properties to set
     */
    function LockResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LockResponseMsg success.
     * @member {boolean} success
     * @memberof LockResponseMsg
     * @instance
     */
    LockResponseMsg.prototype.success = false;

    /**
     * Creates a new LockResponseMsg instance using the specified properties.
     * @function create
     * @memberof LockResponseMsg
     * @static
     * @param {ILockResponseMsg=} [properties] Properties to set
     * @returns {LockResponseMsg} LockResponseMsg instance
     */
    LockResponseMsg.create = function create(properties) {
        return new LockResponseMsg(properties);
    };

    /**
     * Encodes the specified LockResponseMsg message. Does not implicitly {@link LockResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof LockResponseMsg
     * @static
     * @param {ILockResponseMsg} message LockResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LockResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.success);
        return writer;
    };

    /**
     * Decodes a LockResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LockResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LockResponseMsg} LockResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LockResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.LockResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.success = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a LockResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LockResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LockResponseMsg} LockResponseMsg
     */
    LockResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LockResponseMsg)
            return object;
        let message = new $root.LockResponseMsg();
        if (object.success != null)
            message.success = Boolean(object.success);
        return message;
    };

    /**
     * Creates a plain object from a LockResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LockResponseMsg
     * @static
     * @param {LockResponseMsg} message LockResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LockResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            object.success = false;
        if (message.success != null && message.hasOwnProperty("success"))
            object.success = message.success;
        return object;
    };

    /**
     * Converts this LockResponseMsg to JSON.
     * @function toJSON
     * @memberof LockResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LockResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for LockResponseMsg
     * @function getTypeUrl
     * @memberof LockResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    LockResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/LockResponseMsg";
    };

    return LockResponseMsg;
})();

export const ListResponseMsg = $root.ListResponseMsg = (() => {

    /**
     * Properties of a ListResponseMsg.
     * @exports IListResponseMsg
     * @interface IListResponseMsg
     * @property {Array.<ILockRange>|null} [ranges] ListResponseMsg ranges
     */

    /**
     * Constructs a new ListResponseMsg.
     * @exports ListResponseMsg
     * @classdesc Represents a ListResponseMsg.
     * @implements IListResponseMsg
     * @constructor
     * @param {IListResponseMsg=} [properties] Properties to set
     */
    function ListResponseMsg(properties) {
        this.ranges = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ListResponseMsg ranges.
     * @member {Array.<ILockRange>} ranges
     * @memberof ListResponseMsg
     * @instance
     */
    ListResponseMsg.prototype.ranges = $util.emptyArray;

    /**
     * Creates a new ListResponseMsg instance using the specified properties.
     * @function create
     * @memberof ListResponseMsg
     * @static
     * @param {IListResponseMsg=} [properties] Properties to set
     * @returns {ListResponseMsg} ListResponseMsg instance
     */
    ListResponseMsg.create = function create(properties) {
        return new ListResponseMsg(properties);
    };

    /**
     * Encodes the specified ListResponseMsg message. Does not implicitly {@link ListResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof ListResponseMsg
     * @static
     * @param {IListResponseMsg} message ListResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ListResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ranges != null && message.ranges.length)
            for (let i = 0; i < message.ranges.length; ++i)
                $root.LockRange.encode(message.ranges[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a ListResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof ListResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ListResponseMsg} ListResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ListResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.ListResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.ranges && message.ranges.length))
                        message.ranges = [];
                    message.ranges.push($root.LockRange.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a ListResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ListResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ListResponseMsg} ListResponseMsg
     */
    ListResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.ListResponseMsg)
            return object;
        let message = new $root.ListResponseMsg();
        if (object.ranges) {
            if (!Array.isArray(object.ranges))
                throw TypeError(".ListResponseMsg.ranges: array expected");
            message.ranges = [];
            for (let i = 0; i < object.ranges.length; ++i) {
                if (typeof object.ranges[i] !== "object")
                    throw TypeError(".ListResponseMsg.ranges: object expected");
                message.ranges[i] = $root.LockRange.fromObject(object.ranges[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ListResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ListResponseMsg
     * @static
     * @param {ListResponseMsg} message ListResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ListResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.ranges = [];
        if (message.ranges && message.ranges.length) {
            object.ranges = [];
            for (let j = 0; j < message.ranges.length; ++j)
                object.ranges[j] = $root.LockRange.toObject(message.ranges[j], options);
        }
        return object;
    };

    /**
     * Converts this ListResponseMsg to JSON.
     * @function toJSON
     * @memberof ListResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ListResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for ListResponseMsg
     * @function getTypeUrl
     * @memberof ListResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    ListResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ListResponseMsg";
    };

    return ListResponseMsg;
})();

export const KeyRangeLockingResponseMsg = $root.KeyRangeLockingResponseMsg = (() => {

    /**
     * Properties of a KeyRangeLockingResponseMsg.
     * @exports IKeyRangeLockingResponseMsg
     * @interface IKeyRangeLockingResponseMsg
     * @property {ILockResponseMsg|null} [lockResponse] KeyRangeLockingResponseMsg lockResponse
     * @property {IListResponseMsg|null} [listResponse] KeyRangeLockingResponseMsg listResponse
     */

    /**
     * Constructs a new KeyRangeLockingResponseMsg.
     * @exports KeyRangeLockingResponseMsg
     * @classdesc Represents a KeyRangeLockingResponseMsg.
     * @implements IKeyRangeLockingResponseMsg
     * @constructor
     * @param {IKeyRangeLockingResponseMsg=} [properties] Properties to set
     */
    function KeyRangeLockingResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * KeyRangeLockingResponseMsg lockResponse.
     * @member {ILockResponseMsg|null|undefined} lockResponse
     * @memberof KeyRangeLockingResponseMsg
     * @instance
     */
    KeyRangeLockingResponseMsg.prototype.lockResponse = null;

    /**
     * KeyRangeLockingResponseMsg listResponse.
     * @member {IListResponseMsg|null|undefined} listResponse
     * @memberof KeyRangeLockingResponseMsg
     * @instance
     */
    KeyRangeLockingResponseMsg.prototype.listResponse = null;

    /**
     * Creates a new KeyRangeLockingResponseMsg instance using the specified properties.
     * @function create
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {IKeyRangeLockingResponseMsg=} [properties] Properties to set
     * @returns {KeyRangeLockingResponseMsg} KeyRangeLockingResponseMsg instance
     */
    KeyRangeLockingResponseMsg.create = function create(properties) {
        return new KeyRangeLockingResponseMsg(properties);
    };

    /**
     * Encodes the specified KeyRangeLockingResponseMsg message. Does not implicitly {@link KeyRangeLockingResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {IKeyRangeLockingResponseMsg} message KeyRangeLockingResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    KeyRangeLockingResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lockResponse != null && Object.hasOwnProperty.call(message, "lockResponse"))
            $root.LockResponseMsg.encode(message.lockResponse, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.listResponse != null && Object.hasOwnProperty.call(message, "listResponse"))
            $root.ListResponseMsg.encode(message.listResponse, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a KeyRangeLockingResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {KeyRangeLockingResponseMsg} KeyRangeLockingResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    KeyRangeLockingResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.KeyRangeLockingResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.lockResponse = $root.LockResponseMsg.decode(reader, reader.uint32());
                    break;
                }
            case 2: {
                    message.listResponse = $root.ListResponseMsg.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a KeyRangeLockingResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {KeyRangeLockingResponseMsg} KeyRangeLockingResponseMsg
     */
    KeyRangeLockingResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.KeyRangeLockingResponseMsg)
            return object;
        let message = new $root.KeyRangeLockingResponseMsg();
        if (object.lockResponse != null) {
            if (typeof object.lockResponse !== "object")
                throw TypeError(".KeyRangeLockingResponseMsg.lockResponse: object expected");
            message.lockResponse = $root.LockResponseMsg.fromObject(object.lockResponse);
        }
        if (object.listResponse != null) {
            if (typeof object.listResponse !== "object")
                throw TypeError(".KeyRangeLockingResponseMsg.listResponse: object expected");
            message.listResponse = $root.ListResponseMsg.fromObject(object.listResponse);
        }
        return message;
    };

    /**
     * Creates a plain object from a KeyRangeLockingResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {KeyRangeLockingResponseMsg} message KeyRangeLockingResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    KeyRangeLockingResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.lockResponse = null;
            object.listResponse = null;
        }
        if (message.lockResponse != null && message.hasOwnProperty("lockResponse"))
            object.lockResponse = $root.LockResponseMsg.toObject(message.lockResponse, options);
        if (message.listResponse != null && message.hasOwnProperty("listResponse"))
            object.listResponse = $root.ListResponseMsg.toObject(message.listResponse, options);
        return object;
    };

    /**
     * Converts this KeyRangeLockingResponseMsg to JSON.
     * @function toJSON
     * @memberof KeyRangeLockingResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    KeyRangeLockingResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for KeyRangeLockingResponseMsg
     * @function getTypeUrl
     * @memberof KeyRangeLockingResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    KeyRangeLockingResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KeyRangeLockingResponseMsg";
    };

    return KeyRangeLockingResponseMsg;
})();

export const SnapshotRequestMsg = $root.SnapshotRequestMsg = (() => {

    /**
     * Properties of a SnapshotRequestMsg.
     * @exports ISnapshotRequestMsg
     * @interface ISnapshotRequestMsg
     * @property {SnapshotRequestMsg.RequestType} type SnapshotRequestMsg type
     * @property {number|null} [snapshotId] SnapshotRequestMsg snapshotId
     * @property {string|null} [snapshotLabel] SnapshotRequestMsg snapshotLabel
     */

    /**
     * Constructs a new SnapshotRequestMsg.
     * @exports SnapshotRequestMsg
     * @classdesc Represents a SnapshotRequestMsg.
     * @implements ISnapshotRequestMsg
     * @constructor
     * @param {ISnapshotRequestMsg=} [properties] Properties to set
     */
    function SnapshotRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SnapshotRequestMsg type.
     * @member {SnapshotRequestMsg.RequestType} type
     * @memberof SnapshotRequestMsg
     * @instance
     */
    SnapshotRequestMsg.prototype.type = 1;

    /**
     * SnapshotRequestMsg snapshotId.
     * @member {number} snapshotId
     * @memberof SnapshotRequestMsg
     * @instance
     */
    SnapshotRequestMsg.prototype.snapshotId = 0;

    /**
     * SnapshotRequestMsg snapshotLabel.
     * @member {string} snapshotLabel
     * @memberof SnapshotRequestMsg
     * @instance
     */
    SnapshotRequestMsg.prototype.snapshotLabel = "";

    /**
     * Creates a new SnapshotRequestMsg instance using the specified properties.
     * @function create
     * @memberof SnapshotRequestMsg
     * @static
     * @param {ISnapshotRequestMsg=} [properties] Properties to set
     * @returns {SnapshotRequestMsg} SnapshotRequestMsg instance
     */
    SnapshotRequestMsg.create = function create(properties) {
        return new SnapshotRequestMsg(properties);
    };

    /**
     * Encodes the specified SnapshotRequestMsg message. Does not implicitly {@link SnapshotRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof SnapshotRequestMsg
     * @static
     * @param {ISnapshotRequestMsg} message SnapshotRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
        if (message.snapshotId != null && Object.hasOwnProperty.call(message, "snapshotId"))
            writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.snapshotId);
        if (message.snapshotLabel != null && Object.hasOwnProperty.call(message, "snapshotLabel"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.snapshotLabel);
        return writer;
    };

    /**
     * Decodes a SnapshotRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof SnapshotRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SnapshotRequestMsg} SnapshotRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SnapshotRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.int32();
                    break;
                }
            case 2: {
                    message.snapshotId = reader.uint32();
                    break;
                }
            case 3: {
                    message.snapshotLabel = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("type"))
            throw $util.ProtocolError("missing required 'type'", { instance: message });
        return message;
    };

    /**
     * Creates a SnapshotRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SnapshotRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SnapshotRequestMsg} SnapshotRequestMsg
     */
    SnapshotRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.SnapshotRequestMsg)
            return object;
        let message = new $root.SnapshotRequestMsg();
        switch (object.type) {
        default:
            if (typeof object.type === "number") {
                message.type = object.type;
                break;
            }
            break;
        case "CREATE_SNAPSHOT_REQUEST":
        case 1:
            message.type = 1;
            break;
        case "DELETE_SNAPSHOT_REQUEST":
        case 2:
            message.type = 2;
            break;
        case "LIST_SNAPSHOTS_REQUEST":
        case 3:
            message.type = 3;
            break;
        }
        if (object.snapshotId != null)
            message.snapshotId = object.snapshotId >>> 0;
        if (object.snapshotLabel != null)
            message.snapshotLabel = String(object.snapshotLabel);
        return message;
    };

    /**
     * Creates a plain object from a SnapshotRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SnapshotRequestMsg
     * @static
     * @param {SnapshotRequestMsg} message SnapshotRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SnapshotRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.type = options.enums === String ? "CREATE_SNAPSHOT_REQUEST" : 1;
            object.snapshotId = 0;
            object.snapshotLabel = "";
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = options.enums === String ? $root.SnapshotRequestMsg.RequestType[message.type] === undefined ? message.type : $root.SnapshotRequestMsg.RequestType[message.type] : message.type;
        if (message.snapshotId != null && message.hasOwnProperty("snapshotId"))
            object.snapshotId = message.snapshotId;
        if (message.snapshotLabel != null && message.hasOwnProperty("snapshotLabel"))
            object.snapshotLabel = message.snapshotLabel;
        return object;
    };

    /**
     * Converts this SnapshotRequestMsg to JSON.
     * @function toJSON
     * @memberof SnapshotRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SnapshotRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SnapshotRequestMsg
     * @function getTypeUrl
     * @memberof SnapshotRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SnapshotRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SnapshotRequestMsg";
    };

    /**
     * RequestType enum.
     * @name SnapshotRequestMsg.RequestType
     * @enum {number}
     * @property {number} CREATE_SNAPSHOT_REQUEST=1 CREATE_SNAPSHOT_REQUEST value
     * @property {number} DELETE_SNAPSHOT_REQUEST=2 DELETE_SNAPSHOT_REQUEST value
     * @property {number} LIST_SNAPSHOTS_REQUEST=3 LIST_SNAPSHOTS_REQUEST value
     */
    SnapshotRequestMsg.RequestType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[1] = "CREATE_SNAPSHOT_REQUEST"] = 1;
        values[valuesById[2] = "DELETE_SNAPSHOT_REQUEST"] = 2;
        values[valuesById[3] = "LIST_SNAPSHOTS_REQUEST"] = 3;
        return values;
    })();

    return SnapshotRequestMsg;
})();

export const SnapshotResponseMsg = $root.SnapshotResponseMsg = (() => {

    /**
     * Properties of a SnapshotResponseMsg.
     * @exports ISnapshotResponseMsg
     * @interface ISnapshotResponseMsg
     * @property {Array.<ISnapshotMsg>|null} [snapshots] SnapshotResponseMsg snapshots
     */

    /**
     * Constructs a new SnapshotResponseMsg.
     * @exports SnapshotResponseMsg
     * @classdesc Represents a SnapshotResponseMsg.
     * @implements ISnapshotResponseMsg
     * @constructor
     * @param {ISnapshotResponseMsg=} [properties] Properties to set
     */
    function SnapshotResponseMsg(properties) {
        this.snapshots = [];
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SnapshotResponseMsg snapshots.
     * @member {Array.<ISnapshotMsg>} snapshots
     * @memberof SnapshotResponseMsg
     * @instance
     */
    SnapshotResponseMsg.prototype.snapshots = $util.emptyArray;

    /**
     * Creates a new SnapshotResponseMsg instance using the specified properties.
     * @function create
     * @memberof SnapshotResponseMsg
     * @static
     * @param {ISnapshotResponseMsg=} [properties] Properties to set
     * @returns {SnapshotResponseMsg} SnapshotResponseMsg instance
     */
    SnapshotResponseMsg.create = function create(properties) {
        return new SnapshotResponseMsg(properties);
    };

    /**
     * Encodes the specified SnapshotResponseMsg message. Does not implicitly {@link SnapshotResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof SnapshotResponseMsg
     * @static
     * @param {ISnapshotResponseMsg} message SnapshotResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.snapshots != null && message.snapshots.length)
            for (let i = 0; i < message.snapshots.length; ++i)
                $root.SnapshotMsg.encode(message.snapshots[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Decodes a SnapshotResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof SnapshotResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SnapshotResponseMsg} SnapshotResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SnapshotResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.snapshots && message.snapshots.length))
                        message.snapshots = [];
                    message.snapshots.push($root.SnapshotMsg.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Creates a SnapshotResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SnapshotResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SnapshotResponseMsg} SnapshotResponseMsg
     */
    SnapshotResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.SnapshotResponseMsg)
            return object;
        let message = new $root.SnapshotResponseMsg();
        if (object.snapshots) {
            if (!Array.isArray(object.snapshots))
                throw TypeError(".SnapshotResponseMsg.snapshots: array expected");
            message.snapshots = [];
            for (let i = 0; i < object.snapshots.length; ++i) {
                if (typeof object.snapshots[i] !== "object")
                    throw TypeError(".SnapshotResponseMsg.snapshots: object expected");
                message.snapshots[i] = $root.SnapshotMsg.fromObject(object.snapshots[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a SnapshotResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SnapshotResponseMsg
     * @static
     * @param {SnapshotResponseMsg} message SnapshotResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SnapshotResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.arrays || options.defaults)
            object.snapshots = [];
        if (message.snapshots && message.snapshots.length) {
            object.snapshots = [];
            for (let j = 0; j < message.snapshots.length; ++j)
                object.snapshots[j] = $root.SnapshotMsg.toObject(message.snapshots[j], options);
        }
        return object;
    };

    /**
     * Converts this SnapshotResponseMsg to JSON.
     * @function toJSON
     * @memberof SnapshotResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SnapshotResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SnapshotResponseMsg
     * @function getTypeUrl
     * @memberof SnapshotResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SnapshotResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SnapshotResponseMsg";
    };

    return SnapshotResponseMsg;
})();

export const SnapshotMsg = $root.SnapshotMsg = (() => {

    /**
     * Properties of a SnapshotMsg.
     * @exports ISnapshotMsg
     * @interface ISnapshotMsg
     * @property {number} id SnapshotMsg id
     * @property {number} state SnapshotMsg state
     * @property {string} label SnapshotMsg label
     * @property {Uint8Array} version SnapshotMsg version
     * @property {Long} creationTime SnapshotMsg creationTime
     */

    /**
     * Constructs a new SnapshotMsg.
     * @exports SnapshotMsg
     * @classdesc Represents a SnapshotMsg.
     * @implements ISnapshotMsg
     * @constructor
     * @param {ISnapshotMsg=} [properties] Properties to set
     */
    function SnapshotMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SnapshotMsg id.
     * @member {number} id
     * @memberof SnapshotMsg
     * @instance
     */
    SnapshotMsg.prototype.id = 0;

    /**
     * SnapshotMsg state.
     * @member {number} state
     * @memberof SnapshotMsg
     * @instance
     */
    SnapshotMsg.prototype.state = 0;

    /**
     * SnapshotMsg label.
     * @member {string} label
     * @memberof SnapshotMsg
     * @instance
     */
    SnapshotMsg.prototype.label = "";

    /**
     * SnapshotMsg version.
     * @member {Uint8Array} version
     * @memberof SnapshotMsg
     * @instance
     */
    SnapshotMsg.prototype.version = $util.newBuffer([]);

    /**
     * SnapshotMsg creationTime.
     * @member {Long} creationTime
     * @memberof SnapshotMsg
     * @instance
     */
    SnapshotMsg.prototype.creationTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new SnapshotMsg instance using the specified properties.
     * @function create
     * @memberof SnapshotMsg
     * @static
     * @param {ISnapshotMsg=} [properties] Properties to set
     * @returns {SnapshotMsg} SnapshotMsg instance
     */
    SnapshotMsg.create = function create(properties) {
        return new SnapshotMsg(properties);
    };

    /**
     * Encodes the specified SnapshotMsg message. Does not implicitly {@link SnapshotMsg.verify|verify} messages.
     * @function encode
     * @memberof SnapshotMsg
     * @static
     * @param {ISnapshotMsg} message SnapshotMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SnapshotMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.id);
        writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.state);
        writer.uint32(/* id 3, wireType 2 =*/26).string(message.label);
        writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.version);
        writer.uint32(/* id 5, wireType 0 =*/40).uint64(message.creationTime);
        return writer;
    };

    /**
     * Decodes a SnapshotMsg message from the specified reader or buffer.
     * @function decode
     * @memberof SnapshotMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SnapshotMsg} SnapshotMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SnapshotMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.SnapshotMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.uint32();
                    break;
                }
            case 2: {
                    message.state = reader.uint32();
                    break;
                }
            case 3: {
                    message.label = reader.string();
                    break;
                }
            case 4: {
                    message.version = reader.bytes();
                    break;
                }
            case 5: {
                    message.creationTime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("id"))
            throw $util.ProtocolError("missing required 'id'", { instance: message });
        if (!message.hasOwnProperty("state"))
            throw $util.ProtocolError("missing required 'state'", { instance: message });
        if (!message.hasOwnProperty("label"))
            throw $util.ProtocolError("missing required 'label'", { instance: message });
        if (!message.hasOwnProperty("version"))
            throw $util.ProtocolError("missing required 'version'", { instance: message });
        if (!message.hasOwnProperty("creationTime"))
            throw $util.ProtocolError("missing required 'creationTime'", { instance: message });
        return message;
    };

    /**
     * Creates a SnapshotMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SnapshotMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SnapshotMsg} SnapshotMsg
     */
    SnapshotMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.SnapshotMsg)
            return object;
        let message = new $root.SnapshotMsg();
        if (object.id != null)
            message.id = object.id >>> 0;
        if (object.state != null)
            message.state = object.state >>> 0;
        if (object.label != null)
            message.label = String(object.label);
        if (object.version != null)
            if (typeof object.version === "string")
                $util.base64.decode(object.version, message.version = $util.newBuffer($util.base64.length(object.version)), 0);
            else if (object.version.length >= 0)
                message.version = object.version;
        if (object.creationTime != null)
            if ($util.Long)
                (message.creationTime = $util.Long.fromValue(object.creationTime)).unsigned = true;
            else if (typeof object.creationTime === "string")
                message.creationTime = parseInt(object.creationTime, 10);
            else if (typeof object.creationTime === "number")
                message.creationTime = object.creationTime;
            else if (typeof object.creationTime === "object")
                message.creationTime = new $util.LongBits(object.creationTime.low >>> 0, object.creationTime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a SnapshotMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SnapshotMsg
     * @static
     * @param {SnapshotMsg} message SnapshotMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SnapshotMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.id = 0;
            object.state = 0;
            object.label = "";
            if (options.bytes === String)
                object.version = "";
            else {
                object.version = [];
                if (options.bytes !== Array)
                    object.version = $util.newBuffer(object.version);
            }
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.creationTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.creationTime = options.longs === String ? "0" : 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.label != null && message.hasOwnProperty("label"))
            object.label = message.label;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = options.bytes === String ? $util.base64.encode(message.version, 0, message.version.length) : options.bytes === Array ? Array.prototype.slice.call(message.version) : message.version;
        if (message.creationTime != null && message.hasOwnProperty("creationTime"))
            if (typeof message.creationTime === "number")
                object.creationTime = options.longs === String ? String(message.creationTime) : message.creationTime;
            else
                object.creationTime = options.longs === String ? $util.Long.prototype.toString.call(message.creationTime) : options.longs === Number ? new $util.LongBits(message.creationTime.low >>> 0, message.creationTime.high >>> 0).toNumber(true) : message.creationTime;
        return object;
    };

    /**
     * Converts this SnapshotMsg to JSON.
     * @function toJSON
     * @memberof SnapshotMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SnapshotMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for SnapshotMsg
     * @function getTypeUrl
     * @memberof SnapshotMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    SnapshotMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SnapshotMsg";
    };

    return SnapshotMsg;
})();

export const TimeSyncRequestMsg = $root.TimeSyncRequestMsg = (() => {

    /**
     * Properties of a TimeSyncRequestMsg.
     * @exports ITimeSyncRequestMsg
     * @interface ITimeSyncRequestMsg
     * @property {number} nodeId TimeSyncRequestMsg nodeId
     * @property {Long} clientTime TimeSyncRequestMsg clientTime
     */

    /**
     * Constructs a new TimeSyncRequestMsg.
     * @exports TimeSyncRequestMsg
     * @classdesc Represents a TimeSyncRequestMsg.
     * @implements ITimeSyncRequestMsg
     * @constructor
     * @param {ITimeSyncRequestMsg=} [properties] Properties to set
     */
    function TimeSyncRequestMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TimeSyncRequestMsg nodeId.
     * @member {number} nodeId
     * @memberof TimeSyncRequestMsg
     * @instance
     */
    TimeSyncRequestMsg.prototype.nodeId = 0;

    /**
     * TimeSyncRequestMsg clientTime.
     * @member {Long} clientTime
     * @memberof TimeSyncRequestMsg
     * @instance
     */
    TimeSyncRequestMsg.prototype.clientTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new TimeSyncRequestMsg instance using the specified properties.
     * @function create
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {ITimeSyncRequestMsg=} [properties] Properties to set
     * @returns {TimeSyncRequestMsg} TimeSyncRequestMsg instance
     */
    TimeSyncRequestMsg.create = function create(properties) {
        return new TimeSyncRequestMsg(properties);
    };

    /**
     * Encodes the specified TimeSyncRequestMsg message. Does not implicitly {@link TimeSyncRequestMsg.verify|verify} messages.
     * @function encode
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {ITimeSyncRequestMsg} message TimeSyncRequestMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TimeSyncRequestMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.nodeId);
        writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.clientTime);
        return writer;
    };

    /**
     * Decodes a TimeSyncRequestMsg message from the specified reader or buffer.
     * @function decode
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TimeSyncRequestMsg} TimeSyncRequestMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TimeSyncRequestMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TimeSyncRequestMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.nodeId = reader.uint32();
                    break;
                }
            case 2: {
                    message.clientTime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("nodeId"))
            throw $util.ProtocolError("missing required 'nodeId'", { instance: message });
        if (!message.hasOwnProperty("clientTime"))
            throw $util.ProtocolError("missing required 'clientTime'", { instance: message });
        return message;
    };

    /**
     * Creates a TimeSyncRequestMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TimeSyncRequestMsg} TimeSyncRequestMsg
     */
    TimeSyncRequestMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.TimeSyncRequestMsg)
            return object;
        let message = new $root.TimeSyncRequestMsg();
        if (object.nodeId != null)
            message.nodeId = object.nodeId >>> 0;
        if (object.clientTime != null)
            if ($util.Long)
                (message.clientTime = $util.Long.fromValue(object.clientTime)).unsigned = true;
            else if (typeof object.clientTime === "string")
                message.clientTime = parseInt(object.clientTime, 10);
            else if (typeof object.clientTime === "number")
                message.clientTime = object.clientTime;
            else if (typeof object.clientTime === "object")
                message.clientTime = new $util.LongBits(object.clientTime.low >>> 0, object.clientTime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a TimeSyncRequestMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {TimeSyncRequestMsg} message TimeSyncRequestMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TimeSyncRequestMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults) {
            object.nodeId = 0;
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.clientTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.clientTime = options.longs === String ? "0" : 0;
        }
        if (message.nodeId != null && message.hasOwnProperty("nodeId"))
            object.nodeId = message.nodeId;
        if (message.clientTime != null && message.hasOwnProperty("clientTime"))
            if (typeof message.clientTime === "number")
                object.clientTime = options.longs === String ? String(message.clientTime) : message.clientTime;
            else
                object.clientTime = options.longs === String ? $util.Long.prototype.toString.call(message.clientTime) : options.longs === Number ? new $util.LongBits(message.clientTime.low >>> 0, message.clientTime.high >>> 0).toNumber(true) : message.clientTime;
        return object;
    };

    /**
     * Converts this TimeSyncRequestMsg to JSON.
     * @function toJSON
     * @memberof TimeSyncRequestMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TimeSyncRequestMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TimeSyncRequestMsg
     * @function getTypeUrl
     * @memberof TimeSyncRequestMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TimeSyncRequestMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TimeSyncRequestMsg";
    };

    return TimeSyncRequestMsg;
})();

export const TimeSyncResponseMsg = $root.TimeSyncResponseMsg = (() => {

    /**
     * Properties of a TimeSyncResponseMsg.
     * @exports ITimeSyncResponseMsg
     * @interface ITimeSyncResponseMsg
     * @property {Long} hubTime TimeSyncResponseMsg hubTime
     */

    /**
     * Constructs a new TimeSyncResponseMsg.
     * @exports TimeSyncResponseMsg
     * @classdesc Represents a TimeSyncResponseMsg.
     * @implements ITimeSyncResponseMsg
     * @constructor
     * @param {ITimeSyncResponseMsg=} [properties] Properties to set
     */
    function TimeSyncResponseMsg(properties) {
        if (properties)
            for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TimeSyncResponseMsg hubTime.
     * @member {Long} hubTime
     * @memberof TimeSyncResponseMsg
     * @instance
     */
    TimeSyncResponseMsg.prototype.hubTime = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

    /**
     * Creates a new TimeSyncResponseMsg instance using the specified properties.
     * @function create
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {ITimeSyncResponseMsg=} [properties] Properties to set
     * @returns {TimeSyncResponseMsg} TimeSyncResponseMsg instance
     */
    TimeSyncResponseMsg.create = function create(properties) {
        return new TimeSyncResponseMsg(properties);
    };

    /**
     * Encodes the specified TimeSyncResponseMsg message. Does not implicitly {@link TimeSyncResponseMsg.verify|verify} messages.
     * @function encode
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {ITimeSyncResponseMsg} message TimeSyncResponseMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TimeSyncResponseMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.hubTime);
        return writer;
    };

    /**
     * Decodes a TimeSyncResponseMsg message from the specified reader or buffer.
     * @function decode
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TimeSyncResponseMsg} TimeSyncResponseMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TimeSyncResponseMsg.decode = function decode(reader, length, error) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length, message = new $root.TimeSyncResponseMsg();
        while (reader.pos < end) {
            let tag = reader.uint32();
            if (tag === error)
                break;
            switch (tag >>> 3) {
            case 1: {
                    message.hubTime = reader.uint64();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("hubTime"))
            throw $util.ProtocolError("missing required 'hubTime'", { instance: message });
        return message;
    };

    /**
     * Creates a TimeSyncResponseMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TimeSyncResponseMsg} TimeSyncResponseMsg
     */
    TimeSyncResponseMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.TimeSyncResponseMsg)
            return object;
        let message = new $root.TimeSyncResponseMsg();
        if (object.hubTime != null)
            if ($util.Long)
                (message.hubTime = $util.Long.fromValue(object.hubTime)).unsigned = true;
            else if (typeof object.hubTime === "string")
                message.hubTime = parseInt(object.hubTime, 10);
            else if (typeof object.hubTime === "number")
                message.hubTime = object.hubTime;
            else if (typeof object.hubTime === "object")
                message.hubTime = new $util.LongBits(object.hubTime.low >>> 0, object.hubTime.high >>> 0).toNumber(true);
        return message;
    };

    /**
     * Creates a plain object from a TimeSyncResponseMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {TimeSyncResponseMsg} message TimeSyncResponseMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TimeSyncResponseMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        let object = {};
        if (options.defaults)
            if ($util.Long) {
                let long = new $util.Long(0, 0, true);
                object.hubTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.hubTime = options.longs === String ? "0" : 0;
        if (message.hubTime != null && message.hasOwnProperty("hubTime"))
            if (typeof message.hubTime === "number")
                object.hubTime = options.longs === String ? String(message.hubTime) : message.hubTime;
            else
                object.hubTime = options.longs === String ? $util.Long.prototype.toString.call(message.hubTime) : options.longs === Number ? new $util.LongBits(message.hubTime.low >>> 0, message.hubTime.high >>> 0).toNumber(true) : message.hubTime;
        return object;
    };

    /**
     * Converts this TimeSyncResponseMsg to JSON.
     * @function toJSON
     * @memberof TimeSyncResponseMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TimeSyncResponseMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for TimeSyncResponseMsg
     * @function getTypeUrl
     * @memberof TimeSyncResponseMsg
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    TimeSyncResponseMsg.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TimeSyncResponseMsg";
    };

    return TimeSyncResponseMsg;
})();

export { $root as default };
